import { useState, useEffect, useRef, useCallback } from "react";

const SQ_LOGO = "data:image/jpeg;base64,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";


// ─── FIREBASE CONFIG ───────────────────...

// ─── FIREBASE CONFIG ──────────────────────────────────────────────────────────
// ✅ SAFE: apiKey for Firebase Auth is safe to expose in client code.
// Security is enforced by Firebase Security Rules on the database,
// and by Firebase Authentication (only signed-in users can read/write).
const FIREBASE_CONFIG = {
  apiKey:            "AIzaSyDHfrAHgFyYpqOoX3RGs3SmP51_h84QuuE",
  authDomain:        "sq-amc.firebaseapp.com",
  databaseURL:       "https://sq-amc-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId:         "sq-amc",
  storageBucket:     "sq-amc.firebasestorage.app",
  messagingSenderId: "621775970529",
  appId:             "1:621775970529:web:f42c996242ffb8941057a0",
};
const FIREBASE_ENABLED = FIREBASE_CONFIG.apiKey !== "YOUR_API_KEY";

// ─── Brand ────────────────────────────────────────────────────────────────────
const T = {
  navy:"#1a237e",royal:"#1e3a8a",mid:"#1d4ed8",bright:"#2563eb",
  light:"#60a5fa",bg:"#0f1f5c",surface:"#162470",card:"#1a2b80",
  border:"#2d43a8",accent:"#60a5fa",accent2:"#34d399",warn:"#fbbf24",
  danger:"#f87171",text:"#e8f0fe",muted:"#93afd4",heading:"#ffffff",
  font:"'Outfit',sans-serif",mono:"'JetBrains Mono',monospace",
};
const T_DARK  = {...T};
const T_LIGHT = {
  navy:"#1a237e",royal:"#1e3a8a",mid:"#1d4ed8",bright:"#2563eb",
  light:"#2563eb",bg:"#f2f5fb",surface:"#ffffff",card:"#ffffff",
  border:"#dbe3f5",accent:"#1d4ed8",accent2:"#059669",warn:"#b45309",
  danger:"#dc2626",text:"#1e293b",muted:"#64748b",heading:"#0f172a",
  font:"'Outfit',sans-serif",mono:"'JetBrains Mono',monospace",
};
const applyTheme = mode => { Object.assign(T, mode==="light" ? T_LIGHT : T_DARK); };

const SEED_CUSTOMERS = [
  {id:"c1", name:"Altwesa Investment",           location:"Malaket",            capacity:"40,000 GPD",           docNo:"SQ-ROQ-0626-003",     amcStart:"2026-02-01",duration:"3 year",  amcEnd:"2029-02-01",emirate:"Abu Dhabi",lat:24.192,lng:55.763,contactNo:"",operatorName:"",address:"Malaket Area, Al Ain, Abu Dhabi"},
  {id:"c2", name:"Altwesa Investment",           location:"Zakher",             capacity:"60,000 GPD",           docNo:"SQ-ROQ-0626-003",     amcStart:"2026-02-01",duration:"3 year",  amcEnd:"2029-02-01",emirate:"Abu Dhabi",lat:24.155,lng:55.712,contactNo:"",operatorName:"",address:"Zakher, Al Ain, Abu Dhabi"},
  {id:"c3", name:"Altwesa Investment",           location:"Zakher",             capacity:"60,000 GPD",           docNo:"SQ-ROQ-0626-004",     amcStart:"2026-02-01",duration:"3 year",  amcEnd:"2029-02-01",emirate:"Abu Dhabi",lat:24.153,lng:55.714,contactNo:"",operatorName:"",address:"Zakher, Al Ain, Abu Dhabi"},
  {id:"c4", name:"Altwesa Investment",           location:"Zakher",             capacity:"60,000 GPD",           docNo:"SQ-ROQ-0626-005",     amcStart:"2026-02-01",duration:"3 year",  amcEnd:"2029-02-01",emirate:"Abu Dhabi",lat:24.151,lng:55.716,contactNo:"",operatorName:"",address:"Zakher, Al Ain, Abu Dhabi"},
  {id:"c5", name:"Altwesa Investment",           location:"Al Saad",            capacity:"80,000 GPD",           docNo:"SQ-ROQ-0626-002",     amcStart:"2026-02-01",duration:"3 year",  amcEnd:"2029-02-01",emirate:"Abu Dhabi",lat:24.206,lng:55.741,contactNo:"",operatorName:"",address:"Al Saad, Al Ain, Abu Dhabi"},
  {id:"c6", name:"Altwesa Investment",           location:"Al Saad",            capacity:"100,000 GPD",          docNo:"SQ-ROQ-0626-002",     amcStart:"2026-02-01",duration:"3 year",  amcEnd:"2029-02-01",emirate:"Abu Dhabi",lat:24.208,lng:55.743,contactNo:"",operatorName:"",address:"Al Saad, Al Ain, Abu Dhabi"},
  {id:"c7", name:"Abdualh Alhashmy",             location:"Al Khatem",          capacity:"20,000 GPD",           docNo:"SQ-ROQ-060-001",      amcStart:"2026-01-23",duration:"1 year",  amcEnd:"2027-01-23",emirate:"Abu Dhabi",lat:24.078,lng:55.485,contactNo:"",operatorName:"",address:"Al Khatem, Abu Dhabi"},
  {id:"c8", name:"Tristar RO1",                  location:"Al Khatem",          capacity:"80,000 GPD",           docNo:"SQ-ROM-0522-010",     amcStart:"2025-07-16",duration:"1 year",  amcEnd:"2026-07-16",emirate:"Abu Dhabi",lat:24.075,lng:55.483,contactNo:"",operatorName:"",address:"Al Khatem, Abu Dhabi"},
  {id:"c9", name:"Tristar RO2",                  location:"Al Khatem",          capacity:"80,000 GPD",           docNo:"SQ-ROM-0522-010",     amcStart:"2025-07-16",duration:"1 year",  amcEnd:"2026-07-16",emirate:"Abu Dhabi",lat:24.073,lng:55.481,contactNo:"",operatorName:"",address:"Al Khatem, Abu Dhabi"},
  {id:"c10",name:"Hamad Al Mazrouei",            location:"Al Khatem",          capacity:"20,000 GPD",           docNo:"SQ-ROM-0623-002",     amcStart:"2025-07-23",duration:"1 year",  amcEnd:"2026-07-23",emirate:"Abu Dhabi",lat:24.076,lng:55.487,contactNo:"",operatorName:"",address:"Al Khatem, Abu Dhabi"},
  {id:"c11",name:"Hameed Nasir Al Shamsi RO-1",  location:"Al Zahra Truck Road",capacity:"20,000 GPD",           docNo:"050-6128585",         amcStart:"2025-07-18",duration:"1 year",  amcEnd:"2026-07-18",emirate:"Abu Dhabi",lat:24.215,lng:55.798,contactNo:"050-6128585",operatorName:"",address:"Al Zahra Truck Road, Abu Dhabi"},
  {id:"c12",name:"Pure Harvest Smart Farms",     location:"Nahel, Al Ain",      capacity:"22,000 GPD",           docNo:"PO#PO21028922",       amcStart:"2025-08-28",duration:"1 year",  amcEnd:"2026-08-28",emirate:"Abu Dhabi",lat:24.312,lng:55.922,contactNo:"",operatorName:"",address:"Nahel, Al Ain, Abu Dhabi"},
  {id:"c13",name:"Philadelphia Agricultural",    location:"Ajban",              capacity:"40,000 GPD",           docNo:"",                    amcStart:"2025-03-21",duration:"1 year",  amcEnd:"2026-03-21",emirate:"Abu Dhabi",lat:24.523,lng:54.612,contactNo:"",operatorName:"",address:"Ajban, Abu Dhabi"},
  {id:"c14",name:"Saeed Khalfan Al Kabey",       location:"Al Bahya",           capacity:"",                    docNo:"",                    amcStart:"2025-04-05",duration:"1 year",  amcEnd:"2026-04-05",emirate:"Abu Dhabi",lat:24.488,lng:54.698,contactNo:"",operatorName:"",address:"Al Bahya, Abu Dhabi"},
  {id:"c15",name:"Hamd Jasim Al Darwesh Fakhro", location:"Rahbah",             capacity:"60,000 GPD",           docNo:"SQ-CRO 0519 002",    amcStart:"2025-04-03",duration:"3 year",  amcEnd:"2028-04-03",emirate:"Abu Dhabi",lat:24.352,lng:54.512,contactNo:"",operatorName:"",address:"Rahbah, Abu Dhabi"},
  {id:"c16",name:"Al Farah Contracting",         location:"Asab",               capacity:"100,000 GPD",          docNo:"ROM-0623 003",        amcStart:"2024-03-01",duration:"3 year",  amcEnd:"2027-03-01",emirate:"Abu Dhabi",lat:23.117,lng:53.775,contactNo:"",operatorName:"",address:"Asab, Abu Dhabi"},
  {id:"c17",name:"AL HADEEL Old",                location:"Liwa",               capacity:"20,000 GPD",           docNo:"",                    amcStart:"2025-09-25",duration:"1 year",  amcEnd:"2026-09-25",emirate:"Abu Dhabi",lat:23.129,lng:53.771,contactNo:"",operatorName:"",address:"Liwa, Abu Dhabi"},
  {id:"c18",name:"AL HADEEL New",                location:"Liwa",               capacity:"40,000 GPD TDS",       docNo:"",                    amcStart:"2025-01-17",duration:"1 year",  amcEnd:"2026-01-17",emirate:"Abu Dhabi",lat:23.127,lng:53.769,contactNo:"",operatorName:"",address:"Liwa, Abu Dhabi"},
  {id:"c19",name:"Nasir Al Harthy",              location:"Liwa",               capacity:"3 ROs",                docNo:"",                    amcStart:"2025-10-25",duration:"1 year",  amcEnd:"2026-10-25",emirate:"Abu Dhabi",lat:23.131,lng:53.773,contactNo:"",operatorName:"",address:"Liwa, Abu Dhabi"},
  {id:"c20",name:"Villa Sultan Al Habtoor",      location:"Dubai - Jumeirah",   capacity:"40,000 GPD",           docNo:"050-7169230",         amcStart:"2025-02-17",duration:"1 year",  amcEnd:"2026-02-17",emirate:"Dubai",    lat:25.186,lng:55.263,contactNo:"050-7169230",operatorName:"",address:"Jumeirah, Dubai"},
  {id:"c21",name:"Philadelphia Agricultural",    location:"Ajban",              capacity:"25,000 GPD",           docNo:"050 871 9131",        amcStart:"2025-05-20",duration:"1 year",  amcEnd:"2026-05-20",emirate:"Abu Dhabi",lat:24.525,lng:54.614,contactNo:"",operatorName:"",address:"Ajban, Abu Dhabi"},
  {id:"c22",name:"Philadelphia",                 location:"Dubai",              capacity:"",                    docNo:"",                    amcStart:"2025-09-15",duration:"6 Months",amcEnd:"2026-03-15",emirate:"Dubai",    lat:25.188,lng:55.265,contactNo:"",operatorName:"",address:"Dubai"},
  {id:"c23",name:"Qumra Transport",              location:"Unknown",            capacity:"",                    docNo:"",                    amcStart:"2025-03-05",duration:"1 year",  amcEnd:"2026-03-05",emirate:"Abu Dhabi",lat:24.183,lng:55.752,contactNo:"",operatorName:"",address:""},
  {id:"c24",name:"Philadelphia Agricultural",    location:"Ajban",              capacity:"40,000 GPD",           docNo:"",                   amcStart:"2025-02-28",duration:"1 year",  amcEnd:"2026-02-28",emirate:"Abu Dhabi",lat:24.527,lng:54.616,contactNo:"",operatorName:"",address:"Ajban, Abu Dhabi"},
  {id:"c25",name:"Emirates Dairy Farm",          location:"Al Ain",             capacity:"50,000 GPD",           docNo:"SQ-ROM-0623-007",    amcStart:"2025-04-04",duration:"1 year",  amcEnd:"2026-04-04",emirate:"Abu Dhabi",lat:24.223,lng:55.831,contactNo:"",operatorName:"",address:"Al Ain, Abu Dhabi"},
  {id:"c26",name:"Blue Gulf",                    location:"Unknown",            capacity:"",                    docNo:"",                    amcStart:"",          duration:"Rental",  amcEnd:"",          emirate:"Dubai",    lat:25.192,lng:55.271,contactNo:"",operatorName:"",address:"Dubai"},
  {id:"c27",name:"Zakiya",                       location:"Liwa",               capacity:"60,000 GPD",           docNo:"",                   amcStart:"",          duration:"1 year",  amcEnd:"",          emirate:"Abu Dhabi",lat:23.133,lng:53.775,contactNo:"",operatorName:"",address:"Liwa, Abu Dhabi"},
  {id:"c28",name:"Al Ain Palace (Sheikha Moza)", location:"Al Ain",             capacity:"130,000 GPD",          docNo:"SQ-25-09",           amcStart:"",          duration:"1 year",  amcEnd:"",          emirate:"Abu Dhabi",lat:24.228,lng:55.837,contactNo:"",operatorName:"",address:"Al Ain, Abu Dhabi"},
  {id:"c29",name:"Mohamed Al Ketby",             location:"Nahil",              capacity:"80,000 GPD",           docNo:"SQ-25-08",           amcStart:"",          duration:"1 year",  amcEnd:"",          emirate:"Abu Dhabi",lat:24.318,lng:55.928,contactNo:"",operatorName:"",address:"Nahil, Abu Dhabi"},
  {id:"c30",name:"Agri Tech Agricultural LLC",   location:"Nahil",              capacity:"80,000 GPD",           docNo:"AG-PO-2024-10-00140",amcStart:"2025-11-14",duration:"1 year",  amcEnd:"2026-11-14",emirate:"Abu Dhabi",lat:24.316,lng:55.926,contactNo:"",operatorName:"",address:"Nahil, Abu Dhabi"},
];

const EMIRATES = ["Abu Dhabi","Dubai","Sharjah","Ajman","Umm Al Quwain","Ras Al Khaimah","Fujairah"];
const SEED_SMALL_RO = [];
const APP_VERSION = "2026.10.22-b";   // shown in Settings so you can confirm every device has updated

const READINGS_META = [
  {key:"P1", label:"P1", desc:"Before MMF (PSI)"},
  {key:"P2", label:"P2", desc:"Cartridge Filter (PSI)"},
  {key:"P3", label:"P3", desc:"Before HP (PSI)"},
  {key:"P4", label:"P4", desc:"After HP (PSI)"},
  {key:"P5", label:"P5", desc:"After Membrane"},
  {key:"TDS",label:"TDS",desc:"Total Dissolved Solids"},
  {key:"pH1",label:"pH1",desc:"Inlet Source Water"},
  {key:"pH2",label:"pH2",desc:"Outlet Product Water"},
  {key:"DT1",label:"DT1",desc:"Dosing Tank H₂SO₄"},
  {key:"DT2",label:"DT2",desc:"Antiscalant"},
  {key:"DT3",label:"DT3",desc:"Dosing Tank NaOH"},
  {key:"DT4",label:"DT4",desc:"Dosing Tank Chloride"},
  {key:"FM1",label:"FM1",desc:"Flow Meter Production (GPM)"},
  {key:"FM2",label:"FM2",desc:"Flow Meter Rejection (GPM)"},
];


// Users are managed in Firebase Authentication — no passwords in code




// ─── Firebase Auth & DB ───────────────────────────────────────────────────────
// Passwords stored in FIREBASE only — nothing in source code
let _db   = null;
let _auth = null;

const fbInit = async () => {
  if(!FIREBASE_ENABLED) return false;
  try {
    const {initializeApp, getApps} = await import("https://www.gstatic.com/firebasejs/10.8.0/firebase-app.js");
    const {getDatabase, ref, set, onValue, get} = await import("https://www.gstatic.com/firebasejs/10.8.0/firebase-database.js");
    const {getAuth, signInWithEmailAndPassword, signOut, onAuthStateChanged} = await import("https://www.gstatic.com/firebasejs/10.8.0/firebase-auth.js");

    if(!getApps().length) initializeApp(FIREBASE_CONFIG);
    _db   = getDatabase();
    _auth = getAuth();

    // Expose to global for use in helpers
    window._fbRef = ref; window._fbSet = set;
    window._fbOnValue = onValue; window._fbGet = get;
    window._fbSignIn  = signInWithEmailAndPassword;
    window._fbSignOut = signOut;
    window._fbOnAuth  = onAuthStateChanged;
    window._fbAuth    = _auth;
    return true;
  } catch(e) { console.warn("Firebase init error:", e); return false; }
};

// ── Auth functions ──────────────────────────────────────────────────────────
const fbSignIn = async (email, password) => {
  try {
    const cred = await window._fbSignIn(window._fbAuth, email, password);
    return { ok: true, uid: cred.user.uid, email: cred.user.email };
  } catch(e) {
    const msg = e.code === "auth/invalid-credential" || e.code === "auth/wrong-password" || e.code === "auth/user-not-found"
      ? "Incorrect email or password"
      : e.code === "auth/too-many-requests"
      ? "Too many attempts. Account temporarily locked. Try again later."
      : "Login failed. Please try again.";
    return { ok: false, error: msg };
  }
};

const fbSignOut = async () => {
  try { await window._fbSignOut(window._fbAuth); } catch(e) { console.warn(e); }
};

// ── Read user profile from DB (role stored securely in DB, not in code) ──────
const fbGetProfile = async (uid) => {
  if(!_db) return null;
  try {
    const snap = await window._fbGet(window._fbRef(_db, `sq_users/${uid}`));
    return snap.exists() ? snap.val() : null;
  } catch { return null; }
};
const fbGetOnce = async (path) => {
  if(!_db) return null;
  try {
    const snap = await window._fbGet(window._fbRef(_db, path));
    return snap.exists() ? snap.val() : null;
  } catch { return null; }
};

// ── DB helpers ────────────────────────────────────────────────────────────────
const fbSet  = (path, val) => { if(!_db) return; try { window._fbSet(window._fbRef(_db, path), val); } catch(e) { console.warn(e); } };
const fbSetP = (path, val) => { if(!_db) return Promise.reject(new Error("offline")); try { return Promise.resolve(window._fbSet(window._fbRef(_db, path), val)); } catch(e) { return Promise.reject(e); } };
const fbListen = (path, cb) => { if(!_db) return ()=>{}; try { const r=window._fbRef(_db,path); return window._fbOnValue(r, s=>cb(s.exists()?s.val():null)); } catch { return ()=>{}; } };

const uid = () => `id_${Date.now()}_${Math.random().toString(36).slice(2,7)}`;
const todayStr = () => new Date().toISOString().split("T")[0];
const daysUntil = d => { if(!d) return null; return Math.ceil((new Date(d)-new Date())/86400000); };
const expiryBadge = end => {
  const d = daysUntil(end);
  if(d===null) return {label:"No Date",color:T.muted};
  if(d<0)      return {label:"EXPIRED",color:T.danger};
  if(d<=30)    return {label:`${d}d left`,color:T.danger};
  if(d<=90)    return {label:`${d}d left`,color:T.warn};
  return              {label:`${d}d left`,color:T.accent2};
};
// ─── Plant status / coverage / machines helpers ────────────────────────────
// status:   "active" (default) | "inactive" (customer did not renew)
// coverage: "amc" (default)    | "warranty" (1-year warranty, no AMC)
// machines: optional list of machines that share this one contract
const isInactive = c => !!c && c.status==="inactive";
const isWarranty = c => !!c && c.coverage==="warranty";
const isAMC      = c => !!c && !isInactive(c) && !isWarranty(c);   // plants the AMC expiry rules apply to
const machinesOf = c => (c && Array.isArray(c.machines)) ? c.machines.filter(m=>m&&m.id) : [];
const coverageEnd = c => isWarranty(c) ? c.warrantyEnd : c.amcEnd;
const warrantyBadge = c => {
  const d=daysUntil(c.warrantyEnd);
  if(d===null) return {label:"🛡 Warranty · no end date",color:T.accent};
  if(d<0)      return {label:`🛡 Warranty ended ${Math.abs(d)}d ago`,color:T.danger};
  if(d<=60)    return {label:`🛡 Warranty ends in ${d}d`,color:T.warn};
  return              {label:`🛡 Warranty · ${d}d left`,color:T.accent};
};
const machineSummary = c => machinesOf(c).map(m=>`${m.label||"Machine"}${m.capacity?` (${m.capacity})`:""}`).join(" · ");
const addDays = (dateStr,days) => { if(!dateStr) return null; const dt=new Date(dateStr); dt.setDate(dt.getDate()+days); return dt.toISOString().split("T")[0]; };
const nextVisitDue = c => c.lastVisitDate ? addDays(c.lastVisitDate,90) : (c.contractStart ? addDays(c.contractStart,90) : null);
const visitBadge = dueDate => {
  const d = daysUntil(dueDate);
  if(d===null) return {label:"No Visits Yet",color:T.muted};
  if(d<0)      return {label:`${Math.abs(d)}d OVERDUE`,color:T.danger};
  if(d<=14)    return {label:`Due in ${d}d`,color:T.warn};
  return              {label:`${d}d to visit`,color:T.accent2};
};
// Shrinks a photo to a JPEG data-URL. Rejects (instead of hanging or returning a blank image)
// when the file can't be read.
const compressImg = (file,maxW=800) => new Promise((resolve,reject)=>{
  const w = Number(maxW)>=200 ? Number(maxW) : 800;    // guard: a tiny/zero size (e.g. an array index passed by .map) must never produce a blank image
  if(!file) return reject(new Error("No photo selected"));
  const fr=new FileReader();
  fr.onerror=()=>reject(new Error("Could not read the photo. Please try again."));
  fr.onload=e=>{
    const img=new Image();
    img.onerror=()=>reject(new Error("This photo format could not be opened. Please use the camera, or a JPEG/PNG photo."));
    img.onload=()=>{
      try{
        const ratio=Math.min(w/img.width,w/img.height,1);
        const c=document.createElement("canvas");
        c.width=Math.max(1,Math.round(img.width*ratio)); c.height=Math.max(1,Math.round(img.height*ratio));
        c.getContext("2d").drawImage(img,0,0,c.width,c.height);
        const out=c.toDataURL("image/jpeg",0.72);
        if(!out||out.length<200) return reject(new Error("The photo came out empty. Please try again."));
        resolve(out);
      }catch(err){ reject(new Error("Could not process the photo. Please try again.")); }
    };
    img.src=e.target.result;
  };
  fr.readAsDataURL(file);
});
const local = {
  get: k=>{try{const v=localStorage.getItem(k);return v?JSON.parse(v):null;}catch{return null;}},
  set: (k,v)=>{try{localStorage.setItem(k,JSON.stringify(v));}catch{}},
  del: k=>{try{localStorage.removeItem(k);}catch{}},
};

// Export Excel/CSV
// Full data backup — downloads one JSON file with everything, to the user's device
const backupAllData = ({customers,reports,smallRO,smallROVisits,finance}) => {
  const payload = {
    exportedAt: new Date().toISOString(),
    app: "SQ AMC Manager",
    version: 2,
    customers,
    reports,
    smallRO,
    smallROVisits,
    finance: finance||[],
  };
  const blob = new Blob([JSON.stringify(payload, null, 2)], {type: "application/json"});
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `sq-amc-backup-${new Date().toISOString().split("T")[0]}.json`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

// Restore from a backup file. MERGE only: records in the file are added or replace the
// record with the same ID; nothing already in the app is deleted.
const parseBackup = (text) => {
  let data; try{ data=JSON.parse(text); }catch{ throw new Error("That file is not a valid backup (could not read it)."); }
  if(!data || typeof data!=="object" || data.app!=="SQ AMC Manager") throw new Error("That file is not an SQ AMC Manager backup.");
  const okId = id => typeof id==="string" && id.length>0 && id.length<120 && !/[.#$\[\]\/]/.test(id);
  const clean = arr => { const good=[]; let bad=0; (Array.isArray(arr)?arr:[]).forEach(x=>{ if(x && typeof x==="object" && !Array.isArray(x) && okId(x.id)) good.push(x); else bad++; }); return {good,bad}; };
  const out={ exportedAt:data.exportedAt, customers:clean(data.customers), reports:clean(data.reports), smallRO:clean(data.smallRO), smallROVisits:clean(data.smallROVisits), finance:clean(data.finance) };
  return out;
};
// Recycle bin: anything deleted is parked in sq_trash for 30 days.
const TRASH_DAYS = 30;
const trashLabel = e => { const it=e.item||{};
  switch(e.kind){
    case "c": return `Plant · ${it.name||"?"}`;
    case "r": return `Visit report · ${it.customerName||"?"} · ${it.date||""}`;
    case "s": return `Small RO contract · ${it.clientName||"?"}`;
    case "v": return `Small RO report · ${it.reportNo||"?"} · ${it.clientName||""}`;
    case "f": return `Payment plan · ${it.clientName||"?"}`;
    default:  return "Record";
  } };
const trashDaysLeft = e => Math.max(0, TRASH_DAYS - Math.floor((Date.now()-new Date(e.deletedAt||0).getTime())/86400000));
const mergeById = (prev, incoming) => { const m=new Map(prev.map(x=>[x.id,x])); incoming.forEach(x=>m.set(x.id,x)); return Array.from(m.values()); };

const exportExcel = customers => {
  const headers=["Plant Name","Site group","Location","Emirate","Capacity","Machines","Doc No","Coverage","Start","End","Duration","Status","Days Left","Contact","Address"];
  const rows=customers.map(c=>{
    const inact=isInactive(c), w=isWarranty(c), end=coverageEnd(c), d=daysUntil(end);
    const st=inact?"INACTIVE (not renewed)":w?(d===null?"Warranty":d<0?"Warranty ended":d<=60?"Warranty ending":"Under warranty"):(d===null?"No Date":d<0?"EXPIRED":d<=30?"Expiring Soon":d<=90?"Expiring":"Active");
    return[c.name,c.siteGroup||"",c.location,c.emirate,c.capacity,machineSummary(c),c.docNo,w?"Warranty (no AMC)":"AMC",w?c.warrantyStart:c.amcStart,end,w?"1 year warranty":c.duration,st,d===null?"":d,c.contactNo,c.address||""];
  });
  const csv=[headers,...rows].map(r=>r.map(v=>`"${String(v||"").replace(/"/g,'""')}"`).join(",")).join("\n");
  const a=document.createElement("a");a.href=URL.createObjectURL(new Blob([csv],{type:"text/csv"}));a.download=`SQ_Plants_${todayStr()}.csv`;a.click();
};

// Export Plants PDF
// ─── Safety + PDF helpers ───────────────────────────────────────────────────
// esc(): every user-typed value that goes into generated HTML must pass through this.
const esc = x => String(x??"").replace(/[&<>"']/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]));
const isValidPhoto = p => typeof p==="string" && /^data:image\/(jpeg|png|webp|gif);base64,/.test(p) && p.length>200;
const safeImg = x => (typeof x==="string" && /^data:image\/(jpeg|png|webp|gif);base64,[A-Za-z0-9+/=]+$/.test(x)) ? x : "";

const showToast = (msg, ms=0) => {
  let t=document.getElementById("sq-toast");
  if(!t){ t=document.createElement("div"); t.id="sq-toast";
    t.style.cssText="position:fixed;left:50%;bottom:96px;transform:translateX(-50%);background:#0f172a;color:#fff;padding:10px 16px;border-radius:10px;font:600 13px Outfit,sans-serif;z-index:5000;box-shadow:0 6px 24px #0007;max-width:90vw;text-align:center";
    document.body.appendChild(t); }
  t.textContent=msg; t.style.display="block"; clearTimeout(t._h);
  if(ms) t._h=setTimeout(()=>{t.style.display="none";},ms);
  return t;
};
const hideToast = () => { const t=document.getElementById("sq-toast"); if(t) t.style.display="none"; };

// Opens a report in a print window with a Print/Close bar that does not print.
const openPrintWindow = (html, w=820, h=960, autoPrint=false) => {
  const win=window.open("","_blank",`width=${w},height=${h}`);
  if(!win){ alert("Pop-up blocked — please allow pop-ups for this site to open the report."); return; }
  const bar=`<style>.noprint{display:flex;gap:8px;justify-content:flex-end;padding:10px 28px;background:#f3f4f8;border-bottom:1px solid #d6dbe8}@media print{.noprint{display:none!important}}</style>
  <div class="noprint">
    <button onclick="window.print()" style="background:#1a237e;color:#fff;border:none;border-radius:7px;padding:9px 16px;font-size:13px;font-weight:700;cursor:pointer">🖨 Print / Save PDF</button>
    <button onclick="window.close()" style="background:#e5e7eb;color:#1a237e;border:none;border-radius:7px;padding:9px 16px;font-size:13px;font-weight:700;cursor:pointer">✕ Close</button>
  </div>`;
  win.document.write(html.replace("<body>","<body>"+bar));
  win.document.close();
  if(autoPrint) setTimeout(()=>win.print(),700);
};

// Real PDF files: libraries are loaded on demand (only when someone shares a PDF).
const _scriptCache = {};
const loadScript = src => _scriptCache[src] || (_scriptCache[src] = new Promise((res,rej)=>{
  const s=document.createElement("script"); s.src=src; s.async=true;
  s.onload=()=>res(); s.onerror=()=>{ delete _scriptCache[src]; rej(new Error("Could not load PDF tools (check internet connection)")); };
  document.head.appendChild(s);
}));
const ensurePdfLibs = async () => {
  if(!window.html2canvas) await loadScript("https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js");
  if(!(window.jspdf && window.jspdf.jsPDF)) await loadScript("https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js");
};

// Renders report HTML in a hidden A4-width frame and slices it into A4 pages,
// breaking between rows/photos rather than through them.
const htmlToPdfBlob = async html => {
  await ensurePdfLibs();
  const frame=document.createElement("iframe");
  frame.style.cssText="position:fixed;left:-12000px;top:0;width:794px;height:1123px;border:0;opacity:0;pointer-events:none";
  document.body.appendChild(frame);
  try{
    await new Promise(res=>{ frame.onload=res; frame.srcdoc=html; });
    const doc=frame.contentDocument;
    await Promise.all(Array.from(doc.images).map(im=>im.complete?0:new Promise(r=>{im.onload=im.onerror=r;})));
    if(doc.fonts && doc.fonts.ready) await Promise.race([doc.fonts.ready,new Promise(r=>setTimeout(r,2500))]);
    const totalH=Math.ceil(doc.documentElement.scrollHeight);
    frame.style.height=totalH+"px";
    const breaks=Array.from(doc.querySelectorAll("tr,li,img,.sec,p,.sig-box,.hdr,.repline,.title,.intro,.rg,.ftr,.sum"))
      .map(el=>Math.round(el.getBoundingClientRect().bottom)).sort((a,b)=>a-b);
    const SCALE=2;
    const canvas=await window.html2canvas(doc.body,{scale:SCALE,backgroundColor:"#ffffff",useCORS:true,windowWidth:794,height:totalH});
    const {jsPDF}=window.jspdf;
    const pdf=new jsPDF({unit:"mm",format:"a4"});
    const PX_PER_MM=794/210, MARGIN=8, usableMM=297-MARGIN*2, pageHcss=usableMM*PX_PER_MM;
    let start=0, first=true;
    while(start<totalH-1){
      let end=start+pageHcss;
      if(end>=totalH) end=totalH;
      else { const c=breaks.filter(b=>b>start+pageHcss*0.45&&b<=end); if(c.length) end=c[c.length-1]; }
      const sy=Math.round(start*SCALE), sh=Math.max(1,Math.min(canvas.height-sy,Math.round((end-start)*SCALE)));
      const slice=document.createElement("canvas"); slice.width=canvas.width; slice.height=sh;
      const ctx=slice.getContext("2d"); ctx.fillStyle="#fff"; ctx.fillRect(0,0,slice.width,sh);
      ctx.drawImage(canvas,0,sy,canvas.width,sh,0,0,canvas.width,sh);
      if(!first) pdf.addPage();
      pdf.addImage(slice.toDataURL("image/jpeg",0.85),"JPEG",0,MARGIN,210,(sh/SCALE)/PX_PER_MM);
      first=false; start=end;
    }
    return pdf.output("blob");
  } finally { frame.remove(); }
};

// Share a real PDF file. Phones: native share sheet (WhatsApp, Email, Drive…).
// Desktop: downloads the PDF and opens WhatsApp/Email with the text summary.
const sharePDF = async ({html,filename,title,text,method,fallback}) => {
  showToast("Preparing PDF…");
  try{
    const blob=await htmlToPdfBlob(html);
    const file=new File([blob],filename,{type:"application/pdf"});
    if(navigator.canShare && navigator.canShare({files:[file]})){
      try{ await navigator.share({files:[file],title,text}); hideToast(); return; }
      catch(e){
        if(e&&e.name==="AbortError"){ hideToast(); return; }
        // Browser wants a fresh tap (long PDF creation can expire the original tap)
        await new Promise(res=>{
          const t=showToast(""); t.textContent="";
          const b=document.createElement("button"); b.textContent="📤 PDF ready — tap to share";
          b.style.cssText="background:#2563eb;color:#fff;border:none;border-radius:8px;padding:9px 14px;font:700 13px Outfit,sans-serif;cursor:pointer";
          b.onclick=async()=>{ hideToast(); try{ await navigator.share({files:[file],title,text}); }catch(_){} res(); };
          t.appendChild(b);
        });
        return;
      }
    }
    const url=URL.createObjectURL(blob);
    const a=document.createElement("a"); a.href=url; a.download=filename; document.body.appendChild(a); a.click(); a.remove();
    setTimeout(()=>URL.revokeObjectURL(url),5000);
    hideToast();
    const note=`${text}\n\n(PDF downloaded as ${filename} — please attach it to this message.)`;
    if(method==="email") window.open(`mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(note)}`,"_blank");
    else window.open(`https://wa.me/?text=${encodeURIComponent(note)}`,"_blank");
  }catch(e){
    hideToast();
    console.warn("PDF share failed",e);
    alert("Could not create the PDF file ("+(e&&e.message?e.message:"unknown error")+"). Sending the text summary instead.");
    fallback&&fallback();
  }
};
const fileSafe = s => String(s||"report").replace(/[^a-z0-9\-_.]+/gi,"_").replace(/^_+|_+$/g,"").slice(0,60)||"report";

const exportPlantsPDF = customers => {
  const amcList=customers.filter(isAMC), warrList=customers.filter(c=>!isInactive(c)&&isWarranty(c)), inactList=customers.filter(isInactive);
  const expired=amcList.filter(c=>{const d=daysUntil(c.amcEnd);return d!==null&&d<0;});
  const expiring=amcList.filter(c=>{const d=daysUntil(c.amcEnd);return d!==null&&d>=0&&d<=90;});
  const active=amcList.filter(c=>{const d=daysUntil(c.amcEnd);return d!==null&&d>90;});
  const noDate=amcList.filter(c=>!c.amcEnd);
  const wrows=list=>list.map((c,i)=>{const d=daysUntil(c.warrantyEnd);const col=d!==null&&d<0?"#dc2626":d!==null&&d<=60?"#d97706":"#1d4ed8";const t=d===null?"No Date":d<0?"ENDED":`${d}d left`;return`<tr><td>${i+1}</td><td><b>${esc(c.name)}</b></td><td>${esc(c.location)}</td><td>${esc(c.emirate)}</td><td>${esc(c.capacity)||"—"}</td><td>${esc(c.warrantyEnd)||"—"}</td><td style="color:${col};font-weight:700">🛡 ${t}</td></tr>`;}).join("");
  const irows=list=>list.map((c,i)=>`<tr><td>${i+1}</td><td><b>${esc(c.name)}</b></td><td>${esc(c.location)}</td><td>${esc(c.emirate)}</td><td>${esc(c.capacity)||"—"}</td><td>${esc(c.inactiveSince)||"—"}</td><td>${esc(c.inactiveReason)||"Not renewed"}</td></tr>`).join("");
  const badge=c=>{const d=daysUntil(c.amcEnd);if(d===null)return{t:"No Date",bg:"#e5e7eb",col:"#6b7280"};if(d<0)return{t:"EXPIRED",bg:"#fee2e2",col:"#dc2626"};if(d<=30)return{t:`${d}d left`,bg:"#fee2e2",col:"#dc2626"};if(d<=90)return{t:`${d}d left`,bg:"#fef3c7",col:"#d97706"};return{t:`${d}d left`,bg:"#d1fae5",col:"#059669"};};
  const trows=list=>list.map((c,i)=>{const b=badge(c);return`<tr><td>${i+1}</td><td><b>${esc(c.name)}</b></td><td>${esc(c.location)}</td><td>${esc(c.emirate)}</td><td>${esc(c.capacity)||"—"}</td><td>${esc(c.amcEnd)||"—"}</td><td><span style="background:${b.bg};color:${b.col};padding:2px 8px;border-radius:10px;font-weight:700;font-size:10px">${b.t}</span></td></tr>`;}).join("");
  const html=`<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Plants Report</title>
  <style>*{box-sizing:border-box;margin:0;padding:0}body{font-family:'Segoe UI',sans-serif;font-size:11px}
  .hdr{background:linear-gradient(135deg,#1a237e,#1d4ed8);color:#fff;padding:18px 26px}
  .lr{display:flex;align-items:center;gap:10px;margin-bottom:8px}
  .lc{width:36px;height:36px;background:#fff;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:17px}
  h1{font-size:15px;font-weight:700}h1 span{display:block;font-size:9px;opacity:.7;letter-spacing:2px;font-weight:400}
  .sum{display:flex;gap:10px;padding:12px 26px;background:#eff6ff;border-bottom:1px solid #dbeafe;flex-wrap:wrap}
  .sc{background:#fff;border:1px solid #dbeafe;border-radius:7px;padding:8px 14px;text-align:center;min-width:90px}
  .sc .n{font-size:20px;font-weight:800}.sc .l{font-size:9px;color:#6b7aa1;font-weight:600;letter-spacing:1px;text-transform:uppercase}
  .body{padding:12px 26px}
  .sec{font-size:10px;font-weight:700;color:#1d4ed8;letter-spacing:2px;text-transform:uppercase;border-bottom:2px solid #dbeafe;padding-bottom:3px;margin:12px 0 7px}
  table{width:100%;border-collapse:collapse;font-size:10px}
  th{background:#eff6ff;font-weight:700;color:#1a237e;padding:6px 7px;text-align:left;border:1px solid #dbeafe}
  td{padding:5px 7px;border:1px solid #dbeafe}tr:nth-child(even) td{background:#f8fbff}
  .ftr{background:#eff6ff;border-top:2px solid #dbeafe;padding:9px 26px;display:flex;justify-content:space-between;font-size:9px;color:#6b7aa1;margin-top:14px}</style></head><body>
  <div class=\"hdr\"><div class=\"lr\"><div class=\"lc\" style=\"overflow:hidden\"><img src=\"${SQ_LOGO}\" style=\"width:28px;height:28px;object-fit:contain\"/></div><h1>SUPER QUALITY<span>TRADING LLC. · superquality-est.com</span></h1></div>
  <div style="font-size:11px;opacity:.8">RO Plants AMC Report · ${new Date().toLocaleDateString("en-AE",{day:"numeric",month:"long",year:"numeric"})}</div></div>
  <div class="sum">
    <div class="sc"><div class="n" style="color:#1d4ed8">${amcList.length+warrList.length}</div><div class="l">Total (active)</div></div>
    <div class="sc"><div class="n" style="color:#059669">${active.length}</div><div class="l">Active</div></div>
    <div class="sc"><div class="n" style="color:#d97706">${expiring.length}</div><div class="l">Expiring ≤90d</div></div>
    <div class="sc"><div class="n" style="color:#dc2626">${expired.length}</div><div class="l">Expired</div></div>
    <div class="sc"><div class="n" style="color:#6b7280">${noDate.length}</div><div class="l">No Date</div></div>
    <div class="sc"><div class="n" style="color:#1d4ed8">${warrList.length}</div><div class="l">Warranty</div></div>
    <div class="sc"><div class="n" style="color:#6b7280">${inactList.length}</div><div class="l">Inactive</div></div>
  </div>
  <div class="body">
  ${expired.length?`<div class="sec">⚠ Expired (${expired.length})</div><table><tr><th>#</th><th>Plant</th><th>Location</th><th>Emirate</th><th>Capacity</th><th>AMC End</th><th>Status</th></tr>${trows(expired)}</table>`:""}
  ${expiring.length?`<div class="sec">⏳ Expiring ≤90 Days (${expiring.length})</div><table><tr><th>#</th><th>Plant</th><th>Location</th><th>Emirate</th><th>Capacity</th><th>AMC End</th><th>Status</th></tr>${trows(expiring)}</table>`:""}
  <div class="sec">All AMC Plants (${amcList.length})</div>
  <table><tr><th>#</th><th>Plant</th><th>Location</th><th>Emirate</th><th>Capacity</th><th>AMC End</th><th>Status</th></tr>${trows(amcList)}</table>
  ${warrList.length?`<div class="sec">🛡 Under Warranty — no AMC (${warrList.length})</div><table><tr><th>#</th><th>Plant</th><th>Location</th><th>Emirate</th><th>Capacity</th><th>Warranty End</th><th>Status</th></tr>${wrows(warrList)}</table>`:""}
  ${inactList.length?`<div class="sec">⏸ Inactive — not renewed (${inactList.length})</div><table><tr><th>#</th><th>Plant</th><th>Location</th><th>Emirate</th><th>Capacity</th><th>Since</th><th>Reason</th></tr>${irows(inactList)}</table>`:""}
  </div>
  <div class="ftr"><span>Super Quality Trading LLC</span><span>${customers.length} plants total</span><span>superquality-est.com</span></div>
  </body></html>`;
  openPrintWindow(html,1000,800,true);
};

// Export single visit report PDF
const buildReportHTML = report => {
  const rows=pairs=>pairs.map(([k,v])=>`<tr><th>${esc(k)}</th><td>${esc(v)||"—"}</td></tr>`).join("");
  const photos=(report.photos||[]).map(safeImg).filter(Boolean).map(p=>`<img src="${p}"/>`).join("");
  const sig=safeImg(report.signature);
  return `<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Visit Report</title>
  <style>@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;600;700&display=swap');
  *{box-sizing:border-box;margin:0;padding:0}body{font-family:'Outfit',sans-serif;color:#1a237e;font-size:12px}
  .hdr{background:linear-gradient(135deg,#1a237e,#1d4ed8 60%,#3b82f6);color:#fff;padding:20px 28px}
  .lr{display:flex;align-items:center;gap:10px;margin-bottom:10px}
  .lc{width:42px;height:42px;background:#fff;border-radius:50%;display:flex;align-items:center;justify-content:center;overflow:hidden}
  .lc img{width:30px;height:30px;object-fit:contain}
  .co{font-size:16px;font-weight:700}.co span{display:block;font-size:9px;opacity:.7;letter-spacing:2px}
  .body{padding:16px 28px}
  .sec{font-size:10px;font-weight:700;color:#1d4ed8;letter-spacing:2px;text-transform:uppercase;border-bottom:2px solid #dbeafe;padding-bottom:3px;margin:13px 0 7px}
  table{width:100%;border-collapse:collapse;margin-bottom:4px}
  td,th{border:1px solid #dbeafe;padding:5px 8px;font-size:11px}th{background:#eff6ff;font-weight:700;color:#1a237e;width:38%;text-align:left}
  .rg{display:grid;grid-template-columns:repeat(4,1fr);gap:4px;margin-bottom:4px}
  .rb{border:1px solid #dbeafe;border-radius:4px;padding:6px;text-align:center;background:#f8fbff}
  .rk{font-size:9px;font-weight:700;color:#1d4ed8}.rv{font-size:13px;font-weight:700;color:#1a237e;font-family:monospace}.rd{font-size:8px;color:#93afd4}
  .photos{display:flex;flex-wrap:wrap;gap:5px}.photos img{width:150px;height:100px;object-fit:cover;border-radius:4px;border:1px solid #dbeafe}
  .sig-box{border:2px solid #1a237e;border-radius:6px;padding:8px;display:inline-block;background:#fff}
  .sig-box img{max-width:220px;max-height:80px;display:block}
  .ftr{background:#eff6ff;border-top:2px solid #dbeafe;padding:10px 28px;display:flex;justify-content:space-between;font-size:9px;color:#6b7aa1;margin-top:14px}
  </style></head><body>
  <div class="hdr"><div class="lr"><div class="lc"><img src="${SQ_LOGO}" alt=""/></div><div><div class="co">SUPER QUALITY<span>TRADING LLC. · superquality-est.com</span></div></div></div>
  <div style="font-size:12px;opacity:.85">RO UNIT VISIT REPORT · ${esc(report.customerName)}${report.machineLabel?" — "+esc(report.machineLabel):""} · ${esc(report.date)}</div></div>
  <div class="body">
  <div class="sec">Plant Information</div>
  <table>${rows([["Plant/Doc No.",report.plantNo],["Client",report.customerName],...(report.machineLabel?[["Machine",report.machineLabel]]:[]),["Location",report.location],["Capacity",report.capacity],["AMC Valid",report.warrantyValid],["Operator",report.operatorName],["Technician",report.technicianName],["Contact",report.contactNo],["Visit Date",report.date],["Last Visit",report.lastVisitDate],["Next Visit",report.nextVisitDate]])}</table>
  <div class="sec">Membrane & Pumps</div>
  <table>${rows([["Membrane Name",report.membraneName],["Membrane Type",report.membraneType],["No. of Membranes",report.noOfMembrane],...(report.pumpTypes||[]).filter(Boolean).map((p,i)=>[`Pump ${i+1}`,p])])}</table>
  <div class="sec">Readings</div>
  <div class="rg">${READINGS_META.map(r=>`<div class="rb"><div class="rk">${esc(r.label)}</div><div class="rv">${esc(report.readings?.[r.key])||"—"}</div><div class="rd">${esc(r.desc)}</div></div>`).join("")}</div>
  <div class="sec">Water Samples</div>
  <table>${rows([["Well 1",report.wellSamples?.well1],["Well 2",report.wellSamples?.well2],["Well 3",report.wellSamples?.well3],["Well 4",report.wellSamples?.well4],["Product Water",report.productWater],["Reject Water",report.rejectWater]])}</table>
  ${report.remarks?`<div class="sec">Remarks</div><p style="border:1px solid #dbeafe;border-radius:4px;padding:7px;font-size:11px;background:#f8fbff">${esc(report.remarks)}</p>`:""}
  ${photos?`<div class="sec">Site Photos</div><div class="photos">${photos}</div>`:""}
  ${sig?`<div class="sec">Signature</div><div class="sig-box"><img src="${sig}"/></div>`:""}
  </div>
  <div class="ftr"><span>Generated: ${esc(new Date().toLocaleString())}</span><span>By: ${esc(report.submittedBy)}</span><span>superquality-est.com</span></div>
  </body></html>`;
};
const exportReportPDF = report => openPrintWindow(buildReportHTML(report));

// Share via WhatsApp / Email — attaches a real PDF file
const reportShareText = report => `*RO Visit Report — Super Quality Trading LLC*\n\n*Plant:* ${report.customerName}${report.machineLabel?" — "+report.machineLabel:""}\n*Location:* ${report.location}\n*Visit Date:* ${report.date}\n*Technician:* ${report.technicianName}\n*Operator:* ${report.operatorName||"—"}\n*Next Visit:* ${report.nextVisitDate||"—"}\n\n*Key Readings:*\n• TDS: ${report.readings?.TDS||"—"}\n• Product Water TDS: ${report.productWater||"—"}\n• Reject Water TDS: ${report.rejectWater||"—"}\n• FM1 Production: ${report.readings?.FM1||"—"} GPM\n• FM2 Rejection: ${report.readings?.FM2||"—"} GPM\n\n*Remarks:* ${report.remarks||"None"}\n\n_Submitted via Super Quality AMC Manager_`;
const shareReport = (report,method) => {
  const text=reportShareText(report);
  const title=`RO Visit Report — ${report.customerName} — ${report.date}`;
  const textOnly=()=>{
    if(method==="whatsapp") window.open(`https://wa.me/?text=${encodeURIComponent(text)}`,"_blank");
    else window.open(`mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(text)}`,"_blank");
  };
  return sharePDF({html:buildReportHTML(report),filename:`${fileSafe("Visit-Report-"+report.customerName+(report.machineLabel?"-"+report.machineLabel:"")+"-"+report.date)}.pdf`,title,text,method,fallback:textOnly});
};

// ─── Small RO Visit Report: numbering, PDF export, share ───────────────────
const nextSmallROReportNo = (visits) => {
  const prefix = `SQT-MR-${new Date().getFullYear()}-`;
  const max = (visits||[]).reduce((m,v)=>{
    if(!(v.reportNo||"").startsWith(prefix)) return m;
    const n = parseInt(v.reportNo.slice(prefix.length),10);
    return isNaN(n) ? m : Math.max(m,n);
  },0);
  return prefix + String(max+1).padStart(3,"0");
};

const buildSmallROVisitHTML = visit => {
  const rows=pairs=>pairs.map(([k,v])=>`<tr><th>${esc(k)}</th><td>${esc(v)||"—"}</td></tr>`).join("");
  const workItems=(visit.workItems||[]).filter(w=>w.text).map(w=>`<li>${esc(w.text)}${w.date?` (${esc(w.date)})`:""}</li>`).join("");
  const notes=(visit.notes||[]).filter(Boolean).map(n=>`<li>${esc(n)}</li>`).join("");
  const photos=(visit.photos||[]).map(safeImg).filter(Boolean).map(p=>`<img src="${p}"/>`).join("");
  const sig=safeImg(visit.signature);
  const repDate=new Date(visit.submittedAt||visit.date).toLocaleDateString("en-GB",{day:"numeric",month:"long",year:"numeric"});
  return `<!DOCTYPE html><html><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1"><title>${esc(visit.reportNo)} — Maintenance Work Report</title>
  <style>@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;600;700&display=swap');
  @page{size:A4;margin:12mm}
  *{box-sizing:border-box;margin:0;padding:0}body{font-family:'Outfit',Arial,sans-serif;color:#111827;font-size:12px;-webkit-print-color-adjust:exact;print-color-adjust:exact}
  .hdr{padding:18px 28px 14px;display:flex;justify-content:space-between;align-items:flex-start;gap:16px}
  .lr{display:flex;align-items:center;gap:10px}
  .lr img{height:56px;width:auto;object-fit:contain;display:block}
  .lt{line-height:1.05;color:#1a237e}.lt .a{font-size:20px;font-weight:400;letter-spacing:1px}.lt .b{font-size:22px;font-weight:700}.lt .c{font-size:8px;color:#6b7aa1}
  .meta{text-align:right;font-size:10px;color:#2a3f8f;line-height:1.5}
  .meta .nm{font-size:21px;font-weight:700;color:#1a3a8f;line-height:1.1;margin-bottom:3px}
  .repline{display:flex;justify-content:space-between;padding:10px 28px;font-size:11px;color:#6b7280}
  .title{text-align:center;font-size:20px;font-weight:700;color:#2a3f8f;margin:14px 0 16px}
  .body{padding:0 28px}
  .intro{font-size:12.5px;margin-bottom:14px;color:#111827;line-height:1.45}
  table{width:100%;border-collapse:collapse;margin-bottom:16px}
  td,th{border:1px solid #d6dbe8;padding:7px 11px;font-size:12px;text-align:left}th{font-weight:700;color:#111827;width:28%}
  .sec{font-size:12px;font-weight:700;color:#2a3f8f;margin:16px 0 6px;padding-bottom:3px;border-bottom:1px solid #d6dbe8}
  ol,ul{padding-left:24px;margin-bottom:10px}ul{list-style:none;padding-left:4px}ul li:before{content:"— ";color:#2a3f8f}
  li{font-size:12.5px;margin-bottom:6px}
  .photos{display:grid;grid-template-columns:repeat(3,1fr);gap:8px;margin-top:6px}
  .photos img{width:100%;height:150px;object-fit:cover;border:1px solid #d6dbe8;border-radius:4px;break-inside:avoid}
  .sig-box{margin-top:24px;break-inside:avoid}.sig-box img{max-width:220px;max-height:80px;display:block;margin-top:8px}
  .ftr{border-top:1px solid #d6dbe8;padding:10px 28px;display:flex;justify-content:space-between;font-size:9px;color:#6b7280;margin-top:22px}
  </style></head><body>
  <div class="hdr">
    <div class="lr"><img src="${SQ_LOGO}" alt="Super Quality"/><div class="lt"><div class="a">SUPER</div><div class="b">QUALITY</div><div class="c">Trading LLC.</div></div></div>
    <div class="meta"><div class="nm">Super Quality Trading</div>Office# 6 &amp; 7 Industrial Area Alain-UAE<br/>Tel.: +9713-7343413<br/>Email: sq@superquality-est.com<br/>Web.: www.superquality-est.com</div>
  </div>
  <div class="repline"><span>Report No: ${esc(visit.reportNo)}</span><span><b>Date:</b> ${esc(repDate)}</span></div>
  <div class="title">Maintenance Work Report</div>
  <div class="body">
  <p class="intro">We, Super Quality Trading, confirm that scheduled maintenance work has been completed and the system is operating in good condition.</p>
  <table>${rows([["Client",visit.clientName],["Plant Location",visit.plantLocation],["Contractor",visit.contractor],["Plant Capacity",visit.capacity],["Visit Date",visit.date],["Operation Manager",visit.operationManager]])}</table>
  <div class="sec">MAINTENANCE WORK COMPLETED</div>
  <ol>${workItems||"<li>—</li>"}</ol>
  <div class="sec">NOTES</div>
  <ul>${notes||"<li>—</li>"}</ul>
  ${photos?`<div class="sec">SITE PHOTOS</div><div class="photos">${photos}</div>`:""}
  <div class="sig-box"><b>Super Quality Trading S.P L.L.C</b>${sig?`<img src="${sig}"/>`:""}</div>
  </div>
  <div class="ftr"><span>Generated: ${esc(new Date().toLocaleString())}</span><span>By: ${esc(visit.submittedBy||"—")}</span><span>superquality-est.com</span></div>
  </body></html>`;
};
const exportSmallROVisitPDF = visit => openPrintWindow(buildSmallROVisitHTML(visit));

const smallROShareText = visit => {
  const items=(visit.workItems||[]).filter(w=>w.text).map(w=>`• ${w.text}${w.date?` (${w.date})`:""}`).join("\n");
  return `*Maintenance Work Report — Super Quality Trading*\n\n*Report No:* ${visit.reportNo}\n*Client:* ${visit.clientName}\n*Location:* ${visit.plantLocation}\n*Visit Date:* ${visit.date}\n*Operation Manager:* ${visit.operationManager||"—"}\n\n*Work Completed:*\n${items||"—"}\n\n_Submitted via Super Quality AMC Manager_`;
};
const shareSmallROVisit = (visit,method) => {
  const text=smallROShareText(visit);
  const title=`Maintenance Report — ${visit.clientName} — ${visit.date}`;
  const textOnly=()=>{
    if(method==="whatsapp") window.open(`https://wa.me/?text=${encodeURIComponent(text)}`,"_blank");
    else window.open(`mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(text)}`,"_blank");
  };
  return sharePDF({html:buildSmallROVisitHTML(visit),filename:`${fileSafe(visit.reportNo)}.pdf`,title,text,method,fallback:textOnly});
};

const injectCSS = () => {
  let s=document.getElementById("sq-css4");
  if(!s){ s=document.createElement("style"); s.id="sq-css4"; document.head.appendChild(s); }
  let vp=document.querySelector('meta[name="viewport"]');
  if(!vp){ vp=document.createElement("meta"); vp.name="viewport"; vp.content="width=device-width, initial-scale=1"; document.head.appendChild(vp); }
  if(!/viewport-fit/.test(vp.content)) vp.content+=", viewport-fit=cover";
  s.textContent=`
    @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;600&display=swap');
    *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
    html,body,#root{height:100%;font-family:'Outfit',sans-serif;background:${T.bg};color:${T.text};-webkit-font-smoothing:antialiased}
    .shell{display:flex;flex-direction:column;min-height:100vh;min-height:100dvh;max-width:1280px;margin:0 auto}
    .tbar{padding:11px 20px;display:flex;align-items:center;justify-content:space-between;background:${T.navy};border-bottom:1px solid ${T.border};position:sticky;top:0;z-index:50;flex-shrink:0}
    .sidebar{width:210px;background:${T.navy};border-right:1px solid ${T.border};display:none;flex-direction:column;padding:16px 10px;gap:3px;flex-shrink:0;position:sticky;top:53px;height:calc(100vh - 53px);overflow-y:auto}
    @media(min-width:768px){.sidebar{display:flex!important}}
    .sitem{display:flex;align-items:center;gap:10px;padding:10px 13px;border-radius:10px;font-size:13px;font-weight:600;color:${T.muted};cursor:pointer;border:none;background:none;font-family:'Outfit',sans-serif;width:100%;text-align:left;transition:all .18s}
    .sitem:hover{background:${T.surface};color:${T.text}}
    .sitem.on{background:linear-gradient(135deg,${T.mid}33,${T.bright}22);color:#fff;border:1px solid ${T.border}}
    .sitem svg{width:17px;height:17px;flex-shrink:0}
    .pg{padding:20px;padding-bottom:calc(104px + env(safe-area-inset-bottom,0px))}
    @media(min-width:768px){.pg{padding:24px;padding-bottom:28px}}
    @media(min-width:1024px){.pg{padding:28px 36px}}
    .bnav{position:fixed;bottom:0;left:0;right:0;background:${T.navy};border-top:1px solid ${T.border};display:flex;z-index:99;padding-bottom:env(safe-area-inset-bottom,0px);transform:translateZ(0);-webkit-transform:translateZ(0);box-shadow:0 -4px 18px rgba(0,0,0,.28)}
    @media(min-width:768px){.bnav{display:none}}
    .nb{flex:1;display:flex;flex-direction:column;align-items:center;gap:2px;justify-content:center;min-height:62px;padding:8px 2px 7px;font-size:10.5px;font-weight:600;color:${T.muted};background:none;border:none;cursor:pointer;font-family:'Outfit',sans-serif;transition:color .18s,background .18s;position:relative;touch-action:manipulation;-webkit-tap-highlight-color:transparent}
    .nb:active{background:rgba(255,255,255,.10)}
    .bnav.many .nb{font-size:9.5px;padding-left:0;padding-right:0;min-width:0}
    .bnav.many .nb svg{width:22px;height:22px}
    .nb.on{color:#fff}
    .nb.on::before{content:'';position:absolute;top:0;left:22%;right:22%;height:2px;background:linear-gradient(90deg,${T.mid},${T.light});border-radius:0 0 3px 3px}
    .nb svg{width:23px;height:23px}
    .g2{display:grid;grid-template-columns:1fr 1fr;gap:14px}
    .g4{display:grid;grid-template-columns:repeat(4,1fr);gap:8px}
    .stat-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:12px}
    @media(min-width:640px){.stat-grid{grid-template-columns:repeat(4,1fr)}}
    @media(max-width:480px){.g2{grid-template-columns:1fr}.g4{grid-template-columns:repeat(2,1fr)}}
    .card{background:${T.card};border:1px solid ${T.border};border-radius:14px;padding:18px}
    .card-glass{background:rgba(26,43,128,0.75);backdrop-filter:blur(14px);border:1px solid rgba(255,255,255,0.13);border-radius:16px;padding:22px}
    .cc{background:${T.card};border:1.5px solid ${T.border};border-radius:13px;padding:14px;margin-bottom:10px;transition:all .2s}
    .cc:hover{border-color:${T.accent}55;box-shadow:0 4px 18px #00000028}
    input,select,textarea{background:${T.surface};color:${T.text};border:1.5px solid ${T.border};border-radius:9px;padding:9px 13px;font-family:'Outfit',sans-serif;font-size:14px;width:100%;outline:none;transition:all .2s}
    input:focus,select:focus,textarea:focus{border-color:${T.accent};box-shadow:0 0 0 3px ${T.accent}1a}
    input::placeholder{color:${T.muted}}
    select option{background:${T.surface}}
    .fg{margin-bottom:13px}
    .fg label{display:block;font-size:11px;color:${T.muted};margin-bottom:5px;font-weight:700;letter-spacing:1px;text-transform:uppercase}
    button{cursor:pointer;font-family:'Outfit',sans-serif;font-weight:600;border:none;border-radius:9px;padding:9px 17px;transition:all .2s;display:inline-flex;align-items:center;gap:6px}
    .btn-p{background:linear-gradient(135deg,${T.mid},${T.bright});color:#fff;box-shadow:0 4px 12px ${T.mid}44}
    .btn-p:hover{transform:translateY(-1px)}
    .btn-s{background:linear-gradient(135deg,#059669,${T.accent2});color:#fff}
    .btn-s:hover{transform:translateY(-1px)}
    .btn-d{background:linear-gradient(135deg,#dc2626,${T.danger});color:#fff}
    .btn-g{background:transparent;color:${T.accent};border:1.5px solid ${T.border}}
    .btn-g:hover{border-color:${T.accent};background:${T.accent}14}
    .btn-soft{background:${T.surface};color:${T.text};border:1.5px solid ${T.border}}
    .btn-wa{background:linear-gradient(135deg,#128C7E,#25D366);color:#fff}
    .btn-wa:hover{transform:translateY(-1px)}
    .btn-em{background:linear-gradient(135deg,#1d4ed8,#60a5fa);color:#fff}
    .btn-em:hover{transform:translateY(-1px)}
    .tag{display:inline-block;padding:3px 10px;border-radius:20px;font-size:11px;font-weight:700}
    .overlay{position:fixed;inset:0;background:rgba(8,16,70,0.88);backdrop-filter:blur(6px);display:flex;align-items:center;justify-content:center;z-index:1000;padding:14px}
    .modal{background:${T.card};border:1px solid ${T.border};border-radius:18px;padding:24px;width:100%;max-width:680px;max-height:93vh;overflow-y:auto;box-shadow:0 24px 60px #00000060}
    @media(max-width:767px){.modal{padding-bottom:calc(96px + env(safe-area-inset-bottom,0px));max-height:93vh;max-height:93dvh}input,select,textarea{font-size:16px!important}}
    .chip{display:inline-flex;align-items:center;padding:5px 12px;border-radius:20px;font-size:11px;font-weight:600;border:1.5px solid ${T.border};color:${T.muted};cursor:pointer;transition:all .18s;background:${T.surface};white-space:nowrap}
    .chip.on{border-color:${T.accent};color:#fff;background:linear-gradient(135deg,${T.mid},${T.bright})}
    .sig-wrap{background:#fff;border:2px solid ${T.accent}55;border-radius:10px;padding:4px}
    .sig-pad{touch-action:none;display:block;width:100%;background:#fff;border-radius:6px}
    .photo-thumb{width:74px;height:68px;object-fit:cover;border-radius:9px;border:1.5px solid ${T.border};cursor:pointer}
    .photo-wrap{display:flex;flex-wrap:wrap;gap:8px;margin-top:9px}
    .rs{background:${T.card};border:1.5px solid ${T.border};border-radius:13px;padding:13px;margin-bottom:9px;display:flex;align-items:flex-start;gap:11px}
    .rn{width:33px;height:33px;border-radius:50%;background:linear-gradient(135deg,${T.mid},${T.bright});display:flex;align-items:center;justify-content:center;color:#fff;font-size:13px;font-weight:700;flex-shrink:0;margin-top:2px}
    .sec-lbl{font-size:10px;color:${T.muted};font-weight:700;letter-spacing:1.5px;text-transform:uppercase;margin-bottom:11px}
    .divr{display:flex;align-items:center;gap:8px;margin:14px 0 11px}
    .divr::before,.divr::after{content:'';flex:1;height:1px;background:${T.border}}
    .divr span{font-size:10px;color:${T.muted};font-weight:700;letter-spacing:1.5px;text-transform:uppercase;white-space:nowrap}
    .dot-live{width:8px;height:8px;border-radius:50%;background:${T.accent2};box-shadow:0 0 7px ${T.accent2};display:inline-block;flex-shrink:0}
    .alert-pill{display:flex;align-items:center;justify-content:space-between;gap:8px;padding:8px 13px;border-radius:9px;margin-bottom:8px;cursor:pointer;transition:filter .18s;font-size:13px;font-weight:700}
    .alert-pill:hover{filter:brightness(1.12)}
    @keyframes fadeUp{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}
    @keyframes spin{to{transform:rotate(360deg)}}
    .fade-up{animation:fadeUp .3s ease both}
    .spinner{width:16px;height:16px;border:2px solid rgba(255,255,255,0.3);border-top-color:#fff;border-radius:50%;animation:spin .8s linear infinite;display:inline-block}
  `;
  document.head.appendChild(s);
};

const Ic = {
  Home:    ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
  Plants:  ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/></svg>,
  Droplet: ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2.69s6.5 7.36 6.5 11.81a6.5 6.5 0 0 1-13 0C5.5 10.05 12 2.69 12 2.69z"/></svg>,
  Money:   ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="2.5"/><path d="M6 12h.01M18 12h.01"/></svg>,
  Sun:     ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>,
  Moon:    ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>,
  Route:   ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="5" cy="6" r="2"/><circle cx="19" cy="18" r="2"/><path d="M5 8v4a4 4 0 0 0 4 4h6a4 4 0 0 0 4-4V8"/><line x1="19" y1="8" x2="19" y2="16"/></svg>,
  Reports: ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>,
  Settings:()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"/><path d="M19.07 4.93l-1.41 1.41M4.93 4.93l1.41 1.41M20.49 12H22M2 12h1.51M19.07 19.07l-1.41-1.41M4.93 19.07l1.41-1.41M12 20.49V22M12 2v1.51"/></svg>,
  Plus:    ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>,
  Edit:    ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>,
  Trash:   ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>,
  X:       ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
  Bell:    ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>,
  Camera:  ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>,
  PDF:     ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>,
  Excel:   ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="3" width="20" height="18" rx="2"/><line x1="8" y1="3" x2="8" y2="21"/><line x1="2" y1="9" x2="20" y2="9"/><line x1="2" y1="15" x2="20" y2="15"/></svg>,
  Save:    ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/></svg>,
  Out:     ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>,
  Check:   ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>,
  Alert:   ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>,
  Map:     ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>,
  GPS:     ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="3"/><line x1="12" y1="2" x2="12" y2="5"/><line x1="12" y1="19" x2="12" y2="22"/><line x1="2" y1="12" x2="5" y2="12"/><line x1="19" y1="12" x2="22" y2="12"/></svg>,
  WA:      ()=><svg viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/></svg>,
  Email:   ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>,
};



const Logo = ({size=28}) => (
  <div style={{display:"flex",alignItems:"center",gap:9}}>
    <div style={{width:size,height:size,background:"#fff",borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,boxShadow:"0 2px 10px rgba(255,255,255,0.22)",overflow:"hidden"}}>
      <img src={SQ_LOGO} alt="SQ" style={{width:size*0.72,height:size*0.72,objectFit:"contain"}}/>
    </div>
    <div>
      <div style={{fontSize:size*0.5,fontWeight:800,color:"#fff",lineHeight:1,letterSpacing:.5}}>SUPER QUALITY</div>
      <div style={{fontSize:size*0.27,color:"rgba(255,255,255,0.58)",letterSpacing:1.5}}>Trading LLC.</div>
    </div>
  </div>
);

// ─── Signature Pad ─────────────────────────────────────────────────────────
const SigPad = ({onSave,onClear}) => {
  const ref=useRef(),drawing=useRef(false),last=useRef(null);
  useEffect(()=>{ const c=ref.current,ctx=c.getContext("2d"); ctx.fillStyle="#fff"; ctx.fillRect(0,0,c.width,c.height); },[]);
  const pos=(e,c)=>{const r=c.getBoundingClientRect(),s=e.touches?e.touches[0]:e;return{x:s.clientX-r.left,y:s.clientY-r.top};};
  const start=e=>{e.preventDefault();drawing.current=true;last.current=pos(e,ref.current);};
  const end=()=>{drawing.current=false;onSave&&onSave(ref.current.toDataURL());};
  const move=e=>{
    if(!drawing.current)return;e.preventDefault();
    const c=ref.current,ctx=c.getContext("2d"),p=pos(e,c);
    ctx.strokeStyle="#000";ctx.lineWidth=3;ctx.lineCap="round";ctx.lineJoin="round";
    ctx.beginPath();ctx.moveTo(last.current.x,last.current.y);ctx.lineTo(p.x,p.y);ctx.stroke();
    last.current=p;
  };
  const clear=()=>{const c=ref.current,ctx=c.getContext("2d");ctx.fillStyle="#fff";ctx.fillRect(0,0,c.width,c.height);onClear&&onClear();};
  return(
    <div>
      <div className="sig-wrap">
        <canvas ref={ref} width={500} height={120} className="sig-pad" style={{height:120}}
          onMouseDown={start} onMouseMove={move} onMouseUp={end}
          onTouchStart={start} onTouchMove={move} onTouchEnd={end}/>
      </div>
      <div style={{fontSize:11,color:T.muted,marginTop:5}}>Sign in the white box using your finger or mouse (black ink on white)</div>
      <button className="btn-g" style={{marginTop:7,padding:"4px 12px",fontSize:11}} onClick={clear}>Clear Signature</button>
    </div>
  );
};

// ─── Login ──────────────────────────────────────────────────────────────────

// ─── Login — Firebase Auth (secure, no passwords in code) ──────────────────
const Login = ({onLogin, firebaseOk}) => {
  const [email,setEmail]   = useState("");
  const [pass,setPass]     = useState("");
  const [err,setErr]       = useState("");
  const [loading,setLoading] = useState(false);

  const go = async () => {
    if(!email||!pass){setErr("Please enter your email and password");return;}
    if(!firebaseOk){setErr("Firebase not configured. Contact admin.");return;}
    setLoading(true); setErr("");
    const result = await fbSignIn(email.trim(), pass);
    if(result.ok){
      // Profile (name + role) loaded from Firebase DB in App Root via onAuthStateChanged
      // Nothing to do here — App Root handles the auth state listener
    } else {
      setErr(result.error);
      setLoading(false);
    }
  };

  return(
    <div style={{minHeight:"100vh",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:20,background:`linear-gradient(155deg,${T.navy} 0%,${T.royal} 50%,${T.mid} 100%)`,position:"relative",overflow:"hidden"}}>
      <div style={{position:"absolute",top:"-8%",left:"-8%",width:280,height:280,borderRadius:"50%",background:"rgba(255,255,255,0.05)",pointerEvents:"none"}}/>
      <svg style={{position:"absolute",bottom:0,left:0,right:0,pointerEvents:"none"}} viewBox="0 0 1440 140" preserveAspectRatio="none" height="110">
        <path d="M0,70 C360,130 720,10 1080,70 C1260,100 1380,60 1440,50 L1440,140 L0,140Z" fill={T.bg} opacity="0.5"/>
        <path d="M0,100 C300,50 600,140 900,90 C1100,60 1300,110 1440,90 L1440,140 L0,140Z" fill={T.bg} opacity="0.75"/>
        <path d="M0,120 C240,108 480,135 720,120 C960,105 1200,130 1440,118 L1440,140 L0,140Z" fill={T.bg}/>
      </svg>
      <div style={{position:"relative",zIndex:1,width:"100%",maxWidth:390,animation:"fadeUp .4s ease"}}>
        <div style={{textAlign:"center",marginBottom:30}}><Logo size={34}/><div style={{marginTop:16,fontSize:11,color:"rgba(255,255,255,0.45)",letterSpacing:3}}>AMC MANAGEMENT PORTAL</div></div>
        <div className="card-glass">
          <div style={{fontSize:19,fontWeight:700,color:"#fff",marginBottom:20,textAlign:"center"}}>Welcome Back</div>

          {/* 🔒 Email field (not username) — authenticated by Firebase */}
          <div className="fg">
            <label style={{color:"rgba(255,255,255,0.55)"}}>Email Address</label>
            <input
              type="email"
              value={email}
              onChange={e=>setEmail(e.target.value)}
              placeholder="your@email.com"
              onKeyDown={e=>e.key==="Enter"&&go()}
              style={{background:"rgba(255,255,255,0.1)",border:"1.5px solid rgba(255,255,255,0.2)",color:"#fff"}}
            />
          </div>

          {/* 🔒 Password verified by Firebase Auth — never stored in code */}
          <div className="fg">
            <label style={{color:"rgba(255,255,255,0.55)"}}>Password</label>
            <input
              type="password"
              value={pass}
              onChange={e=>setPass(e.target.value)}
              placeholder="Enter your password"
              onKeyDown={e=>e.key==="Enter"&&go()}
              style={{background:"rgba(255,255,255,0.1)",border:"1.5px solid rgba(255,255,255,0.2)",color:"#fff"}}
            />
          </div>

          {err&&<div style={{color:"#fca5a5",fontSize:12,marginBottom:12,textAlign:"center",padding:"8px 10px",background:"rgba(248,113,113,0.1)",borderRadius:8}}>{err}</div>}

          <button className="btn-p" style={{width:"100%",justifyContent:"center",padding:"13px",fontSize:15,background:"rgba(255,255,255,0.94)",color:T.royal,fontWeight:700,borderRadius:11}} onClick={go} disabled={loading||!firebaseOk}>
            {loading?<><span className="spinner" style={{borderTopColor:T.royal,borderColor:`${T.royal}33`}}/> Signing in…</>:"Sign In →"}
          </button>

          {!firebaseOk&&(
            <div style={{marginTop:13,padding:"9px 12px",background:"rgba(251,191,36,0.1)",border:"1px solid rgba(251,191,36,0.28)",borderRadius:8,fontSize:11,color:T.warn,textAlign:"center"}}>
              ⚠ Firebase not configured — add your config to enable login
            </div>
          )}

          <div style={{marginTop:14,padding:"10px 12px",background:"rgba(255,255,255,0.06)",borderRadius:8,fontSize:11,color:"rgba(255,255,255,0.5)",textAlign:"center",lineHeight:1.7}}>
            🔒 Secured by Firebase Authentication<br/>
          </div>
        </div>
        <div style={{textAlign:"center",marginTop:14,fontSize:10,color:"rgba(255,255,255,0.28)"}}>Copyright © 2026 Muhammad Faran. All Rights Reserved</div>
      </div>
    </div>
  );
};

const CustomerModal = ({initial,sites,onSave,onClose}) => {
  const blank={name:"",location:"",capacity:"",docNo:"",amcStart:"",duration:"1 year",amcEnd:"",emirate:"Abu Dhabi",lat:"",lng:"",address:"",contactNo:"",operatorName:"",
    status:"active",inactiveSince:"",inactiveReason:"",coverage:"amc",warrantyStart:"",warrantyEnd:"",siteGroup:"",machines:[]};
  const [f,setF]=useState(initial?{...blank,...initial,machines:machinesOf(initial).map(m=>({...m}))}:blank);
  const set=(k,v)=>setF(x=>({...x,[k]:v}));
  const setM=(id,k,v)=>setF(x=>({...x,machines:x.machines.map(m=>m.id===id?{...m,[k]:v}:m)}));
  const warrantyStartChanged=v=>setF(x=>{ const auto=addMonthsStr(x.warrantyStart,12); const keep=x.warrantyEnd&&x.warrantyEnd!==auto; return {...x,warrantyStart:v,warrantyEnd:keep?x.warrantyEnd:addMonthsStr(v,12)}; });
  const getGPS=()=>{
    if(!navigator.geolocation){alert("GPS not available");return;}
    navigator.geolocation.getCurrentPosition(pos=>{set("lat",pos.coords.latitude.toFixed(6));set("lng",pos.coords.longitude.toFixed(6));},()=>alert("Could not get location"));
  };
  const submit=()=>{
    if(!f.name||!f.location) return alert("Name & Location required");
    if(f.coverage==="warranty"&&!f.warrantyStart) return alert("Enter the warranty start date");
    const machines=f.machines.filter(m=>(m.label||"").trim()||(m.capacity||"").trim()).map(m=>({...m,label:(m.label||"").trim()||"Machine"}));
    onSave({...f,machines,siteGroup:(f.siteGroup||"").trim(),
      inactiveSince:f.status==="inactive"?(f.inactiveSince||todayStr()):""});
  };
  const sec={background:T.surface,borderRadius:9,padding:12,marginBottom:12,border:`1px solid ${T.border}`};
  const secT={fontSize:11,color:T.light,fontWeight:700,letterSpacing:1,marginBottom:9};
  return(
    <div className="overlay" style={{alignItems:"flex-start",paddingTop:12,paddingBottom:12}}>
      <div className="modal" style={{padding:18}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
          <div style={{fontSize:16,fontWeight:800,color:T.heading}}>{initial?"Edit Plant":"Add New Plant"}</div>
          <button style={{background:"transparent",color:T.muted,border:`1px solid ${T.border}`,borderRadius:7,padding:"5px 10px",fontSize:14,fontWeight:700,cursor:"pointer",fontFamily:T.font}} onClick={onClose}>✕</button>
        </div>
        <div className="g2" style={{gap:10}}>
          {[{l:"Plant Name *",k:"name"},{l:"Location *",k:"location"},{l:"Capacity",k:"capacity"},{l:"Doc / Contract No.",k:"docNo"},{l:"Contact No.",k:"contactNo"},{l:"Operator Name",k:"operatorName"}].map(x=>(
            <div key={x.k} className="fg" style={{marginBottom:9}}><label>{x.l}</label><input value={f[x.k]||""} onChange={e=>set(x.k,e.target.value)}/></div>
          ))}
          <div className="fg" style={{marginBottom:9}}><label>Emirate</label><select value={f.emirate} onChange={e=>set("emirate",e.target.value)}>{EMIRATES.map(e=><option key={e}>{e}</option>)}</select></div>
          <div className="fg" style={{marginBottom:9}}><label>Site group (optional)</label><input list="sq-sites" value={f.siteGroup||""} onChange={e=>set("siteGroup",e.target.value)} placeholder="e.g. Altwesa – Zakher"/>
            <datalist id="sq-sites">{(sites||[]).map(x=><option key={x} value={x}/>)}</datalist></div>
        </div>

        <div style={sec}>
          <div style={secT}>🛡 COVERAGE & STATUS</div>
          <div className="g2" style={{gap:10}}>
            <div className="fg" style={{marginBottom:9}}><label>Coverage</label>
              <select value={f.coverage} onChange={e=>set("coverage",e.target.value)}>
                <option value="amc">AMC contract</option>
                <option value="warranty">Under warranty (1 year, no AMC)</option>
              </select></div>
            <div className="fg" style={{marginBottom:9}}><label>Status</label>
              <select value={f.status} onChange={e=>set("status",e.target.value)}>
                <option value="active">Active</option>
                <option value="inactive">Inactive (did not renew)</option>
              </select></div>
          </div>
          {f.coverage==="warranty"?(
            <div className="g2" style={{gap:10}}>
              <div className="fg" style={{marginBottom:9}}><label>Warranty start *</label><input type="date" value={f.warrantyStart||""} onChange={e=>warrantyStartChanged(e.target.value)}/></div>
              <div className="fg" style={{marginBottom:9}}><label>Warranty end (auto +12 months)</label><input type="date" value={f.warrantyEnd||""} onChange={e=>set("warrantyEnd",e.target.value)}/></div>
            </div>
          ):(
            <div className="g2" style={{gap:10}}>
              <div className="fg" style={{marginBottom:9}}><label>Duration</label><select value={f.duration} onChange={e=>set("duration",e.target.value)}>{["6 Months","1 year","2 year","3 year","Rental"].map(d=><option key={d}>{d}</option>)}</select></div>
              <div className="fg" style={{marginBottom:9}}><label>AMC Start</label><input type="date" value={f.amcStart} onChange={e=>set("amcStart",e.target.value)}/></div>
              <div className="fg" style={{marginBottom:9}}><label>AMC End</label><input type="date" value={f.amcEnd} onChange={e=>set("amcEnd",e.target.value)}/></div>
            </div>
          )}
          {f.status==="inactive"&&(
            <div className="g2" style={{gap:10}}>
              <div className="fg" style={{marginBottom:9}}><label>Inactive since</label><input type="date" value={f.inactiveSince||todayStr()} onChange={e=>set("inactiveSince",e.target.value)}/></div>
              <div className="fg" style={{marginBottom:9}}><label>Reason (optional)</label><input value={f.inactiveReason||""} onChange={e=>set("inactiveReason",e.target.value)} placeholder="e.g. did not renew"/></div>
            </div>
          )}
          <div style={{fontSize:11,color:T.muted}}>{f.status==="inactive"?"Inactive plants are hidden from alerts, routes and new reports. All history is kept and you can reactivate any time.":f.coverage==="warranty"?"Warranty plants are highlighted and flagged before the warranty ends so you can offer an AMC.":"AMC plants follow the normal expiry alerts."}</div>
        </div>

        <div style={sec}>
          <div style={secT}>⚙ MACHINES ON THIS CONTRACT</div>
          <div style={{fontSize:11,color:T.muted,marginBottom:8}}>Add each machine that shares this contract and price — technicians then submit one report per machine. Leave empty for a single machine. Machines with their own contract dates or price should be added as separate plants with the same Site group.</div>
          {f.machines.map((m,k)=>(
            <div key={m.id} style={{border:`1px solid ${T.border}`,borderRadius:9,padding:8,marginBottom:8}}>
              <div style={{display:"flex",gap:6,marginBottom:6}}>
                <input value={m.label||""} onChange={e=>setM(m.id,"label",e.target.value)} placeholder={`Name e.g. RO-${k+1}`} style={{flex:1,minWidth:0}}/>
                <input value={m.capacity||""} onChange={e=>setM(m.id,"capacity",e.target.value)} placeholder="Capacity" style={{flex:1,minWidth:0}}/>
                <button className="btn-d" style={{padding:"6px 8px"}} onClick={()=>setF(x=>({...x,machines:x.machines.filter(y=>y.id!==m.id)}))}><Ic.Trash/></button>
              </div>
              <div style={{display:"flex",gap:6}}>
                <input value={m.membraneName||""} onChange={e=>setM(m.id,"membraneName",e.target.value)} placeholder="Membrane name" style={{flex:2,minWidth:0}}/>
                <input value={m.membraneType||""} onChange={e=>setM(m.id,"membraneType",e.target.value)} placeholder="Type" style={{flex:1,minWidth:0}}/>
                <input value={m.noOfMembrane||""} onChange={e=>setM(m.id,"noOfMembrane",e.target.value)} placeholder="No." style={{width:56}}/>
              </div>
            </div>
          ))}
          <button className="btn-g" style={{fontSize:12,padding:"6px 12px"}} onClick={()=>setF(x=>({...x,machines:[...x.machines,{id:uid(),label:`RO-${x.machines.length+1}`,capacity:"",membraneName:"",membraneType:"",noOfMembrane:""}]}))}><Ic.Plus/> Add machine</button>
        </div>

        <div style={sec}>
          <div style={secT}>📍 PLANT LOCATION</div>
          <div className="fg" style={{marginBottom:9}}><label>Full Address</label><input value={f.address||""} onChange={e=>set("address",e.target.value)} placeholder="e.g. Al Khatem Area, Abu Dhabi, UAE"/></div>
          <div className="g2" style={{marginBottom:9}}>
            <div className="fg" style={{marginBottom:0}}><label>Latitude</label><input type="number" step="0.000001" value={f.lat||""} onChange={e=>set("lat",e.target.value)} placeholder="e.g. 24.192"/></div>
            <div className="fg" style={{marginBottom:0}}><label>Longitude</label><input type="number" step="0.000001" value={f.lng||""} onChange={e=>set("lng",e.target.value)} placeholder="e.g. 55.763"/></div>
          </div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            <button className="btn-p" style={{fontSize:12,padding:"7px 12px"}} onClick={getGPS}><Ic.GPS/> Use My GPS</button>
            <button className="btn-soft" style={{fontSize:12,padding:"7px 12px"}} onClick={()=>window.open(`https://maps.google.com?q=${encodeURIComponent(f.address||f.name)}`,"_blank")}><Ic.Map/> Google Maps</button>
          </div>
        </div>
        <div style={{display:"flex",gap:9}}>
          <button className="btn-p" style={{flex:1,justifyContent:"center"}} onClick={submit}><Ic.Save/> Save</button>
          <button className="btn-soft" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

// ─── Dashboard ──────────────────────────────────────────────────────────────
const Dashboard = ({customers,reports,user,onTab,firebaseOk,payAlert}) => {
  const [showExpired,setShowExpired]=useState(false);
  const [showExpiring,setShowExpiring]=useState(false);
  const [showWarranty,setShowWarranty]=useState(false);
  const live=customers.filter(c=>!isInactive(c));           // inactive (not renewed) plants are left out of every alert/count
  const amc=customers.filter(isAMC);                        // AMC plants: expiry rules apply
  const warrEnding=live.filter(c=>isWarranty(c)&&daysUntil(c.warrantyEnd)!==null&&daysUntil(c.warrantyEnd)<=60).sort((a,b)=>daysUntil(a.warrantyEnd)-daysUntil(b.warrantyEnd));
  const total=live.length;
  const expiredList=amc.filter(c=>{const d=daysUntil(c.amcEnd);return d!==null&&d<0;});
  const exp30List=amc.filter(c=>{const d=daysUntil(c.amcEnd);return d!==null&&d>=0&&d<=30;});
  const active=amc.filter(c=>{const d=daysUntil(c.amcEnd);return d!==null&&d>30;}).length;
  // Monthly visits: one expected visit per AMC plant — or per machine when a plant lists machines
  const monthKey=new Date().toISOString().slice(0,7);
  const expected=amc.reduce((t,c)=>t+Math.max(1,machinesOf(c).length),0);
  const doneSet=new Set(); { const byId={}; amc.forEach(c=>{byId[c.id]=c;});
    reports.forEach(r=>{ if(!(r.date||"").startsWith(monthKey)) return; const c=byId[r.customerId]; if(!c) return; const ms=machinesOf(c);
      if(ms.length){ if(ms.some(m=>m.id===r.machineId)) doneSet.add(c.id+"|"+r.machineId); } else doneSet.add(c.id); }); }
  const monthR=doneSet.size;
  const pct=expected?Math.min(100,Math.round((monthR/expected)*100)):0;
  return(
    <div className="pg fade-up">
      <div style={{marginBottom:18}}>
        <div style={{fontSize:13,color:T.muted}}>Good {new Date().getHours()<12?"morning":"afternoon"},</div>
        <div style={{fontSize:26,fontWeight:800,color:T.heading}}>{user.name}</div>
        <div style={{fontSize:12,color:T.muted,marginTop:3,display:"flex",alignItems:"center",gap:8}}>
          <span className="dot-live"/>
          {firebaseOk?"Live sync active":"Local mode"} · {new Date().toLocaleDateString("en-AE",{weekday:"long",day:"numeric",month:"long"})}
        </div>
      </div>

      {/* Compact clickable alert pills */}
      {user.role==="admin"&&payAlert&&payAlert.count>0&&(
        <div className="alert-pill" style={{background:T.danger+"18",border:`1px solid ${T.danger}44`,color:T.danger}} onClick={()=>onTab("finance")}>
          <div style={{display:"flex",alignItems:"center",gap:8}}><Ic.Money/>{payAlert.count} payment installment{payAlert.count>1?"s":""} OVERDUE · AED {money(payAlert.gross)}</div>
          <span style={{fontSize:11}}>Review ›</span>
        </div>
      )}
      {expiredList.length>0&&(
        <div className="alert-pill" style={{background:T.danger+"18",border:`1px solid ${T.danger}44`,color:T.danger}}
          onClick={()=>{setShowExpiring(false);setShowWarranty(false);setShowExpired(v=>!v);}}>
          <div style={{display:"flex",alignItems:"center",gap:8}}><Ic.Alert/>{expiredList.length} contract{expiredList.length>1?"s":""} EXPIRED</div>
          <span style={{fontSize:11}}>{showExpired?"▲ Hide":"▼ Show"}</span>
        </div>
      )}
      {exp30List.length>0&&(
        <div className="alert-pill" style={{background:T.warn+"18",border:`1px solid ${T.warn}44`,color:T.warn}}
          onClick={()=>{setShowExpired(false);setShowWarranty(false);setShowExpiring(v=>!v);}}>
          <div style={{display:"flex",alignItems:"center",gap:8}}><Ic.Bell/>{exp30List.length} expiring within 30 days</div>
          <span style={{fontSize:11}}>{showExpiring?"▲ Hide":"▼ Show"}</span>
        </div>
      )}

      {warrEnding.length>0&&(
        <div className="alert-pill" style={{background:T.accent+"18",border:`1px solid ${T.accent}44`,color:T.accent}}
          onClick={()=>{setShowExpired(false);setShowExpiring(false);setShowWarranty(v=>!v);}}>
          <div style={{display:"flex",alignItems:"center",gap:8}}><Ic.Bell/>🛡 {warrEnding.length} warranty plant{warrEnding.length>1?"s":""} ending ≤60 days — no AMC yet</div>
          <span style={{fontSize:11}}>{showWarranty?"▲ Hide":"▼ Show"}</span>
        </div>
      )}
      {showWarranty&&warrEnding.length>0&&(
        <div className="card" style={{marginBottom:12,borderColor:T.accent+"44"}}>
          <div style={{fontSize:12,fontWeight:700,color:T.accent,marginBottom:10}}>Warranty ending — offer an AMC</div>
          {warrEnding.map(c=>{const b=warrantyBadge(c);return(
            <div key={c.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"7px 0",borderBottom:`1px solid ${T.border}`}}>
              <div><div style={{fontSize:13,fontWeight:600,color:T.heading}}>{c.name}</div><div style={{fontSize:11,color:T.muted}}>📍 {c.location} · ends {c.warrantyEnd||"—"}</div></div>
              <span className="tag" style={{background:b.color+"22",color:b.color,fontSize:10}}>{b.label}</span>
            </div>);})}
        </div>
      )}

      {/* Expandable list */}
      {(showExpired||showExpiring)&&(
        <div className="card" style={{marginBottom:12,borderColor:showExpired?T.danger+"44":T.warn+"44"}}>
          <div style={{fontSize:12,fontWeight:700,color:showExpired?T.danger:T.warn,marginBottom:10}}>
            {showExpired?"Expired Contracts":"Expiring Within 30 Days"}
          </div>
          {(showExpired?expiredList:exp30List).map(c=>{const b=expiryBadge(c.amcEnd);return(
            <div key={c.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"7px 0",borderBottom:`1px solid ${T.border}`}}>
              <div><div style={{fontSize:13,fontWeight:600,color:T.heading}}>{c.name}</div><div style={{fontSize:11,color:T.muted}}>📍 {c.location} · {c.amcEnd||"—"}</div></div>
              <span className="tag" style={{background:b.color+"22",color:b.color,fontSize:10}}>{b.label}</span>
            </div>
          );})}
        </div>
      )}

      {/* Stats */}
      <div className="stat-grid" style={{marginBottom:16}}>
        {[{l:"Total Plants",v:total,c:T.light,e:"🏭"},{l:"Active",v:active,c:T.accent2,e:"✅"},{l:"Expiring ≤30d",v:exp30List.length,c:T.warn,e:"⏳"},{l:"Expired",v:expiredList.length,c:T.danger,e:"❌"}].map(s=>(
          <div key={s.l} className="card" style={{cursor:"pointer",borderColor:s.c+"33"}} onClick={()=>onTab("customers")}>
            <div style={{fontSize:11,marginBottom:4}}>{s.e}</div>
            <div style={{fontSize:34,fontWeight:800,color:s.c,fontFamily:T.mono,lineHeight:1}}>{s.v}</div>
            <div style={{fontSize:11,color:T.muted,marginTop:5,fontWeight:600}}>{s.l}</div>
          </div>
        ))}
      </div>

      {/* Monthly progress */}
      <div className="card" style={{marginBottom:16}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12}}>
          <div><div className="sec-lbl">Monthly Visits</div><div style={{fontSize:30,fontWeight:800,color:T.heading,fontFamily:T.mono}}>{monthR}<span style={{fontSize:14,color:T.muted,fontWeight:400}}> / {expected}</span></div></div>
          <div style={{fontSize:28,fontWeight:800,color:pct>=80?T.accent2:pct>=50?T.warn:T.accent}}>{pct}%</div>
        </div>
        <div style={{background:T.bg,borderRadius:8,height:8,overflow:"hidden"}}>
          <div style={{width:`${pct}%`,background:`linear-gradient(90deg,${T.mid},${T.light})`,height:"100%",borderRadius:8,transition:"width .6s"}}/>
        </div>
        <div style={{fontSize:11,color:T.muted,marginTop:8}}>{new Date().toLocaleDateString("en-AE",{month:"long",year:"numeric"})}</div>
      </div>

      {/* Export */}
      <div style={{marginBottom:16}}>
        <div className="sec-lbl">Export Plant List</div>
        <div style={{display:"flex",gap:9,flexWrap:"wrap"}}>
          <button className="btn-s" style={{fontSize:13,padding:"9px 16px"}} onClick={()=>exportExcel(customers)}><Ic.Excel/> Export to Excel / CSV</button>
          <button className="btn-p" style={{fontSize:13,padding:"9px 16px"}} onClick={()=>exportPlantsPDF(customers)}><Ic.PDF/> Export to PDF</button>
        </div>
        <div style={{fontSize:11,color:T.muted,marginTop:6}}>PDF includes expired &amp; expiring summary · CSV opens in Excel</div>
      </div>

      {/* Upcoming expirations */}
      <div className="sec-lbl">⚠ Upcoming Expirations</div>
      {amc.filter(c=>{const d=daysUntil(c.amcEnd);return d!==null&&d<=90;}).sort((a,b)=>daysUntil(a.amcEnd)-daysUntil(b.amcEnd)).slice(0,6).map(c=>{
        const b=expiryBadge(c.amcEnd);
        return(
          <div key={c.id} className="cc" style={{borderColor:b.color+"44"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
              <div><div style={{fontWeight:700,fontSize:14,color:T.heading}}>{c.name}</div><div style={{fontSize:12,color:T.muted,marginTop:2}}>📍 {c.location} · {c.emirate} · Ends: {c.amcEnd||"—"}</div></div>
              <span className="tag" style={{background:b.color+"22",color:b.color,border:`1px solid ${b.color}33`,flexShrink:0,marginLeft:10}}>{b.label}</span>
            </div>
          </div>
        );
      })}
      {amc.filter(c=>{const d=daysUntil(c.amcEnd);return d!==null&&d<=90;}).length===0&&(
        <div style={{textAlign:"center",padding:"28px 20px",color:T.muted}}><div style={{fontSize:30,marginBottom:8}}>✅</div><div style={{fontSize:14,fontWeight:600,color:T.accent2}}>All contracts healthy</div></div>
      )}
    </div>
  );
};

// ─── Customers Page ─────────────────────────────────────────────────────────
const Customers = ({customers,setCustomers,user}) => {
  const [search,setSearch]=useState(""), [em,setEm]=useState("All"), [modal,setModal]=useState(null), [sortBy,setSortBy]=useState("name-asc");
  const [cov,setCov]=useState("active");   // active | amc | warranty | inactive | all
  const covOK=c=>cov==="all"?true:cov==="inactive"?isInactive(c):cov==="warranty"?(!isInactive(c)&&isWarranty(c)):cov==="amc"?isAMC(c):!isInactive(c);
  const q=search.toLowerCase();
  const filtered=customers
    .filter(c=>covOK(c)&&(em==="All"||c.emirate===em)&&((c.name||"").toLowerCase().includes(q)||(c.location||"").toLowerCase().includes(q)||(c.siteGroup||"").toLowerCase().includes(q)||machineSummary(c).toLowerCase().includes(q)))
    .sort((a,b)=>{
      if(sortBy==="name-asc")  return (a.name||"").localeCompare(b.name||"");
      if(sortBy==="name-desc") return (b.name||"").localeCompare(a.name||"");
      const ms=d=>d?new Date(d).getTime():Infinity;
      if(sortBy==="expiry-asc")  return ms(coverageEnd(a))-ms(coverageEnd(b));
      if(sortBy==="expiry-desc") return ms(coverageEnd(b))-ms(coverageEnd(a));
      return 0;
    });
  const sites=[...new Set(customers.map(c=>(c.siteGroup||"").trim()).filter(Boolean))].sort();
  const save=f=>{if(modal==="add")setCustomers(cs=>[...cs,{...f,id:uid()}]);else setCustomers(cs=>cs.map(c=>c.id===modal.id?{...f,id:c.id}:c));setModal(null);};
  const toggleActive=c=>{
    const to=isInactive(c)?"active":"inactive";
    if(!window.confirm(to==="inactive"?`Mark "${c.name}" as INACTIVE (did not renew)? It will be hidden from alerts, routes and new reports. History is kept and you can reactivate it any time.`:`Reactivate "${c.name}"?`)) return;
    setCustomers(cs=>cs.map(x=>x.id===c.id?{...x,status:to,inactiveSince:to==="inactive"?todayStr():""}:x));
  };
  const nWarr=customers.filter(c=>!isInactive(c)&&isWarranty(c)).length, nInact=customers.filter(isInactive).length;
  return(
    <div className="pg fade-up">
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
        <div><div style={{fontSize:22,fontWeight:800,color:T.heading}}>Plants</div><div style={{fontSize:12,color:T.muted}}>{filtered.length} of {customers.length}</div></div>
        {user.role==="admin"&&<button className="btn-p" style={{padding:"8px 14px",fontSize:13}} onClick={()=>setModal("add")}><Ic.Plus/> Add Plant</button>}
      </div>
      <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="🔍 Search name, location, site or machine…" style={{marginBottom:11}}/>
      <div style={{display:"flex",gap:6,overflowX:"auto",marginBottom:10,paddingBottom:4}}>
        {[["active","Active"],["amc","AMC"],["warranty",`🛡 Warranty (${nWarr})`],["inactive",`⏸ Inactive (${nInact})`],["all","All"]].map(([k,l])=><button key={k} onClick={()=>setCov(k)} className={cov===k?"chip on":"chip"}>{l}</button>)}
      </div>
      <div style={{display:"flex",gap:6,overflowX:"auto",marginBottom:14,paddingBottom:4}}>
        {["All",...EMIRATES].map(e=><button key={e} onClick={()=>setEm(e)} className={em===e?"chip on":"chip"}>{e}{e!=="All"?` (${customers.filter(c=>c.emirate===e&&covOK(c)).length})`:""}</button>)}
      </div>
      <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:12,flexWrap:"wrap"}}>
        <span style={{fontSize:12,color:T.muted,fontWeight:600,marginRight:2}}>Sort:</span>
        {[{v:"name-asc",l:"🔤 A→Z"},{v:"name-desc",l:"🔤 Z→A"},{v:"expiry-asc",l:"📅 Expiry ↑"},{v:"expiry-desc",l:"📅 Expiry ↓"}].map(o=>(
          <button key={o.v} onClick={()=>setSortBy(o.v)} className={sortBy===o.v?"chip on":"chip"}>{o.l}</button>
        ))}
      </div>
      {filtered.map(c=>{
        const inact=isInactive(c), warr=isWarranty(c);
        const b=inact?{label:"⏸ Inactive",color:T.muted}:warr?warrantyBadge(c):expiryBadge(c.amcEnd);
        const ms=machinesOf(c);
        const style=inact?{opacity:.68,borderStyle:"dashed"}:warr?{borderLeft:`4px solid ${T.accent}`,background:T.accent+"12"}:{};
        return(
        <div key={c.id} className="cc" style={style}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:user.role==="admin"?8:0}}>
            <div style={{flex:1}}>
              <div style={{fontWeight:700,fontSize:15,color:T.heading}}>{c.name}{ms.length>0&&<span className="tag" style={{marginLeft:8,background:T.accent+"22",color:T.accent,fontSize:10}}>{ms.length} machines</span>}</div>
              <div style={{fontSize:12,color:T.muted,marginTop:3}}>📍 {c.location} · 🏛 {c.emirate}{c.siteGroup?` · 🏢 ${c.siteGroup}`:""}</div>
              <div style={{fontSize:12,color:T.muted}}>💧 {c.capacity||"—"} · 📋 {c.docNo||"—"}</div>
              {ms.length>0&&<div style={{fontSize:12,color:T.muted}}>⚙ {machineSummary(c)}</div>}
              {warr
                ?<div style={{fontSize:12,color:T.accent,fontWeight:600}}>🛡 Warranty {c.warrantyStart||"—"} → {c.warrantyEnd||"—"} · no AMC yet</div>
                :<div style={{fontSize:12,color:T.muted}}>🗓 {c.amcStart||"—"} → {c.amcEnd||"—"} ({c.duration})</div>}
              {inact&&<div style={{fontSize:12,color:T.muted}}>⏸ Not renewed{c.inactiveSince?` · since ${c.inactiveSince}`:""}{c.inactiveReason?` · ${c.inactiveReason}`:""}</div>}
              {c.address&&<div style={{fontSize:12,color:T.muted}}>📌 {c.address}</div>}
              {c.lat&&c.lng&&<a href={`https://maps.google.com?q=${c.lat},${c.lng}`} target="_blank" rel="noopener noreferrer" style={{fontSize:11,color:T.accent,display:"block",marginTop:2,textDecoration:"none"}}>🗺 View on Maps ({Number(c.lat).toFixed(4)}, {Number(c.lng).toFixed(4)})</a>}
            </div>
            <span className="tag" style={{background:b.color+"22",color:b.color,border:`1px solid ${b.color}33`,marginLeft:10,flexShrink:0}}>{b.label}</span>
          </div>
          {user.role==="admin"&&(
            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
              <button className="btn-g" style={{padding:"5px 12px",fontSize:12}} onClick={()=>setModal(c)}><Ic.Edit/> Edit</button>
              <button className="btn-soft" style={{padding:"5px 12px",fontSize:12}} onClick={()=>toggleActive(c)}>{inact?"▶ Reactivate":"⏸ Mark inactive"}</button>
              <button className="btn-d" style={{padding:"5px 10px",fontSize:12}} onClick={()=>{if(window.confirm("Delete this plant? (It goes to the Recycle Bin for 30 days.)"))setCustomers(cs=>cs.filter(x=>x.id!==c.id));}}><Ic.Trash/></button>
            </div>
          )}
        </div>
      );})}
      {filtered.length===0&&<div style={{textAlign:"center",padding:"28px 20px",color:T.muted}}><div style={{fontSize:30,marginBottom:8}}>🏭</div><div style={{fontSize:14,fontWeight:600}}>No plants match this filter</div></div>}
      {modal&&<CustomerModal initial={modal==="add"?null:modal} sites={sites} onSave={save} onClose={()=>setModal(null)}/>}
    </div>
  );
};

// ─── Photo thumbnails with a full-screen viewer (replaces window.open(dataURL), which Chrome blocks) ─
// One photo; shows a clear "unavailable" tile (not a broken-image icon / black screen) if it can't load.
const PhotoImg = ({src,alt,className,style,onClick}) => {
  const [failed,setFailed]=useState(false);
  if(!isValidPhoto(src)||failed) return(
    <div className={className} onClick={onClick} style={{...style,display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",gap:4,background:T.surface,border:`1px dashed ${T.warn}`,color:T.warn,fontSize:11,textAlign:"center",padding:6,cursor:onClick?"pointer":"default"}}>
      <span style={{fontSize:20}}>⚠</span>Photo unavailable
    </div>);
  return <img src={src} alt={alt} className={className} style={style} onClick={onClick} onError={()=>setFailed(true)}/>;
};
const PhotoGrid = ({photos,onRemove}) => {
  const [open,setOpen]=useState(null);
  const list=photos||[];
  useEffect(()=>{
    if(open===null) return;
    const h=e=>{ if(e.key==="Escape") setOpen(null); if(e.key==="ArrowRight") setOpen(i=>(i+1)%list.length); if(e.key==="ArrowLeft") setOpen(i=>(i-1+list.length)%list.length); };
    window.addEventListener("keydown",h); return ()=>window.removeEventListener("keydown",h);
  },[open,list.length]);
  if(!list.length) return null;
  const nav={position:"absolute",top:"50%",transform:"translateY(-50%)",background:"rgba(0,0,0,.55)",color:"#fff",border:"none",borderRadius:"50%",width:44,height:44,fontSize:22,cursor:"pointer"};
  return(<>
    <div className="photo-wrap">{list.map((p,i)=>(
      <div key={i} style={{position:"relative"}}>
        <PhotoImg src={p} className="photo-thumb" alt={`Photo ${i+1}`} onClick={()=>setOpen(i)}/>
        {onRemove&&<button onClick={()=>onRemove(i)} style={{position:"absolute",top:-6,right:-6,background:T.danger,color:"#fff",border:"none",borderRadius:"50%",width:22,height:22,fontSize:13,cursor:"pointer",padding:0,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700}}>×</button>}
      </div>))}
    </div>
    {open!==null&&list[open]!==undefined&&(
      <div className="overlay" style={{zIndex:3000,background:"rgba(0,0,0,.92)"}} onClick={()=>setOpen(null)}>
        <PhotoImg src={list[open]} alt="" style={{maxWidth:"100%",maxHeight:"88vh",borderRadius:8,minWidth:220,minHeight:140}} onClick={e=>e.stopPropagation()}/>
        <button onClick={()=>setOpen(null)} style={{position:"absolute",top:14,right:14,background:"rgba(255,255,255,.18)",color:"#fff",border:"none",borderRadius:"50%",width:42,height:42,fontSize:20,cursor:"pointer"}}>✕</button>
        {list.length>1&&<>
          <button onClick={e=>{e.stopPropagation();setOpen((open-1+list.length)%list.length);}} style={{...nav,left:10}}>‹</button>
          <button onClick={e=>{e.stopPropagation();setOpen((open+1)%list.length);}} style={{...nav,right:10}}>›</button>
          <div style={{position:"absolute",bottom:20,left:0,right:0,textAlign:"center",color:"#fff",fontSize:12,fontWeight:700}}>{open+1} / {list.length}</div>
        </>}
      </div>)}
  </>);
};

// ─── Small RO Plants: Add/Edit Modal ───────────────────────────────────────
const SmallROModal = ({initial,onSave,onClose}) => {
  const blank={clientName:"",plantLocation:"",capacity:"",docNo:"",operatorManager:"",contactNo:"",
    contractStart:"",duration:"1 year",contractEnd:"",emirate:"Abu Dhabi",lat:"",lng:"",address:"",lastVisitDate:"",status:"active",inactiveSince:"",inactiveReason:""};
  const [f,setF]=useState(initial?{...blank,...initial}:blank);
  const set=(k,v)=>setF(x=>({...x,[k]:v}));
  const getGPS=()=>{
    if(!navigator.geolocation){alert("GPS not available");return;}
    navigator.geolocation.getCurrentPosition(pos=>{set("lat",pos.coords.latitude.toFixed(6));set("lng",pos.coords.longitude.toFixed(6));},()=>alert("Could not get location"));
  };
  return(
    <div className="overlay" style={{alignItems:"flex-start",paddingTop:12,paddingBottom:12}}>
      <div className="modal" style={{padding:18}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
          <div style={{fontSize:16,fontWeight:800,color:T.heading}}>{initial?"Edit Small RO Plant":"Add Small RO Plant"}</div>
          <button style={{background:"transparent",color:T.muted,border:`1px solid ${T.border}`,borderRadius:7,padding:"5px 10px",fontSize:14,fontWeight:700,cursor:"pointer",fontFamily:T.font}} onClick={onClose}>✕</button>
        </div>
        <div className="g2" style={{gap:10}}>
          {[{l:"Client Name *",k:"clientName"},{l:"Location *",k:"plantLocation"},{l:"Plant Capacity",k:"capacity",p:"e.g. 150 GPD"},{l:"Doc / Contract No.",k:"docNo"},{l:"Contact No.",k:"contactNo"},{l:"Operator / Manager",k:"operatorManager"}].map(x=>(
            <div key={x.k} className="fg" style={{marginBottom:9}}><label>{x.l}</label><input value={f[x.k]||""} onChange={e=>set(x.k,e.target.value)} placeholder={x.p||""}/></div>
          ))}
          <div className="fg" style={{marginBottom:9}}><label>Emirate</label><select value={f.emirate} onChange={e=>set("emirate",e.target.value)}>{EMIRATES.map(e=><option key={e}>{e}</option>)}</select></div>
          <div className="fg" style={{marginBottom:9}}><label>Duration</label><select value={f.duration} onChange={e=>set("duration",e.target.value)}>{["1 year","2 year","3 year"].map(d=><option key={d}>{d}</option>)}</select></div>
          <div className="fg" style={{marginBottom:9}}><label>Contract Start</label><input type="date" value={f.contractStart} onChange={e=>set("contractStart",e.target.value)}/></div>
          <div className="fg" style={{marginBottom:9}}><label>Contract End</label><input type="date" value={f.contractEnd} onChange={e=>set("contractEnd",e.target.value)}/></div>
          <div className="fg" style={{marginBottom:9}}><label>Last Visit Date</label><input type="date" value={f.lastVisitDate} onChange={e=>set("lastVisitDate",e.target.value)}/></div>
          <div className="fg" style={{marginBottom:9}}><label>Status</label><select value={f.status||"active"} onChange={e=>set("status",e.target.value)}><option value="active">Active</option><option value="inactive">Inactive (did not renew)</option></select></div>
          {f.status==="inactive"&&<div className="fg" style={{marginBottom:9}}><label>Reason (optional)</label><input value={f.inactiveReason||""} onChange={e=>set("inactiveReason",e.target.value)} placeholder="e.g. did not renew"/></div>}
          <div className="fg" style={{marginBottom:9}}><label>Next Visit Due</label><input value={nextVisitDue(f)||"— set contract start or last visit"} disabled style={{opacity:.7}}/></div>
        </div>
        <div style={{background:T.surface,borderRadius:9,padding:12,marginBottom:12,border:`1px solid ${T.border}`}}>
          <div style={{fontSize:11,color:T.light,fontWeight:700,letterSpacing:1,marginBottom:9}}>📍 SITE LOCATION</div>
          <div className="fg" style={{marginBottom:9}}><label>Full Address</label><input value={f.address||""} onChange={e=>set("address",e.target.value)} placeholder="e.g. Al Khatem Area, Abu Dhabi, UAE"/></div>
          <div className="g2" style={{marginBottom:9}}>
            <div className="fg" style={{marginBottom:0}}><label>Latitude</label><input type="number" step="0.000001" value={f.lat||""} onChange={e=>set("lat",e.target.value)} placeholder="e.g. 24.192"/></div>
            <div className="fg" style={{marginBottom:0}}><label>Longitude</label><input type="number" step="0.000001" value={f.lng||""} onChange={e=>set("lng",e.target.value)} placeholder="e.g. 55.763"/></div>
          </div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            <button className="btn-p" style={{fontSize:12,padding:"7px 12px"}} onClick={getGPS}><Ic.GPS/> Use My GPS</button>
            <button className="btn-soft" style={{fontSize:12,padding:"7px 12px"}} onClick={()=>window.open(`https://maps.google.com?q=${encodeURIComponent(f.address||f.clientName)}`,"_blank")}><Ic.Map/> Google Maps</button>
          </div>
        </div>
        <div style={{display:"flex",gap:9}}>
          <button className="btn-p" style={{flex:1,justifyContent:"center"}} onClick={()=>{if(!f.clientName||!f.plantLocation)return alert("Client name & Location required");onSave({...f,inactiveSince:f.status==="inactive"?(f.inactiveSince||todayStr()):""});}}><Ic.Save/> Save</button>
          <button className="btn-soft" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

// ─── Small RO Plants Page (own dashboard + contracts) ──────────────────────
const SmallRO = ({customers,setCustomers,visits,setVisits,setVisitPhotos,touchVisit,user}) => {
  const [search,setSearch]=useState(""), [em,setEm]=useState("All"), [modal,setModal]=useState(null), [sortBy,setSortBy]=useState("name-asc");
  const [visitModal,setVisitModal]=useState(null);   // {contract, visit|null} — visit set when editing
  const [expandedVisits,setExpandedVisits]=useState(null); // contract id whose visit history is open
  const visitPhotoRef=useRef(null), visitPhotoTarget=useRef(null);
  const [visitPhotoBusy,setVisitPhotoBusy]=useState(false);
  const pickVisitPhotos=v=>{ visitPhotoTarget.current=v; visitPhotoRef.current&&visitPhotoRef.current.click(); };
  // Add photos to an already-saved visit report, any time, by anyone signed in
  const attachToVisit=async(v,files)=>{
    const list=Array.from(files||[]).slice(0,6);
    if(!list.length||!v) return;
    setVisitPhotoBusy(true);
    const ok=[];
    for(const file of list){ try{ ok.push(await compressImg(file,900)); }catch(e){ alert(e.message||"Could not add that photo"); } }
    if(ok.length){
      const cur=visits.find(x=>x.id===v.id)||v;
      const photos=[...(cur.photos||[]).filter(isValidPhoto),...ok].slice(0,8);
      if(setVisitPhotos(v.id,photos)!==false) showToast(`📷 ${ok.length} photo${ok.length>1?"s":""} added to ${v.reportNo}`,2500);
    }
    setVisitPhotoBusy(false);
  };
  const [cov,setCov]=useState("active");   // active | inactive | all
  const live=customers.filter(c=>!isInactive(c));        // inactive contracts are left out of every count and alert
  const total=live.length;
  const overdueList=live.filter(c=>{const d=daysUntil(nextVisitDue(c));return d!==null&&d<0;});
  const dueSoonList=live.filter(c=>{const d=daysUntil(nextVisitDue(c));return d!==null&&d>=0&&d<=14;});
  const activeCount=live.filter(c=>{const d=daysUntil(c.contractEnd);return d!==null&&d>0;}).length;
  const nInact=customers.filter(isInactive).length;
  const toggleActive=c=>{
    const to=isInactive(c)?"active":"inactive";
    if(!window.confirm(to==="inactive"?`Mark "${c.clientName}" as INACTIVE (did not renew)? It will be hidden from alerts. History is kept and you can reactivate it any time.`:`Reactivate "${c.clientName}"?`)) return;
    setCustomers(cs=>cs.map(x=>x.id===c.id?{...x,status:to,inactiveSince:to==="inactive"?todayStr():""}:x));
  };

  const filtered=customers
    .filter(c=>(cov==="all"?true:cov==="inactive"?isInactive(c):!isInactive(c))&&(em==="All"||c.emirate===em)&&((c.clientName||"").toLowerCase().includes(search.toLowerCase())||(c.plantLocation||"").toLowerCase().includes(search.toLowerCase())))
    .sort((a,b)=>{
      if(sortBy==="name-asc")  return (a.clientName||"").localeCompare(b.clientName||"");
      if(sortBy==="name-desc") return (b.clientName||"").localeCompare(a.clientName||"");
      const ms=d=>d?new Date(d).getTime():Infinity;
      if(sortBy==="visit-asc")  return ms(nextVisitDue(a))-ms(nextVisitDue(b));
      if(sortBy==="visit-desc") return ms(nextVisitDue(b))-ms(nextVisitDue(a));
      return 0;
    });
  const save=f=>{if(modal==="add")setCustomers(cs=>[...cs,{...f,id:uid()}]);else setCustomers(cs=>cs.map(c=>c.id===modal.id?{...f,id:c.id}:c));setModal(null);};

  // Keep the contract's "last visit" equal to its newest visit report (after add / edit / delete)
  const syncLastVisit=(contractId,list)=>{
    const ds=list.filter(v=>v.contractId===contractId).map(v=>v.date).filter(Boolean).sort();
    touchVisit(contractId, ds.length?ds[ds.length-1]:"");
  };
  const saveVisit=v=>{
    const exists=visits.some(x=>x.id===v.id);
    const next=exists?visits.map(x=>x.id===v.id?v:x):[...visits,v];
    setVisits(next);
    syncLastVisit(v.contractId,next);
    setVisitModal(null);
  };
  const deleteVisit=v=>{
    if(!window.confirm(`Delete report ${v.reportNo}? This cannot be undone.`)) return;
    const next=visits.filter(x=>x.id!==v.id);
    setVisits(next);
    syncLastVisit(v.contractId,next);
  };

  return(
    <div className="pg fade-up">
      <input ref={visitPhotoRef} type="file" accept="image/*" multiple style={{display:"none"}} onChange={e=>{attachToVisit(visitPhotoTarget.current,e.target.files);e.target.value="";}}/>
      <div style={{marginBottom:16}}>
        <div style={{fontSize:22,fontWeight:800,color:T.heading}}>Small RO Plants</div>
        <div style={{fontSize:12,color:T.muted}}>Clinics & homes · Quarterly maintenance contracts</div>
      </div>

      {overdueList.length>0&&(
        <div className="alert-pill" style={{background:T.danger+"18",border:`1px solid ${T.danger}44`,color:T.danger,cursor:"default"}}>
          <div style={{display:"flex",alignItems:"center",gap:8}}><Ic.Alert/>{overdueList.length} visit{overdueList.length>1?"s":""} OVERDUE</div>
        </div>
      )}
      {dueSoonList.length>0&&(
        <div className="alert-pill" style={{background:T.warn+"18",border:`1px solid ${T.warn}44`,color:T.warn,cursor:"default"}}>
          <div style={{display:"flex",alignItems:"center",gap:8}}><Ic.Bell/>{dueSoonList.length} visit{dueSoonList.length>1?"s":""} due within 14 days</div>
        </div>
      )}

      <div className="stat-grid" style={{marginBottom:16,marginTop:overdueList.length||dueSoonList.length?12:0}}>
        {[{l:"Total Plants",v:total,c:T.light,e:"💧"},{l:"Active Contracts",v:activeCount,c:T.accent2,e:"✅"},{l:"Visit Due ≤14d",v:dueSoonList.length,c:T.warn,e:"⏳"},{l:"Overdue Visits",v:overdueList.length,c:T.danger,e:"❌"}].map(s=>(
          <div key={s.l} className="card" style={{borderColor:s.c+"33"}}>
            <div style={{fontSize:11,marginBottom:4}}>{s.e}</div>
            <div style={{fontSize:34,fontWeight:800,color:s.c,fontFamily:T.mono,lineHeight:1}}>{s.v}</div>
            <div style={{fontSize:11,color:T.muted,marginTop:5,fontWeight:600}}>{s.l}</div>
          </div>
        ))}
      </div>

      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
        <div style={{fontSize:12,color:T.muted}}>{filtered.length} of {customers.length}</div>
        {user.role==="admin"&&<button className="btn-p" style={{padding:"8px 14px",fontSize:13}} onClick={()=>setModal("add")}><Ic.Plus/> Add Small RO Plant</button>}
      </div>
      <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="🔍 Search client or location…" style={{marginBottom:11}}/>
      <div style={{display:"flex",gap:6,overflowX:"auto",marginBottom:10,paddingBottom:4}}>
        {[["active","Active"],["inactive",`⏸ Inactive (${nInact})`],["all","All"]].map(([k,l])=><button key={k} onClick={()=>setCov(k)} className={cov===k?"chip on":"chip"}>{l}</button>)}
      </div>
      <div style={{display:"flex",gap:6,overflowX:"auto",marginBottom:14,paddingBottom:4}}>
        {["All",...EMIRATES].map(e=><button key={e} onClick={()=>setEm(e)} className={em===e?"chip on":"chip"}>{e}{e!=="All"?` (${customers.filter(c=>c.emirate===e).length})`:""}</button>)}
      </div>
      <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:12,flexWrap:"wrap"}}>
        <span style={{fontSize:12,color:T.muted,fontWeight:600,marginRight:2}}>Sort:</span>
        {[{v:"name-asc",l:"🔤 A→Z"},{v:"name-desc",l:"🔤 Z→A"},{v:"visit-asc",l:"📅 Visit Due ↑"},{v:"visit-desc",l:"📅 Visit Due ↓"}].map(o=>(
          <button key={o.v} onClick={()=>setSortBy(o.v)} className={sortBy===o.v?"chip on":"chip"}>{o.l}</button>
        ))}
      </div>

      {filtered.map(c=>{const inact=isInactive(c); const vb=inact?{label:"⏸ Inactive",color:T.muted}:visitBadge(nextVisitDue(c)); const cVisits=visits.filter(v=>v.contractId===c.id).sort((a,b)=>new Date(b.date)-new Date(a.date)); return(
        <div key={c.id} className="cc" style={inact?{opacity:.68,borderStyle:"dashed"}:{}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
            <div style={{flex:1}}>
              <div style={{fontWeight:700,fontSize:15,color:T.heading}}>{c.clientName}</div>
              {inact&&<div style={{fontSize:12,color:T.muted}}>⏸ Not renewed{c.inactiveSince?` · since ${c.inactiveSince}`:""}{c.inactiveReason?` · ${c.inactiveReason}`:""}</div>}
              <div style={{fontSize:12,color:T.muted,marginTop:3}}>📍 {c.plantLocation} · 🏛 {c.emirate}</div>
              <div style={{fontSize:12,color:T.muted}}>💧 {c.capacity||"—"} · 📋 {c.docNo||"—"}</div>
              <div style={{fontSize:12,color:T.muted}}>🗓 {c.contractStart||"—"} → {c.contractEnd||"—"} ({c.duration})</div>
              <div style={{fontSize:12,color:T.muted}}>🔁 Last visit: {c.lastVisitDate||"—"} · Next due: {nextVisitDue(c)||"—"}</div>
              {c.address&&<div style={{fontSize:12,color:T.muted}}>📌 {c.address}</div>}
              {c.lat&&c.lng&&<a href={`https://maps.google.com?q=${c.lat},${c.lng}`} target="_blank" rel="noopener noreferrer" style={{fontSize:11,color:T.accent,display:"block",marginTop:2,textDecoration:"none"}}>🗺 View on Maps ({Number(c.lat).toFixed(4)}, {Number(c.lng).toFixed(4)})</a>}
            </div>
            <span className="tag" style={{background:vb.color+"22",color:vb.color,border:`1px solid ${vb.color}33`,marginLeft:10,flexShrink:0}}>{vb.label}</span>
          </div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:user.role==="admin"?8:0}}>
            {!inact&&<button className="btn-p" style={{padding:"5px 12px",fontSize:12}} onClick={()=>setVisitModal({contract:c,visit:null})}><Ic.PDF/> New Visit Report</button>}
            {cVisits.length>0&&<button className="btn-soft" style={{padding:"5px 12px",fontSize:12}} onClick={()=>setExpandedVisits(x=>x===c.id?null:c.id)}>{expandedVisits===c.id?"▲ Hide":"▼"} History ({cVisits.length})</button>}
            {user.role==="admin"&&(<>
              <button className="btn-g" style={{padding:"5px 12px",fontSize:12}} onClick={()=>setModal(c)}><Ic.Edit/> Edit</button>
              <button className="btn-soft" style={{padding:"5px 12px",fontSize:12}} onClick={()=>toggleActive(c)}>{inact?"▶ Reactivate":"⏸ Mark inactive"}</button>
              <button className="btn-d" style={{padding:"5px 10px",fontSize:12}} onClick={()=>{if(window.confirm("Delete this Small RO plant? (It goes to the Recycle Bin for 30 days.)"))setCustomers(cs=>cs.filter(x=>x.id!==c.id));}}><Ic.Trash/></button>
            </>)}
          </div>
          {expandedVisits===c.id&&cVisits.map(v=>(
            <div key={v.id} className="rs" style={{marginTop:8}}>
              <div className="rn">{(v.submittedBy||"?").charAt(0)}</div>
              <div style={{flex:1}}>
                <div style={{fontSize:13,fontWeight:700,color:T.heading}}>{v.reportNo} · {v.date}</div>
                <div style={{fontSize:11,color:T.muted}}>{(v.workItems||[]).length} work item{(v.workItems||[]).length!==1?"s":""} · {(v.photos||[]).length} photo{(v.photos||[]).length!==1?"s":""} · By {v.submittedBy}{v.editedAt?" · edited":""}</div>
                {(v.photos||[]).length>0&&<div style={{marginTop:6}}><PhotoGrid photos={v.photos}/></div>}
                <div style={{display:"flex",gap:6,marginTop:7,flexWrap:"wrap"}}>
                  <button className="btn-p" style={{padding:"4px 10px",fontSize:11}} disabled={visitPhotoBusy} onClick={()=>pickVisitPhotos(v)}><Ic.Camera/> {visitPhotoBusy?"…":"Add photos"}</button>
                  <button className="btn-soft" style={{padding:"4px 10px",fontSize:11}} onClick={()=>exportSmallROVisitPDF(v)}><Ic.PDF/> PDF</button>
                  <button className="btn-wa" style={{padding:"4px 10px",fontSize:11}} onClick={()=>shareSmallROVisit(v,"whatsapp")}><Ic.WA/> WhatsApp</button>
                  <button className="btn-em" style={{padding:"4px 10px",fontSize:11}} onClick={()=>shareSmallROVisit(v,"email")}><Ic.Email/> Email</button>
                  {user.role==="admin"&&<button className="btn-g" style={{padding:"4px 10px",fontSize:11}} onClick={()=>setVisitModal({contract:c,visit:v})}><Ic.Edit/> Edit</button>}
                  {user.role==="admin"&&<button className="btn-d" style={{padding:"4px 8px",fontSize:11}} onClick={()=>deleteVisit(v)}><Ic.Trash/></button>}
                </div>
              </div>
            </div>
          ))}
        </div>
      );})}
      {filtered.length===0&&(
        <div style={{textAlign:"center",padding:"28px 20px",color:T.muted}}><div style={{fontSize:30,marginBottom:8}}>💧</div><div style={{fontSize:14,fontWeight:600}}>No Small RO plants yet</div></div>
      )}
      {modal&&<SmallROModal initial={modal==="add"?null:modal} onSave={save} onClose={()=>setModal(null)}/>}
      {visitModal&&<SmallROVisitModal contract={visitModal.contract} initial={visitModal.visit} allVisits={visits} techName={user.name} onSave={saveVisit} onClose={()=>setVisitModal(null)}/>}
    </div>
  );
};

// ─── Small RO Visit Report — on-site entry form (matches company template) ─
const SmallROVisitModal = ({contract,initial,allVisits,onSave,onClose,techName}) => {
  const [f,setF]=useState(initial ? {
    ...initial,
    workItems:(initial.workItems&&initial.workItems.length)?initial.workItems.map(w=>({...w,id:w.id||uid()})):[{id:uid(),text:"",date:""}],
    notes:(initial.notes&&initial.notes.length)?initial.notes:[""],
    photos:initial.photos||[],
    signature:initial.signature||"",
  } : {
    reportNo: nextSmallROReportNo(allVisits),
    date: todayStr(),
    clientName: contract.clientName,
    plantLocation: contract.emirate ? `${contract.plantLocation} – ${contract.emirate}` : contract.plantLocation,
    contractor: "Super Quality Trading, Al Ain",
    capacity: contract.capacity||"",
    operationManager: contract.operatorManager||"",
    workItems: [{id:uid(),text:"",date:""}],
    notes: [""],
    photos: [],
    signature: "",
  });
  const camRef=useRef(null), galRef=useRef(null);
  const [busy,setBusy]=useState(false);
  const addPhotos=async files=>{
    const list=Array.from(files||[]);
    if(!list.length) return;
    setBusy(true);
    const ok=[];
    for(const file of list.slice(0,6)){ try{ ok.push(await compressImg(file,900)); }catch(e){ alert(e.message||"Could not read that photo. Please try again."); } }
    setF(x=>({...x,photos:[...(x.photos||[]),...ok].slice(0,6)}));
    setBusy(false);
  };
  const set=(k,v)=>setF(x=>({...x,[k]:v}));
  const setItem=(id,k,v)=>setF(x=>({...x,workItems:x.workItems.map(w=>w.id===id?{...w,[k]:v}:w)}));
  const addItem=()=>setF(x=>({...x,workItems:[...x.workItems,{id:uid(),text:"",date:""}]}));
  const rmItem=id=>setF(x=>({...x,workItems:x.workItems.filter(w=>w.id!==id)}));
  const setNote=(i,v)=>setF(x=>({...x,notes:x.notes.map((n,idx)=>idx===i?v:n)}));
  const addNote=()=>setF(x=>({...x,notes:[...x.notes,""]}));
  const rmNote=i=>setF(x=>({...x,notes:x.notes.filter((_,idx)=>idx!==i)}));

  const submit=()=>{
    if(!f.clientName||!f.date) return alert("Client & Visit Date required");
    const workItems=f.workItems.filter(w=>w.text.trim());
    if(workItems.length===0) return alert("Add at least one completed work item");
    const body={...f, workItems, notes:f.notes.filter(n=>n.trim())};
    if(initial) onSave({...body, id:initial.id, contractId:initial.contractId, reportNo:initial.reportNo, submittedBy:initial.submittedBy, submittedAt:initial.submittedAt, editedAt:new Date().toISOString(), editedBy:techName});
    else onSave({...body, id:uid(), contractId:contract.id, submittedBy:techName, submittedAt:new Date().toISOString()});
  };

  return(
    <div className="overlay" style={{alignItems:"flex-start",paddingTop:12,paddingBottom:12}}>
      <div className="modal" style={{padding:18}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
          <div><div style={{fontSize:16,fontWeight:800,color:T.heading}}>{initial?"Edit Visit Report":"Maintenance Visit Report"}</div><div style={{fontSize:11,color:T.muted,fontFamily:T.mono}}>{f.reportNo}</div></div>
          <button style={{background:"transparent",color:T.muted,border:`1px solid ${T.border}`,borderRadius:7,padding:"5px 10px",fontSize:14,fontWeight:700,cursor:"pointer",fontFamily:T.font}} onClick={onClose}>✕</button>
        </div>

        <div className="g2" style={{gap:10}}>
          <div className="fg" style={{marginBottom:9}}><label>Client *</label><input value={f.clientName} onChange={e=>set("clientName",e.target.value)}/></div>
          <div className="fg" style={{marginBottom:9}}><label>Plant Location</label><input value={f.plantLocation} onChange={e=>set("plantLocation",e.target.value)}/></div>
          <div className="fg" style={{marginBottom:9}}><label>Contractor</label><input value={f.contractor} onChange={e=>set("contractor",e.target.value)}/></div>
          <div className="fg" style={{marginBottom:9}}><label>Plant Capacity</label><input value={f.capacity} onChange={e=>set("capacity",e.target.value)}/></div>
          <div className="fg" style={{marginBottom:9}}><label>Visit Date *</label><input type="date" value={f.date} onChange={e=>set("date",e.target.value)}/></div>
          <div className="fg" style={{marginBottom:9}}><label>Operation Manager</label><input value={f.operationManager} onChange={e=>set("operationManager",e.target.value)}/></div>
        </div>

        <div className="divr"><span>Maintenance Work Completed</span></div>
        {f.workItems.map((w,i)=>(
          <div key={w.id} style={{display:"flex",gap:6,marginBottom:7,alignItems:"center"}}>
            <span style={{fontSize:12,color:T.muted,width:16,flexShrink:0}}>{i+1}.</span>
            <input value={w.text} onChange={e=>setItem(w.id,"text",e.target.value)} placeholder="e.g. Changed PP filter" style={{flex:1}}/>
            <input type="date" value={w.date} onChange={e=>setItem(w.id,"date",e.target.value)} style={{width:140,flexShrink:0}}/>
            {f.workItems.length>1&&<button className="btn-d" style={{padding:"6px 8px",flexShrink:0}} onClick={()=>rmItem(w.id)}><Ic.Trash/></button>}
          </div>
        ))}
        <button className="btn-g" style={{fontSize:12,padding:"6px 12px",marginBottom:16}} onClick={addItem}><Ic.Plus/> Add Work Item</button>

        <div className="divr"><span>Notes</span></div>
        {f.notes.map((n,i)=>(
          <div key={i} style={{display:"flex",gap:6,marginBottom:7,alignItems:"center"}}>
            <span style={{fontSize:12,color:T.muted,width:12,flexShrink:0}}>—</span>
            <input value={n} onChange={e=>setNote(i,e.target.value)} placeholder="e.g. 1st visit as per maintenance contract" style={{flex:1}}/>
            {f.notes.length>1&&<button className="btn-d" style={{padding:"6px 8px",flexShrink:0}} onClick={()=>rmNote(i)}><Ic.Trash/></button>}
          </div>
        ))}
        <button className="btn-g" style={{fontSize:12,padding:"6px 12px",marginBottom:16}} onClick={addNote}><Ic.Plus/> Add Note</button>

        <div className="divr"><span>Site Photos</span></div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
          <button className="btn-soft" style={{fontSize:13}} disabled={busy||f.photos.length>=6} onClick={()=>camRef.current&&camRef.current.click()}><Ic.Camera/> Take Photo</button>
          <button className="btn-soft" style={{fontSize:13}} disabled={busy||f.photos.length>=6} onClick={()=>galRef.current&&galRef.current.click()}><Ic.Camera/> From Gallery</button>
        </div>
        <input ref={camRef} type="file" accept="image/*" capture="environment" style={{display:"none"}} onChange={e=>{addPhotos(e.target.files);e.target.value="";}}/>
        <input ref={galRef} type="file" accept="image/*" multiple style={{display:"none"}} onChange={e=>{addPhotos(e.target.files);e.target.value="";}}/>
        <div style={{fontSize:11,color:T.muted,marginTop:6}}>{busy?"Processing photo…":`${f.photos.length}/6 photos attached`}</div>
        {f.photos.length>0&&<div style={{marginBottom:14,marginTop:6}}><PhotoGrid photos={f.photos} onRemove={i=>setF(x=>({...x,photos:x.photos.filter((_,j)=>j!==i)}))}/></div>}

        <div className="divr"><span>Signature</span></div>
        {initial&&f.signature&&<div style={{marginBottom:8,fontSize:11,color:T.muted}}>Current signature (kept unless you sign again or remove it):<br/><img src={f.signature} alt="" style={{maxHeight:60,background:"#fff",borderRadius:6,border:`1px solid ${T.border}`,marginTop:4}}/> <button className="btn-d" style={{padding:"3px 8px",fontSize:11,marginLeft:6}} onClick={()=>set("signature","")}>Remove</button></div>}
        <SigPad onSave={v=>set("signature",v)} onClear={()=>{ if(!initial) set("signature",""); }}/>

        <div style={{display:"flex",gap:9,marginTop:18}}>
          <button className="btn-p" style={{flex:1,justifyContent:"center"}} disabled={busy} onClick={submit}><Ic.Save/> Save Report</button>
          <button className="btn-soft" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

// ─── Finance: contract payment plans, revenue & pending installments (ADMIN ONLY) ──
const money = n => Number(n||0).toLocaleString("en-US",{minimumFractionDigits:0,maximumFractionDigits:2});
const FREQ = {"Monthly":1,"Quarterly":3,"Half-yearly":6,"Yearly":12};
const addMonthsStr = (dateStr,m) => {
  if(!dateStr) return "";
  const [y,mo,d]=dateStr.split("-").map(Number);
  const t=new Date(Date.UTC(y,mo-1+m,1));
  const last=new Date(Date.UTC(t.getUTCFullYear(),t.getUTCMonth()+1,0)).getUTCDate();
  t.setUTCDate(Math.min(d,last));
  return t.toISOString().split("T")[0];
};
// VAT (UAE standard rate 5%). Each plan stores vatRate and vatMode:
//   "excl" = amounts entered are BEFORE VAT (VAT is added on top when invoiced)
//   "incl" = amounts entered already INCLUDE VAT
// Revenue is reported NET (ex VAT); VAT is tracked separately as a liability.
const r2 = n => Math.round((Number(n)||0)*100)/100;
const vatSplit = (amount, rate, mode) => {
  const a=Number(amount)||0, r=(Number(rate)||0)/100;
  if(mode==="incl"){ const gross=r2(a), net=r2(gross/(1+r)); return {net, vat:r2(gross-net), gross}; }
  const net=r2(a), vat=r2(net*r); return {net, vat, gross:r2(net+vat)};
};
const planVat = p => ({rate:Number(p.vatRate)||0, mode:p.vatMode==="incl"?"incl":"excl"});
const addS = (a,b) => ({net:r2(a.net+b.net), vat:r2(a.vat+b.vat), gross:r2(a.gross+b.gross)});
const ZERO_S = {net:0,vat:0,gross:0};
const sumSplit = (arr,p) => { const {rate,mode}=planVat(p); return arr.reduce((t,i)=>addS(t,vatSplit(i.amount,rate,mode)),ZERO_S); };
const planStats = p => {
  const ins=p.installments||[], {rate,mode}=planVat(p);
  const unpaid=ins.filter(i=>!i.paid);
  const overdue=unpaid.filter(i=>i.dueDate&&daysUntil(i.dueDate)<0);
  const next=unpaid.slice().sort((a,b)=>(a.dueDate||"").localeCompare(b.dueDate||""))[0]||null;
  return {total:vatSplit(p.totalValue,rate,mode), paid:sumSplit(ins.filter(i=>i.paid),p), pending:sumSplit(unpaid,p),
          scheduled:sumSplit(ins,p), overdue:sumSplit(overdue,p), overdueCount:overdue.length, next, rate, mode};
};
// Overdue instalments across all plans (used by the Home alert and the Finance tab badge)
const overduePayments = plans => {
  let count=0, gross=ZERO_S;
  (plans||[]).forEach(p=>{ const {rate,mode}=planVat(p);
    (p.installments||[]).forEach(i=>{ if(!i.paid&&i.dueDate&&daysUntil(i.dueDate)<0){ count++; gross=addS(gross,vatSplit(i.amount,rate,mode)); } }); });
  return {count, gross:gross.gross};
};
const instBadge = i => {
  if(i.paid) return {label:`Paid ${i.paidDate||""}`.trim(),color:T.accent2};
  const d=daysUntil(i.dueDate);
  if(d===null) return {label:"No date",color:T.muted};
  if(d<0)   return {label:`${Math.abs(d)}d OVERDUE`,color:T.danger};
  if(d<=14) return {label:`Due in ${d}d`,color:T.warn};
  return {label:`Due ${i.dueDate}`,color:T.accent};
};
const csvCell = v => { let t=String(v??""); if(/^[=+\-@\t\r]/.test(t)) t="'"+t; return /[",\n]/.test(t)?`"${t.replace(/"/g,'""')}"`:t; };
const exportFinanceCSV = plans => {
  const rows=[["Client","Type","Contract value as entered (AED)","VAT rate %","Amounts entered","Installment #","Due date","Net (AED)","VAT (AED)","Gross incl. VAT (AED)","Status","Paid date","Reference"]];
  plans.forEach(p=>{ const {rate,mode}=planVat(p); (p.installments||[]).forEach((i,k)=>{ const x=vatSplit(i.amount,rate,mode); rows.push([p.clientName,p.contractType==="plant"?"Plant AMC":p.contractType==="smallro"?"Small RO":"Other",p.totalValue,rate,mode==="incl"?"incl. VAT":"excl. VAT",k+1,i.dueDate,x.net,x.vat,x.gross,i.paid?"Paid":"Pending",i.paidDate||"",i.ref||""]); }); });
  const blob=new Blob(["\ufeff"+rows.map(r=>r.map(csvCell).join(",")).join("\n")],{type:"text/csv;charset=utf-8"});
  const url=URL.createObjectURL(blob); const a=document.createElement("a");
  a.href=url; a.download=`sq-payments-${todayStr()}.csv`; document.body.appendChild(a); a.click(); a.remove(); setTimeout(()=>URL.revokeObjectURL(url),4000);
};

const PayModal = ({label,onSave,onClose}) => {
  const [d,setD]=useState(todayStr()), [ref,setRef]=useState("");
  return(
    <div className="overlay" style={{zIndex:1500}}>
      <div className="modal" style={{maxWidth:380,padding:18}}>
        <div style={{fontSize:16,fontWeight:800,color:T.heading,marginBottom:4}}>Mark as paid</div>
        <div style={{fontSize:12,color:T.muted,marginBottom:12}}>{label}</div>
        <div className="fg"><label>Date received</label><input type="date" value={d} onChange={e=>setD(e.target.value)}/></div>
        <div className="fg"><label>Reference (receipt / cheque / transfer no.)</label><input value={ref} onChange={e=>setRef(e.target.value)} placeholder="optional"/></div>
        <div style={{display:"flex",gap:9}}>
          <button className="btn-p" style={{flex:1,justifyContent:"center"}} onClick={()=>{ if(!d) return alert("Pick the date received"); onSave(d,ref.trim()); }}><Ic.Save/> Save</button>
          <button className="btn-soft" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

const PlanModal = ({initial,plants,smallRO,onSave,onClose}) => {
  const blank={contractType:"plant",contractId:"",clientName:"",totalValue:"",vatRate:"5",vatMode:"excl",installments:[],notes:""};
  const [f,setF]=useState(initial?{...initial,totalValue:String(initial.totalValue??""),vatRate:String(initial.vatRate??0),vatMode:initial.vatMode==="incl"?"incl":"excl",notes:initial.notes||"",installments:(initial.installments||[]).map(i=>({...i,id:i.id||uid(),amount:String(i.amount??"")}))}:blank);
  const [gen,setGen]=useState({count:4,first:todayStr(),freq:"Quarterly"});
  const sel=f.contractType==="other"?"other":(f.contractId?`${f.contractType}:${f.contractId}`:"");
  const pick=v=>{
    if(v==="other"){ setF(x=>({...x,contractType:"other",contractId:"",clientName:x.contractType==="other"?x.clientName:""})); return; }
    if(!v){ setF(x=>({...x,contractId:"",clientName:""})); return; }
    const k=v.indexOf(":"), t=v.slice(0,k), id=v.slice(k+1);
    const c=(t==="plant"?plants:smallRO).find(x=>x.id===id);
    setF(x=>({...x,contractType:t,contractId:id,clientName:t==="plant"?(c?.name||""):(c?.clientName||"")}));
  };
  const setIns=(id,k,v)=>setF(x=>({...x,installments:x.installments.map(i=>i.id===id?{...i,[k]:v}:i)}));
  const sumIns=f.installments.reduce((t,i)=>t+(Number(i.amount)||0),0);
  const generate=()=>{
    const totalC=Math.round(Number(f.totalValue)*100);
    if(!(totalC>0)) return alert("Enter the total contract value first");
    if(f.installments.some(i=>i.paid)) return alert("Some installments are already marked paid — edit the rows by hand instead.");
    if(!gen.first) return alert("Pick the first due date");
    const n=Math.max(1,Math.min(24,parseInt(gen.count)||1)), step=FREQ[gen.freq], eachC=Math.floor(totalC/n);
    const rows=[]; for(let k=0;k<n;k++){ const c=k===n-1?totalC-eachC*(n-1):eachC; rows.push({id:uid(),dueDate:addMonthsStr(gen.first,step*k),amount:String(c/100),paid:false,paidDate:"",ref:""}); }
    setF(x=>({...x,installments:rows}));
  };
  const submit=()=>{
    if(!f.clientName.trim()) return alert("Choose a contract or type the client name");
    const total=Number(f.totalValue);
    if(!(total>0)) return alert("Enter the total contract value");
    const vr=Number(f.vatRate);
    if(isNaN(vr)||vr<0||vr>100) return alert("VAT rate must be between 0 and 100");
    if(f.installments.length===0) return alert("Add at least one installment (use Generate, or Add row)");
    const ins=f.installments.map(i=>({id:i.id,dueDate:i.dueDate,amount:Number(i.amount),paid:!!i.paid,paidDate:i.paid?(i.paidDate||todayStr()):"",ref:i.ref||""}));
    if(ins.some(i=>!i.dueDate||isNaN(i.amount)||i.amount<0)) return alert("Every installment needs a due date and a valid amount");
    const diff=Math.round((ins.reduce((t,i)=>t+i.amount,0)-total)*100)/100;
    if(diff!==0 && !window.confirm(`Installments total AED ${money(total+diff)} but the contract value is AED ${money(total)} (difference ${money(diff)}). Save anyway?`)) return;
    ins.sort((a,b)=>a.dueDate.localeCompare(b.dueDate));
    onSave({...(initial||{}),id:initial?.id||uid(),contractType:f.contractType,contractId:f.contractId,clientName:f.clientName.trim(),totalValue:total,vatRate:vr,vatMode:f.vatMode,installments:ins,notes:(f.notes||"").trim(),createdAt:initial?.createdAt||new Date().toISOString()});
  };
  return(
    <div className="overlay" style={{alignItems:"flex-start",paddingTop:12,paddingBottom:12}}>
      <div className="modal" style={{padding:18}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
          <div style={{fontSize:16,fontWeight:800,color:T.heading}}>{initial?"Edit Payment Plan":"New Payment Plan"}</div>
          <button style={{background:"transparent",color:T.muted,border:`1px solid ${T.border}`,borderRadius:7,padding:"5px 10px",fontSize:14,fontWeight:700,cursor:"pointer",fontFamily:T.font}} onClick={onClose}>✕</button>
        </div>
        <div className="fg"><label>Contract *</label>
          <select value={sel} onChange={e=>pick(e.target.value)}>
            <option value="">— choose —</option>
            {plants.length>0&&<optgroup label="Plants">{plants.map(c=><option key={c.id} value={`plant:${c.id}`}>{c.name}{isInactive(c)?" (inactive)":isWarranty(c)?" (warranty)":""}</option>)}</optgroup>}
            {smallRO.length>0&&<optgroup label="Small RO">{smallRO.map(c=><option key={c.id} value={`smallro:${c.id}`}>{c.clientName}</option>)}</optgroup>}
            <option value="other">Other / not in the list…</option>
          </select></div>
        {f.contractType==="other"&&<div className="fg"><label>Client name *</label><input value={f.clientName} onChange={e=>setF(x=>({...x,clientName:e.target.value}))}/></div>}
        <div className="fg"><label>Total contract value (AED) *</label><input type="number" inputMode="decimal" step="0.01" value={f.totalValue} onChange={e=>setF(x=>({...x,totalValue:e.target.value}))} placeholder="e.g. 4800"/></div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
          <div className="fg" style={{width:110}}><label>VAT rate %</label><input type="number" inputMode="decimal" step="0.01" value={f.vatRate} onChange={e=>setF(x=>({...x,vatRate:e.target.value}))}/></div>
          <div className="fg" style={{flex:1,minWidth:200}}><label>Amounts I enter are…</label>
            <select value={f.vatMode} onChange={e=>setF(x=>({...x,vatMode:e.target.value}))}>
              <option value="excl">Before VAT (VAT added on top)</option>
              <option value="incl">Already including VAT</option>
            </select></div>
        </div>
        {Number(f.totalValue)>0&&(()=>{const v=vatSplit(f.totalValue,f.vatRate,f.vatMode);return <div style={{fontSize:12,color:T.muted,marginBottom:10}}>Contract: net <b style={{color:T.heading}}>{money(v.net)}</b> + VAT <b style={{color:T.heading}}>{money(v.vat)}</b> = <b style={{color:T.heading}}>AED {money(v.gross)}</b> incl. VAT</div>;})()}

        <div className="divr"><span>Installments</span></div>
        <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:9,padding:10,marginBottom:10}}>
          <div style={{fontSize:11,color:T.muted,fontWeight:700,marginBottom:6}}>QUICK GENERATE (equal split)</div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"flex-end"}}>
            <div style={{width:70}}><label style={{fontSize:11,color:T.muted}}>Count</label><input type="number" min="1" max="24" value={gen.count} onChange={e=>setGen(g=>({...g,count:e.target.value}))}/></div>
            <div style={{flex:1,minWidth:130}}><label style={{fontSize:11,color:T.muted}}>First due date</label><input type="date" value={gen.first} onChange={e=>setGen(g=>({...g,first:e.target.value}))}/></div>
            <div style={{flex:1,minWidth:110}}><label style={{fontSize:11,color:T.muted}}>Every</label><select value={gen.freq} onChange={e=>setGen(g=>({...g,freq:e.target.value}))}>{Object.keys(FREQ).map(k=><option key={k}>{k}</option>)}</select></div>
            <button className="btn-g" style={{padding:"9px 12px"}} onClick={generate}>Generate</button>
          </div>
        </div>
        {f.installments.map((i,k)=>(
          <div key={i.id} style={{border:`1px solid ${T.border}`,borderRadius:9,padding:8,marginBottom:7}}>
            <div style={{display:"flex",gap:6,alignItems:"center"}}>
              <span style={{fontSize:12,color:T.muted,width:18}}>{k+1}.</span>
              <input type="date" value={i.dueDate} onChange={e=>setIns(i.id,"dueDate",e.target.value)} style={{flex:1,minWidth:0}}/>
              <input type="number" inputMode="decimal" step="0.01" value={i.amount} onChange={e=>setIns(i.id,"amount",e.target.value)} placeholder="AED" style={{width:100}}/>
              <button className="btn-d" style={{padding:"6px 8px"}} onClick={()=>setF(x=>({...x,installments:x.installments.filter(y=>y.id!==i.id)}))}><Ic.Trash/></button>
            </div>
            {Number(i.amount)>0&&Number(f.vatRate)>0&&(()=>{const v=vatSplit(i.amount,f.vatRate,f.vatMode);return <div style={{fontSize:11,color:T.muted,marginTop:4,marginLeft:24}}>net {money(v.net)} + VAT {money(v.vat)} = <b>{money(v.gross)}</b> incl. VAT</div>;})()}
            <label style={{display:"flex",alignItems:"center",gap:8,marginTop:6,fontSize:12,color:T.muted,cursor:"pointer"}}>
              <input type="checkbox" checked={!!i.paid} onChange={e=>setF(x=>({...x,installments:x.installments.map(y=>y.id===i.id?{...y,paid:e.target.checked,paidDate:e.target.checked?(y.paidDate||todayStr()):""}:y)}))} style={{width:18,height:18}}/>
              Paid
              {i.paid&&<input type="date" value={i.paidDate||""} onChange={e=>setIns(i.id,"paidDate",e.target.value)} style={{flex:1,minWidth:0}}/>}
            </label>
          </div>
        ))}
        <button className="btn-g" style={{fontSize:12,padding:"6px 12px",marginBottom:8}} onClick={()=>setF(x=>({...x,installments:[...x.installments,{id:uid(),dueDate:"",amount:"",paid:false,paidDate:"",ref:""}]}))}><Ic.Plus/> Add row</button>
        <div style={{fontSize:12,marginBottom:12,color:Math.round((sumIns-(Number(f.totalValue)||0))*100)===0?T.accent2:T.warn}}>
          Installments total: AED {money(sumIns)} {Number(f.totalValue)>0&&Math.round((sumIns-Number(f.totalValue))*100)!==0&&`· differs from contract value by ${money(sumIns-Number(f.totalValue))}`}
        </div>
        <div className="fg"><label>Notes</label><input value={f.notes} onChange={e=>setF(x=>({...x,notes:e.target.value}))} placeholder="optional"/></div>
        <div style={{display:"flex",gap:9,marginTop:6}}>
          <button className="btn-p" style={{flex:1,justifyContent:"center"}} onClick={submit}><Ic.Save/> Save Plan</button>
          <button className="btn-soft" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

const Finance = ({plans,setPlans,plants,smallRO}) => {
  const [filter,setFilter]=useState("all"), [search,setSearch]=useState(""), [modal,setModal]=useState(null), [open,setOpen]=useState(null), [pay,setPay]=useState(null);
  const rows=plans.map(p=>({p,s:planStats(p)}));
  const T0=rows.reduce((a,{s})=>({total:addS(a.total,s.total),paid:addS(a.paid,s.paid),pending:addS(a.pending,s.pending),overdue:addS(a.overdue,s.overdue),overdueCount:a.overdueCount+s.overdueCount,unscheduled:r2(a.unscheduled+Math.max(0,s.total.gross-s.scheduled.gross))}),{total:ZERO_S,paid:ZERO_S,pending:ZERO_S,overdue:ZERO_S,overdueCount:0,unscheduled:0});
  const due30=rows.reduce((t,{p})=>{const {rate,mode}=planVat(p);return t+(p.installments||[]).filter(i=>!i.paid&&i.dueDate&&daysUntil(i.dueDate)>=0&&daysUntil(i.dueDate)<=30).reduce((x,i)=>x+vatSplit(i.amount,rate,mode).gross,0);},0);

  // collected REVENUE (net of VAT) per month — last 6 months
  const months=[]; { const n=new Date(); for(let k=5;k>=0;k--){ const d=new Date(n.getFullYear(),n.getMonth()-k,1); months.push({key:`${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}`,label:d.toLocaleString("en-GB",{month:"short"}),v:0}); } }
  plans.forEach(p=>{ const {rate,mode}=planVat(p); (p.installments||[]).forEach(i=>{ if(i.paid&&i.paidDate){ const m=months.find(x=>x.key===i.paidDate.slice(0,7)); if(m) m.v+=vatSplit(i.amount,rate,mode).net; } }); });
  const maxV=Math.max(1,...months.map(m=>m.v));

  const shown=rows.filter(({p,s})=>{
    if(search&&!(p.clientName||"").toLowerCase().includes(search.toLowerCase())) return false;
    if(filter==="overdue") return s.overdueCount>0;
    if(filter==="due30")   return (p.installments||[]).some(i=>!i.paid&&i.dueDate&&daysUntil(i.dueDate)>=0&&daysUntil(i.dueDate)<=30);
    if(filter==="pending") return s.pending.gross>0;
    if(filter==="paid")    return s.pending.gross===0&&(p.installments||[]).length>0;
    return true;
  }).sort((a,b)=>(a.s.next?.dueDate||"9999").localeCompare(b.s.next?.dueDate||"9999"));

  const savePlan=p=>{ setPlans(ps=>ps.some(x=>x.id===p.id)?ps.map(x=>x.id===p.id?p:x):[...ps,p]); setModal(null); };
  const markPaid=(date,ref)=>{ const {pid,iid}=pay; setPlans(ps=>ps.map(p=>p.id===pid?{...p,installments:p.installments.map(i=>i.id===iid?{...i,paid:true,paidDate:date,ref}:i)}:p)); setPay(null); };
  const undoPaid=(pid,iid)=>{ if(!window.confirm("Mark this installment as NOT paid?")) return; setPlans(ps=>ps.map(p=>p.id===pid?{...p,installments:p.installments.map(i=>i.id===iid?{...i,paid:false,paidDate:"",ref:""}:i)}:p)); };
  const delPlan=p=>{ if(window.confirm(`Delete the payment plan for ${p.clientName}? It goes to the Recycle Bin (Settings) for 30 days.`)) setPlans(ps=>ps.filter(x=>x.id!==p.id)); };
  const typeLabel=t=>t==="plant"?"Plant AMC":t==="smallro"?"Small RO":"Other";

  return(
    <div className="pg fade-up">
      <div style={{marginBottom:16,display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:10,flexWrap:"wrap"}}>
        <div><div style={{fontSize:22,fontWeight:800,color:T.heading}}>Finance</div><div style={{fontSize:12,color:T.muted}}>Contract revenue & installments · Admin only · AED</div></div>
        <div style={{display:"flex",gap:8}}>
          {plans.length>0&&<button className="btn-soft" style={{padding:"8px 12px",fontSize:12}} onClick={()=>exportFinanceCSV(plans)}>⬇ CSV</button>}
          <button className="btn-p" style={{padding:"8px 14px",fontSize:13}} onClick={()=>setModal("add")}><Ic.Plus/> New Plan</button>
        </div>
      </div>

      {T0.overdueCount>0&&(
        <div className="alert-pill" style={{background:T.danger+"18",border:`1px solid ${T.danger}44`,color:T.danger,cursor:"pointer",marginBottom:12}} onClick={()=>setFilter("overdue")}>
          <div style={{display:"flex",alignItems:"center",gap:8}}><Ic.Alert/>{T0.overdueCount} overdue installment{T0.overdueCount>1?"s":""} · AED {money(T0.overdue.gross)} incl. VAT</div>
        </div>
      )}

      <div className="stat-grid" style={{marginBottom:14}}>
        {[{l:"Contract value (ex VAT)",v:T0.total.net,sub:`VAT ${money(T0.total.vat)} · incl. ${money(T0.total.gross)}`,c:T.light,e:"📑"},
          {l:"Revenue collected (ex VAT)",v:T0.paid.net,sub:`+ VAT ${money(T0.paid.vat)} = cash ${money(T0.paid.gross)}`,c:T.accent2,e:"✅"},
          {l:"Pending (incl. VAT)",v:T0.pending.gross,sub:`of which VAT ${money(T0.pending.vat)}`,c:T.warn,e:"⏳"},
          {l:"Overdue (incl. VAT)",v:T0.overdue.gross,sub:`${T0.overdueCount} installment${T0.overdueCount!==1?"s":""}`,c:T.danger,e:"❌"}].map(x=>(
          <div key={x.l} className="card" style={{borderColor:x.c+"33"}}>
            <div style={{fontSize:11,marginBottom:4}}>{x.e}</div>
            <div style={{fontSize:22,fontWeight:800,color:x.c,fontFamily:T.mono,lineHeight:1.1,wordBreak:"break-all"}}>{money(x.v)}</div>
            <div style={{fontSize:11,color:T.muted,marginTop:5,fontWeight:600}}>{x.l}</div>
            <div style={{fontSize:10,color:T.muted,marginTop:2}}>{x.sub}</div>
          </div>
        ))}
      </div>
      <div style={{fontSize:12,color:T.muted,marginBottom:14,display:"flex",gap:14,flexWrap:"wrap"}}>
        <span>Due in next 30 days: <b style={{color:T.heading}}>AED {money(due30)}</b> incl. VAT</span>
        {T0.unscheduled>0&&<span>Not yet scheduled: <b style={{color:T.heading}}>AED {money(T0.unscheduled)}</b> incl. VAT</span>}
      </div>

      <div className="card" style={{marginBottom:14}}>
        <div className="sec-lbl">Revenue collected per month (ex VAT)</div>
        <div style={{display:"flex",alignItems:"flex-end",gap:8,height:110,marginTop:8}}>
          {months.map(m=>(
            <div key={m.key} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"flex-end",height:"100%"}}>
              <div style={{fontSize:9,color:T.muted,marginBottom:2,fontFamily:T.mono}}>{m.v?money(m.v):""}</div>
              <div style={{width:"100%",maxWidth:38,height:`${Math.max(m.v?6:2,(m.v/maxV)*80)}px`,background:m.v?T.accent2:T.border,borderRadius:"5px 5px 0 0"}}/>
              <div style={{fontSize:10,color:T.muted,marginTop:4}}>{m.label}</div>
            </div>
          ))}
        </div>
      </div>

      <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="🔍 Search client…" style={{marginBottom:10}}/>
      <div style={{display:"flex",gap:6,overflowX:"auto",marginBottom:14,paddingBottom:4}}>
        {[["all","All"],["overdue","Overdue"],["due30","Due ≤30d"],["pending","Has pending"],["paid","Fully paid"]].map(([k,l])=><button key={k} onClick={()=>setFilter(k)} className={filter===k?"chip on":"chip"}>{l}</button>)}
      </div>

      {shown.map(({p,s})=>{
        const pct=s.total.gross>0?Math.min(100,Math.round(s.paid.gross/s.total.gross*100)):0;
        const nb=s.next?instBadge(s.next):null;
        return(
          <div key={p.id} className="cc">
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8}}>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontWeight:700,fontSize:15,color:T.heading}}>{p.clientName}</div>
                <div style={{fontSize:11,color:T.muted,marginTop:2}}>{typeLabel(p.contractType)} · {(p.installments||[]).length} installment{(p.installments||[]).length!==1?"s":""}</div>
              </div>
              {nb?<span className="tag" style={{background:nb.color+"22",color:nb.color,border:`1px solid ${nb.color}33`,flexShrink:0}}>{nb.label}</span>:<span className="tag" style={{background:T.accent2+"22",color:T.accent2,border:`1px solid ${T.accent2}33`}}>Fully paid</span>}
            </div>
            <div style={{display:"flex",gap:14,flexWrap:"wrap",fontSize:12,color:T.muted,margin:"8px 0 6px"}}>
              <span>Total <b style={{color:T.heading}}>{money(s.total.gross)}</b></span>
              <span>Collected <b style={{color:T.accent2}}>{money(s.paid.gross)}</b></span>
              <span>Pending <b style={{color:T.warn}}>{money(s.pending.gross)}</b></span>
              {s.overdue.gross>0&&<span>Overdue <b style={{color:T.danger}}>{money(s.overdue.gross)}</b></span>}
            </div>
            <div style={{fontSize:10,color:T.muted,margin:"-2px 0 6px"}}>{s.rate>0?`Amounts incl. ${s.rate}% VAT · revenue ex VAT ${money(s.total.net)} · VAT ${money(s.total.vat)}`:"No VAT applied"}</div>
            <div style={{height:7,background:T.border,borderRadius:4,overflow:"hidden",marginBottom:10}}><div style={{width:`${pct}%`,height:"100%",background:T.accent2}}/></div>
            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
              <button className="btn-soft" style={{padding:"5px 12px",fontSize:12}} onClick={()=>setOpen(o=>o===p.id?null:p.id)}>{open===p.id?"▲ Hide":"▼ Installments"}</button>
              <button className="btn-g" style={{padding:"5px 12px",fontSize:12}} onClick={()=>setModal(p)}><Ic.Edit/> Edit</button>
              <button className="btn-d" style={{padding:"5px 10px",fontSize:12}} onClick={()=>delPlan(p)}><Ic.Trash/></button>
            </div>
            {open===p.id&&(p.installments||[]).map((i,k)=>{const b=instBadge(i);const v=vatSplit(i.amount,s.rate,s.mode);return(
              <div key={i.id} className="rs" style={{marginTop:8,alignItems:"center"}}>
                <div className="rn">{k+1}</div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:13,fontWeight:700,color:T.heading}}>AED {money(v.gross)} <span style={{fontSize:11,color:T.muted,fontWeight:400}}>· due {i.dueDate||"—"}</span></div>
                  {v.vat>0&&<div style={{fontSize:10,color:T.muted}}>net {money(v.net)} + VAT {money(v.vat)}</div>}
                  <div style={{fontSize:11,color:b.color,fontWeight:700}}>{b.label}{i.ref?<span style={{color:T.muted,fontWeight:400}}> · Ref {i.ref}</span>:null}</div>
                </div>
                {i.paid?<button className="btn-soft" style={{padding:"4px 10px",fontSize:11}} onClick={()=>undoPaid(p.id,i.id)}>Undo</button>
                       :<button className="btn-p" style={{padding:"4px 10px",fontSize:11}} onClick={()=>setPay({pid:p.id,iid:i.id,label:`${p.clientName} · installment ${k+1} · AED ${money(v.gross)}${v.vat>0?" incl. VAT":""}`})}>Mark paid</button>}
              </div>);})}
            {open===p.id&&p.notes&&<div style={{fontSize:12,color:T.muted,marginTop:8}}>📝 {p.notes}</div>}
          </div>
        );
      })}
      {shown.length===0&&(
        <div style={{textAlign:"center",padding:"28px 20px",color:T.muted}}><div style={{fontSize:30,marginBottom:8}}>💰</div><div style={{fontSize:14,fontWeight:600}}>{plans.length===0?"No payment plans yet — tap New Plan":"Nothing matches this filter"}</div></div>
      )}
      {modal&&<PlanModal initial={modal==="add"?null:modal} plants={plants} smallRO={smallRO} onSave={savePlan} onClose={()=>setModal(null)}/>}
      {pay&&<PayModal label={pay.label} onSave={markPaid} onClose={()=>setPay(null)}/>}
    </div>
  );
};

// ─── Route Planner ──────────────────────────────────────────────────────────
const Route = ({customers,setCustomers,reports,user}) => {
  const [em,setEm]=useState("Abu Dhabi");
  const [editLoc,setEditLoc]=useState(null);
  const [tempLoc,setTempLoc]=useState({});
  const [selected,setSelected]=useState(new Set());   // selected plant IDs
  const [sortMode,setSortMode]=useState("auto");       // "auto" | "manual"
  const [visited,setVisited]=useState(new Set());      // visited during this session

  const EC={"Abu Dhabi":{lat:24.2,lng:55.7},"Dubai":{lat:25.2,lng:55.27},"Sharjah":{lat:25.35,lng:55.41},"Ajman":{lat:25.4,lng:55.44},"Ras Al Khaimah":{lat:25.78,lng:55.94},"Fujairah":{lat:25.12,lng:56.34},"Umm Al Quwain":{lat:25.55,lng:55.55}};

  const liveCustomers = customers.filter(c=>!isInactive(c));   // inactive plants are never routed
  const allPlants = liveCustomers.filter(c=>c.emirate===em&&c.lat&&c.lng);
  const noGPS    = liveCustomers.filter(c=>c.emirate===em&&(!c.lat||!c.lng));

  // Check if a plant has a report today
  const todayVisited = p => { const today=reports.filter(r=>r.customerId===p.id&&r.date===todayStr()); const ms=machinesOf(p); return ms.length ? ms.every(m=>today.some(r=>r.machineId===m.id)) : today.length>0; };

  // Optimize route via nearest-neighbor
  const optimize=pts=>{
    if(!pts.length) return [];
    const start=EC[em]||{lat:24.2,lng:55.7};
    const rem=[...pts];
    const route=[];
    let curLat=start.lat, curLng=start.lng;
    while(rem.length){
      const lat=curLat, lng=curLng;
      let ni=0, md=Infinity;
      for(let i=0;i<rem.length;i++){
        const d=Math.hypot(rem[i].lat-lat, rem[i].lng-lng);
        if(d<md){md=d;ni=i;}
      }
      route.push(rem[ni]);
      curLat=rem[ni].lat;
      curLng=rem[ni].lng;
      rem.splice(ni,1);
    }
    return route;
  };

  // Determine which plants to route
  const routePlants = selected.size>0
    ? allPlants.filter(p=>selected.has(p.id))
    : allPlants;
  const route = sortMode==="auto" ? optimize(routePlants) : routePlants;

  const toggleSelect = id => setSelected(prev=>{const n=new Set(prev);n.has(id)?n.delete(id):n.add(id);return n;});
  const selectAll    = () => setSelected(new Set(allPlants.map(p=>p.id)));
  const clearAll     = () => setSelected(new Set());
  const toggleVisited= id => setVisited(prev=>{const n=new Set(prev);n.has(id)?n.delete(id):n.add(id);return n;});

  const openEdit=p=>{setEditLoc(p);setTempLoc({lat:p.lat||"",lng:p.lng||"",address:p.address||""});};
  const getGPS=()=>{
    if(!navigator.geolocation){alert("GPS not available");return;}
    navigator.geolocation.getCurrentPosition(
      pos=>{setTempLoc(t=>({...t,lat:pos.coords.latitude.toFixed(6),lng:pos.coords.longitude.toFixed(6)}));},
      ()=>alert("Could not get GPS location")
    );
  };
  const saveLocation=()=>{
    setCustomers(cs=>cs.map(c=>c.id===editLoc.id?{...c,lat:tempLoc.lat,lng:tempLoc.lng,address:tempLoc.address}:c));
    setEditLoc(null);
  };

  const doneCount = route.filter(s=>visited.has(s.id)||todayVisited(s)).length;

  return(
    <div className="pg fade-up">
      {/* Header */}
      <div style={{marginBottom:12}}>
        <div style={{fontSize:22,fontWeight:800,color:T.heading}}>Route Planner</div>
        <div style={{fontSize:12,color:T.muted}}>Select plants · optimize route · track visits</div>
      </div>

      {/* Emirate chips */}
      <div style={{display:"flex",gap:6,overflowX:"auto",marginBottom:12,paddingBottom:4}}>
        {EMIRATES.map(e=><button key={e} onClick={()=>{setEm(e);setSelected(new Set());setVisited(new Set());}} className={em===e?"chip on":"chip"}>{e} ({liveCustomers.filter(c=>c.emirate===e).length})</button>)}
      </div>

      {/* Controls bar */}
      <div className="card" style={{marginBottom:12,padding:"12px 14px"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:8}}>
          <div>
            <div style={{fontWeight:700,color:T.heading,fontSize:14}}>{em} · {route.length} stops</div>
            <div style={{fontSize:11,color:T.muted}}>{doneCount}/{route.length} visited today</div>
          </div>
          <div style={{display:"flex",gap:7,flexWrap:"wrap",alignItems:"center"}}>
            {/* Sort toggle */}
            <div style={{display:"flex",background:T.bg,borderRadius:8,border:`1px solid ${T.border}`,overflow:"hidden"}}>
              <button onClick={()=>setSortMode("auto")} style={{padding:"6px 11px",fontSize:11,background:sortMode==="auto"?`linear-gradient(135deg,${T.mid},${T.bright})`:"transparent",color:sortMode==="auto"?"#fff":T.muted,borderRadius:0,border:"none"}}>🔄 Auto</button>
              <button onClick={()=>setSortMode("manual")} style={{padding:"6px 11px",fontSize:11,background:sortMode==="manual"?`linear-gradient(135deg,${T.mid},${T.bright})`:"transparent",color:sortMode==="manual"?"#fff":T.muted,borderRadius:0,border:"none"}}>📋 Listed</button>
            </div>
            {/* Select all / clear */}
            <button className="btn-soft" style={{fontSize:11,padding:"6px 11px"}} onClick={selected.size===allPlants.length?clearAll:selectAll}>
              {selected.size===allPlants.length?"☑ Clear All":"☐ Select All"}
            </button>
            {/* Open Maps */}
            {route.length>0&&(
              <a href={`https://www.google.com/maps/dir/${route.map(p=>`${p.lat},${p.lng}`).join("/")}`} target="_blank" rel="noopener noreferrer"
                style={{background:`linear-gradient(135deg,${T.mid},${T.bright})`,color:"#fff",padding:"7px 13px",borderRadius:8,fontSize:12,fontWeight:700,textDecoration:"none",display:"flex",alignItems:"center",gap:5}}>
                <Ic.Map/> Maps
              </a>
            )}
          </div>
        </div>
        {selected.size>0&&<div style={{fontSize:11,color:T.accent,marginTop:8}}>✓ {selected.size} plant{selected.size>1?"s":""} selected — route shows selected only</div>}
      </div>

      {/* Progress bar */}
      {route.length>0&&(
        <div style={{background:T.bg,borderRadius:8,height:6,marginBottom:12,overflow:"hidden"}}>
          <div style={{width:`${(doneCount/route.length)*100}%`,background:`linear-gradient(90deg,${T.accent2},${T.mid})`,height:"100%",borderRadius:8,transition:"width .4s"}}/>
        </div>
      )}

      {/* Missing GPS warning */}
      {noGPS.length>0&&(
        <div style={{background:T.warn+"14",border:`1px solid ${T.warn}33`,borderRadius:10,padding:11,marginBottom:12}}>
          <div style={{fontSize:12,color:T.warn,fontWeight:700,marginBottom:7}}>⚠ {noGPS.length} plant{noGPS.length>1?"s":""} missing GPS coordinates</div>
          {noGPS.map(p=>(
            <div key={p.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"5px 0",borderBottom:`1px solid ${T.border}`}}>
              <div><div style={{fontSize:13,color:T.heading,fontWeight:600}}>{p.name}</div><div style={{fontSize:11,color:T.muted}}>📍 {p.location}</div></div>
              <button className="btn-soft" style={{fontSize:11,padding:"4px 10px"}} onClick={()=>openEdit(p)}><Ic.GPS/> Add GPS</button>
            </div>
          ))}
        </div>
      )}

      {route.length===0&&allPlants.length===0&&(
        <div style={{textAlign:"center",padding:"36px 20px",color:T.muted}}>
          <div style={{fontSize:36,marginBottom:8}}>🗺</div>
          No GPS-tagged plants in {em}
          <div style={{fontSize:12,marginTop:5}}>Add coordinates via Plants → Edit</div>
        </div>
      )}

      {/* Route list with checkboxes */}
      {allPlants.map((s,i)=>{
        const inRoute  = route.find(r=>r.id===s.id);
        const routeIdx = route.indexOf(inRoute);
        const isSelected = selected.has(s.id);
        const isVisited  = visited.has(s.id)||todayVisited(s);
        const next = inRoute && routeIdx<route.length-1 ? route[routeIdx+1] : null;
        const b = isWarranty(s)?warrantyBadge(s):expiryBadge(s.amcEnd);
        return(
          <div key={s.id} className="rs" style={{opacity:selected.size>0&&!isSelected?0.45:1,borderColor:isVisited?T.accent2+"55":isSelected?T.accent+"55":T.border,background:isVisited?T.accent2+"08":T.card}}>
            {/* Checkbox */}
            <div onClick={()=>toggleSelect(s.id)} style={{width:24,height:24,borderRadius:6,border:`2px solid ${isSelected?T.accent:T.border}`,background:isSelected?T.accent:"transparent",display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",flexShrink:0,transition:"all .18s"}}>
              {isSelected&&<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>}
            </div>
            {/* Route number (only if in route) */}
            {inRoute ? (
              <div className="rn" style={{background:isVisited?`linear-gradient(135deg,${T.accent2},#059669)`:undefined}}>{isVisited?"✓":routeIdx+1}</div>
            ) : (
              <div style={{width:33,height:33,borderRadius:"50%",background:T.border+"44",display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,color:T.muted,flexShrink:0}}>—</div>
            )}
            {/* Info */}
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontWeight:700,color:isVisited?T.accent2:"#fff",fontSize:14,display:"flex",alignItems:"center",gap:6}}>
                {s.name}
                {isVisited&&<span style={{fontSize:10,background:T.accent2+"22",color:T.accent2,padding:"1px 7px",borderRadius:10,fontWeight:700}}>✔ Done</span>}
                {todayVisited(s)&&!visited.has(s.id)&&<span style={{fontSize:10,background:T.accent2+"22",color:T.accent2,padding:"1px 7px",borderRadius:10,fontWeight:700}}>✔ Report Submitted</span>}
              </div>
              <div style={{fontSize:12,color:T.muted}}>📍 {s.location} · 💧 {s.capacity||"—"}</div>
              {s.address&&<div style={{fontSize:11,color:T.muted}}>📌 {s.address}</div>}
              <a href={`https://maps.google.com?q=${s.lat},${s.lng}`} target="_blank" rel="noopener noreferrer" style={{fontSize:11,color:T.accent,textDecoration:"none",display:"block",marginTop:2}}>
                🗺 {Number(s.lat).toFixed(4)}, {Number(s.lng).toFixed(4)}
              </a>
              {next&&<div style={{fontSize:11,color:T.light,marginTop:2}}>↓ ~{(Math.hypot(next.lat-s.lat,next.lng-s.lng)*111).toFixed(1)} km to next</div>}
            </div>
            {/* Right side actions */}
            <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:5,flexShrink:0}}>
              <span className="tag" style={{background:b.color+"22",color:b.color,fontSize:9}}>{b.label}</span>
              {/* Visited toggle button */}
              <button onClick={()=>toggleVisited(s.id)}
                style={{fontSize:10,padding:"3px 9px",borderRadius:6,border:`1px solid ${isVisited?T.accent2:T.border}`,background:isVisited?T.accent2+"22":"transparent",color:isVisited?T.accent2:T.muted,cursor:"pointer",fontFamily:T.font,fontWeight:600,whiteSpace:"nowrap"}}>
                {isVisited?"✔ Visited":"Mark Done"}
              </button>
              <button className="btn-soft" style={{fontSize:10,padding:"3px 8px"}} onClick={()=>openEdit(s)}>📍 Edit</button>
            </div>
          </div>
        );
      })}

      {/* Edit location modal — compact, no empty space */}
      {editLoc&&(
        <div className="overlay">
          <div className="modal" style={{maxWidth:400,padding:20}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
              <div>
                <div style={{fontSize:15,fontWeight:800,color:T.heading}}>Edit Location</div>
                <div style={{fontSize:12,color:T.muted}}>{editLoc.name}</div>
              </div>
              <button className="btn-g" style={{padding:"6px 8px",fontSize:16,lineHeight:1}} onClick={()=>setEditLoc(null)}>✕</button>
            </div>
            <div className="fg"><label>Full Address</label><input value={tempLoc.address||""} onChange={e=>setTempLoc(t=>({...t,address:e.target.value}))} placeholder="e.g. Al Khatem, Abu Dhabi"/></div>
            <div className="g2">
              <div className="fg"><label>Latitude</label><input type="number" step="0.000001" value={tempLoc.lat||""} onChange={e=>setTempLoc(t=>({...t,lat:e.target.value}))} placeholder="24.192"/></div>
              <div className="fg"><label>Longitude</label><input type="number" step="0.000001" value={tempLoc.lng||""} onChange={e=>setTempLoc(t=>({...t,lng:e.target.value}))} placeholder="55.763"/></div>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              <button className="btn-p" style={{justifyContent:"center"}} onClick={getGPS}><Ic.GPS/> Use My Current GPS</button>
              <button className="btn-soft" style={{justifyContent:"center"}} onClick={()=>window.open(`https://maps.google.com?q=${encodeURIComponent(tempLoc.address||editLoc.name)}`,"_blank")}><Ic.Map/> Search Google Maps</button>
              <button className="btn-s" style={{justifyContent:"center"}} onClick={saveLocation}><Ic.Save/> Save Location</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// ─── Report Form ────────────────────────────────────────────────────────────
const ReportForm = ({customer,machine,techName,onSave,onClose}) => {
  const [f,setF]=useState({customerId:customer.id,customerName:customer.name,machineId:machine?machine.id:"",machineLabel:machine?machine.label:"",location:customer.location,capacity:(machine&&machine.capacity)||customer.capacity,operatorName:customer.operatorName||"",technicianName:techName,visitDate:todayStr(),lastVisitDate:"",nextVisitDate:"",contactNo:customer.contactNo||"",warrantyValid:coverageEnd(customer)||"",plantNo:customer.docNo||"",membraneType:(machine&&machine.membraneType)||"",membraneName:(machine&&machine.membraneName)||"",noOfMembrane:(machine&&machine.noOfMembrane)||"",pumpTypes:["","","","",""],readings:{},wellSamples:{well1:"",well2:"",well3:"",well4:""},productWater:"",rejectWater:"",remarks:"",signature:"",photos:[]});
  const [submitted,setSubmitted]=useState(null);
  const set=(k,v)=>setF(x=>({...x,[k]:v}));
  const fileRef=useRef();
  const [photoBusy,setPhotoBusy]=useState(false);
  const addPhotos=async files=>{
    const list=Array.from(files||[]).slice(0,6);
    if(!list.length) return;
    setPhotoBusy(true);
    const ok=[];
    for(const file of list){ try{ ok.push(await compressImg(file,900)); }catch(e){ alert(e.message||"Could not add that photo"); } }
    setF(x=>({...x,photos:[...(x.photos||[]),...ok].slice(0,8)}));
    setPhotoBusy(false);
  };
  const D=({t})=>(<div className="divr"><span>{t}</span></div>);
  const handleSubmit=()=>{
    const clean={...f,photos:(f.photos||[]).filter(isValidPhoto)};
    const rep={...clean,id:uid(),date:f.visitDate,submittedBy:techName,submittedAt:new Date().toISOString()};
    setSubmitted(rep);
    onSave(clean);
  };

  // Success screen
  if(submitted) return(
    <div className="overlay">
      <div className="modal" style={{maxWidth:380,textAlign:"center"}}>
        <div style={{fontSize:50,marginBottom:10}}>✅</div>
        <div style={{fontSize:18,fontWeight:800,color:T.heading,marginBottom:6}}>Report Submitted!</div>
        <div style={{fontSize:13,color:T.muted,marginBottom:22}}>Visit report for <strong style={{color:T.heading}}>{submitted.customerName}{submitted.machineLabel?` — ${submitted.machineLabel}`:""}</strong> saved successfully.</div>
        <div style={{display:"flex",flexDirection:"column",gap:9}}>
          <button className="btn-wa" style={{justifyContent:"center",padding:"11px",fontSize:14}} onClick={()=>shareReport(submitted,"whatsapp")}><Ic.WA/> Share via WhatsApp</button>
          <button className="btn-em" style={{justifyContent:"center",padding:"11px",fontSize:14}} onClick={()=>shareReport(submitted,"email")}><Ic.Email/> Send via Email</button>
          <button className="btn-p" style={{justifyContent:"center",padding:"11px",fontSize:14}} onClick={()=>exportReportPDF(submitted, SQ_LOGO)}><Ic.PDF/> Export as PDF</button>
          <button className="btn-soft" style={{justifyContent:"center",padding:"11px",fontSize:14}} onClick={onClose}>Close</button>
        </div>
        <div style={{marginTop:12,fontSize:11,color:T.muted}}>WhatsApp &amp; Email attach the PDF report (or open the share sheet on your phone).</div>
      </div>
    </div>
  );

  return(
    <div className="overlay" style={{alignItems:"flex-start",paddingTop:12,paddingBottom:12}}>
      <div className="modal" style={{maxWidth:700}}>
        <div style={{background:`linear-gradient(135deg,${T.navy},${T.mid})`,margin:"-24px -24px 20px",padding:"18px 24px",borderRadius:"18px 18px 0 0",textAlign:"center"}}>
          <div style={{fontSize:10,color:"rgba(255,255,255,0.5)",letterSpacing:2}}>RO UNIT VISIT REPORT</div>
          <div style={{fontSize:17,fontWeight:800,color:"#fff",marginTop:4}}>{customer.name}{machine?` — ${machine.label}`:""}</div>
          <div style={{fontSize:12,color:"rgba(255,255,255,0.55)",marginTop:3}}>📍 {customer.location} · 💧 {(machine&&machine.capacity)||customer.capacity||"—"}</div>
        </div>
        <D t="PLANT INFORMATION"/>
        <div className="g2">
          {[{l:"Plant No.",k:"plantNo"},{l:"AMC/Warranty Valid",k:"warrantyValid"},{l:"Operator Name",k:"operatorName"},{l:"Technician Name",k:"technicianName"},{l:"Contact No.",k:"contactNo"},{l:"Visit Date",k:"visitDate",t:"date"},{l:"Last Visited",k:"lastVisitDate",t:"date"},{l:"Next Visit",k:"nextVisitDate",t:"date"}].map(x=>(
            <div key={x.k} className="fg"><label>{x.l}</label><input type={x.t||"text"} value={f[x.k]||""} onChange={e=>set(x.k,e.target.value)}/></div>
          ))}
        </div>
        <D t="PUMPS & MEMBRANES"/>
        <div className="g2">
          {f.pumpTypes.map((p,i)=><div key={i} className="fg"><label>Pump {i+1}</label><input value={p} onChange={e=>{const a=[...f.pumpTypes];a[i]=e.target.value;set("pumpTypes",a);}}/></div>)}
          {[{l:"Membrane Name",k:"membraneName"},{l:"Membrane Type",k:"membraneType"},{l:"No. of Membranes",k:"noOfMembrane"}].map(x=><div key={x.k} className="fg"><label>{x.l}</label><input value={f[x.k]||""} onChange={e=>set(x.k,e.target.value)}/></div>)}
        </div>
        <D t="PRESSURE, FLOW & DOSING READINGS"/>
        <div className="g4">
          {READINGS_META.map(r=><div key={r.key} className="fg"><label style={{color:T.light}}>{r.label}</label><input value={f.readings[r.key]||""} onChange={e=>setF(x=>({...x,readings:{...x.readings,[r.key]:e.target.value}}))} placeholder="—" style={{textAlign:"center",fontFamily:T.mono}}/><div style={{fontSize:9,color:T.muted,marginTop:2}}>{r.desc}</div></div>)}
        </div>
        <D t="WATER SAMPLES (TDS)"/>
        <div className="g2">
          {["well1","well2","well3","well4"].map((w,i)=><div key={w} className="fg"><label>Well {i+1}</label><input value={f.wellSamples[w]} onChange={e=>setF(x=>({...x,wellSamples:{...x.wellSamples,[w]:e.target.value}}))}/></div>)}
          <div className="fg"><label>Product Water TDS</label><input value={f.productWater} onChange={e=>set("productWater",e.target.value)}/></div>
          <div className="fg"><label>Reject Water TDS</label><input value={f.rejectWater} onChange={e=>set("rejectWater",e.target.value)}/></div>
        </div>
        <D t="REMARKS & OBSERVATIONS"/>
        <div className="fg"><textarea rows={3} value={f.remarks} onChange={e=>set("remarks",e.target.value)} style={{resize:"vertical"}} placeholder="Issues found, work done, next steps…"/></div>
        <D t="SITE PHOTOS"/>
        <button className="btn-soft" style={{fontSize:13}} onClick={()=>fileRef.current.click()}><Ic.Camera/> Attach Photos (max 8)</button>
        <input ref={fileRef} type="file" accept="image/*" multiple style={{display:"none"}} onChange={e=>{addPhotos(e.target.files);e.target.value="";}}/>
        <div style={{fontSize:11,color:T.muted,margin:"6px 0"}}>{photoBusy?"Processing photo…":`${(f.photos||[]).length}/8 photos attached`}</div>
        {f.photos.length>0&&<PhotoGrid photos={f.photos} onRemove={i=>setF(x=>({...x,photos:x.photos.filter((_,j)=>j!==i)}))}/>}
        <D t="OPERATOR / TECHNICIAN SIGNATURE"/>
        <SigPad onSave={v=>set("signature",v)} onClear={()=>set("signature","")}/>
        <div style={{display:"flex",gap:10,marginTop:20}}>
          <button className="btn-s" style={{flex:1,justifyContent:"center",fontSize:14,padding:"12px"}} disabled={photoBusy} onClick={handleSubmit}><Ic.Check/> {photoBusy?"Processing photo…":"Submit Report"}</button>
          <button className="btn-soft" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

// ─── Reports Page ────────────────────────────────────────────────────────────
const Reports = ({customers,reports,setReports,setPhotos,user}) => {
  const [step,setStep]=useState("list"), [selC,setSelC]=useState(null), [selM,setSelM]=useState(null), [view,setView]=useState(null);
  const [month,setMonth]=useState(new Date().toISOString().slice(0,7));
  const [search,setSearch]=useState(""), [cSearch,setCSearch]=useState("");
  const photoRef=useRef(null), photoTarget=useRef(null);
  const [photoBusy,setPhotoBusy]=useState(false);
  const pickPhotos=r=>{ photoTarget.current=r; photoRef.current&&photoRef.current.click(); };
  // Add photos to an EXISTING report, any time, by anyone signed in. Unusable (broken) photos are dropped.
  const attachToReport=async(rep,files)=>{
    const list=Array.from(files||[]).slice(0,6);
    if(!list||!list.length||!rep) return;
    setPhotoBusy(true);
    const ok=[];
    for(const file of list){ try{ ok.push(await compressImg(file,900)); }catch(e){ alert(e.message||"Could not add that photo"); } }
    if(ok.length){
      const cur=reports.find(x=>x.id===rep.id)||rep;
      const photos=[...(cur.photos||[]).filter(isValidPhoto),...ok].slice(0,8);
      if(setPhotos(rep.id,photos)!==false){
        setView(v=>v&&v.id===rep.id?{...v,photos}:v);
        showToast(`📷 ${ok.length} photo${ok.length>1?"s":""} added to the report`,2500);
      }
    }
    setPhotoBusy(false);
  };
  const filtered=reports.filter(r=>(!month||(r.date||"").startsWith(month))&&(!search||(r.customerName||"").toLowerCase().includes(search.toLowerCase())||(r.machineLabel||"").toLowerCase().includes(search.toLowerCase()))).sort((a,b)=>new Date(b.submittedAt||0)-new Date(a.submittedAt||0));
  const save=f=>{setReports(rs=>[{...f,id:uid(),date:f.visitDate,submittedBy:user.name,submittedAt:new Date().toISOString()},...rs]);setStep("list");setSelC(null);setSelM(null);};
  return(
    <div className="pg fade-up">
      <input ref={photoRef} type="file" accept="image/*" multiple style={{display:"none"}} onChange={e=>{attachToReport(photoTarget.current,e.target.files);e.target.value="";}}/>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
        <div><div style={{fontSize:22,fontWeight:800,color:T.heading}}>Reports</div><div style={{fontSize:12,color:T.muted}}>{filtered.length} visit reports</div></div>
        <button className="btn-p" style={{padding:"8px 14px",fontSize:13}} onClick={()=>setStep("selectCustomer")}><Ic.Plus/> New Report</button>
      </div>
      <div style={{display:"flex",gap:8,marginBottom:13,flexWrap:"wrap"}}>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="🔍 Search plant…" style={{flex:1,minWidth:150}}/>
        <input type="month" value={month} onChange={e=>setMonth(e.target.value)} style={{width:155}}/>
      </div>
      {filtered.length===0&&<div style={{textAlign:"center",padding:50,color:T.muted}}><div style={{fontSize:36,marginBottom:8}}>📋</div>No reports found</div>}
      {filtered.map(r=>(
        <div key={r.id} className="cc">
          <div style={{cursor:"pointer"}} onClick={()=>setView(r)}>
            <div style={{display:"flex",justifyContent:"space-between"}}>
              <div><div style={{fontWeight:700,fontSize:14,color:T.heading}}>{r.customerName}{r.machineLabel&&<span className="tag" style={{marginLeft:8,background:T.accent+"22",color:T.accent,fontSize:10}}>⚙ {r.machineLabel}</span>}</div><div style={{fontSize:12,color:T.muted}}>📍 {r.location} · 📅 {r.date}</div><div style={{fontSize:12,color:T.muted}}>👤 {r.submittedBy}{r.photos?.length?` · 📷 ${r.photos.length}`:""}</div></div>
              <span className="tag" style={{background:T.accent2+"22",color:T.accent2,flexShrink:0,alignSelf:"flex-start"}}>✔ Done</span>
            </div>
          </div>
          <div style={{display:"flex",gap:7,marginTop:10,flexWrap:"wrap"}}>
            <button className="btn-g"  style={{padding:"5px 11px",fontSize:12}} onClick={()=>setView(r)}>View</button>
            <button className="btn-p" style={{padding:"5px 11px",fontSize:12}} disabled={photoBusy} onClick={()=>pickPhotos(r)}><Ic.Camera/> {photoBusy?"…":"Add photos"}</button>
            <button className="btn-soft" style={{padding:"5px 11px",fontSize:12}} onClick={()=>exportReportPDF(r, SQ_LOGO)}><Ic.PDF/> PDF</button>
            <button className="btn-wa" style={{padding:"5px 11px",fontSize:12}} onClick={()=>shareReport(r,"whatsapp")}><Ic.WA/> WA</button>
            <button className="btn-em" style={{padding:"5px 11px",fontSize:12}} onClick={()=>shareReport(r,"email")}><Ic.Email/> Email</button>
            {user.role==="admin"&&<button className="btn-d" style={{padding:"5px 9px",fontSize:12}} onClick={()=>{if(window.confirm("Delete this report?"))setReports(rs=>rs.filter(x=>x.id!==r.id));}}><Ic.Trash/></button>}
          </div>
        </div>
      ))}

      {step==="selectCustomer"&&(
        <div className="overlay"><div className="modal" style={{maxWidth:460}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
            <div style={{fontSize:16,fontWeight:800,color:T.heading}}>Select Plant</div>
            <button className="btn-g" style={{padding:"5px 8px"}} onClick={()=>setStep("list")}><Ic.X/></button>
          </div>
          <input placeholder="🔍 Search…" value={cSearch} onChange={e=>setCSearch(e.target.value)} style={{marginBottom:11}}/>
          <div style={{maxHeight:430,overflowY:"auto"}}>
            {customers.filter(c=>!isInactive(c)&&((c.name||"").toLowerCase().includes(cSearch.toLowerCase())||(c.location||"").toLowerCase().includes(cSearch.toLowerCase())||(c.siteGroup||"").toLowerCase().includes(cSearch.toLowerCase()))).map(c=>(
              <div key={c.id} className="cc" style={{cursor:"pointer"}} onClick={()=>{setSelC(c);setSelM(null);setStep(machinesOf(c).length>0?"selectMachine":"form");}}>
                <div style={{fontWeight:600,color:T.heading,fontSize:14}}>{c.name}{isWarranty(c)&&<span className="tag" style={{marginLeft:8,background:T.accent+"22",color:T.accent,fontSize:10}}>🛡 warranty</span>}</div>
                <div style={{fontSize:12,color:T.muted}}>📍 {c.location} · {c.emirate}{c.siteGroup?` · 🏢 ${c.siteGroup}`:""}</div>
                {machinesOf(c).length>0&&<div style={{fontSize:11,color:T.accent}}>⚙ {machinesOf(c).length} machines — pick one next</div>}
              </div>
            ))}
          </div>
        </div></div>
      )}
      {step==="selectMachine"&&selC&&(
        <div className="overlay"><div className="modal" style={{maxWidth:460}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
            <div style={{fontSize:16,fontWeight:800,color:T.heading}}>Which machine?</div>
            <button className="btn-g" style={{padding:"5px 8px"}} onClick={()=>{setStep("list");setSelC(null);}}><Ic.X/></button>
          </div>
          <div style={{fontSize:12,color:T.muted,marginBottom:12}}>{selC.name} · one report per machine</div>
          {machinesOf(selC).map(m=>{
            const done=reports.some(r=>r.customerId===selC.id&&r.machineId===m.id&&(r.date||"").startsWith(new Date().toISOString().slice(0,7)));
            return(
            <div key={m.id} className="cc" style={{cursor:"pointer"}} onClick={()=>{setSelM(m);setStep("form");}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:8}}>
                <div><div style={{fontWeight:700,color:T.heading,fontSize:14}}>{m.label}</div><div style={{fontSize:12,color:T.muted}}>💧 {m.capacity||"—"}{m.membraneName?` · ${m.membraneName}`:""}</div></div>
                <span className="tag" style={{background:(done?T.accent2:T.warn)+"22",color:done?T.accent2:T.warn,flexShrink:0}}>{done?"✔ reported this month":"not yet this month"}</span>
              </div>
            </div>);})}
        </div></div>
      )}
      {step==="form"&&selC&&<ReportForm customer={selC} machine={selM} techName={user.name} onSave={save} onClose={()=>{setStep("list");setSelC(null);setSelM(null);}}/>}

      {view&&(
        <div className="overlay" style={{alignItems:"flex-start",paddingTop:10}}>
          <div className="modal" style={{maxWidth:700}}>
            <div style={{background:`linear-gradient(135deg,${T.navy},${T.mid})`,margin:"-24px -24px 20px",padding:"18px 24px",borderRadius:"18px 18px 0 0",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div><div style={{fontSize:16,fontWeight:800,color:"#fff"}}>{view.customerName}{view.machineLabel?` — ${view.machineLabel}`:""}</div><div style={{fontSize:12,color:"rgba(255,255,255,0.55)"}}>📅 {view.date} · 👤 {view.submittedBy}</div></div>
              <button onClick={()=>setView(null)} style={{background:"rgba(255,255,255,0.14)",color:"#fff",border:"none",borderRadius:8,padding:"7px 12px",cursor:"pointer",display:"flex",alignItems:"center",gap:5,fontFamily:T.font,fontWeight:700,fontSize:13}}>✕ Close</button>
            </div>
            {/* Action buttons */}
            <div style={{display:"flex",gap:8,marginBottom:16,flexWrap:"wrap"}}>
              <button className="btn-p"  style={{padding:"8px 13px",fontSize:12}} onClick={()=>exportReportPDF(view, SQ_LOGO)}><Ic.PDF/> PDF</button>
              <button className="btn-wa" style={{padding:"8px 13px",fontSize:12}} onClick={()=>shareReport(view,"whatsapp")}><Ic.WA/> WhatsApp</button>
              <button className="btn-em" style={{padding:"8px 13px",fontSize:12}} onClick={()=>shareReport(view,"email")}><Ic.Email/> Email</button>
            </div>
            <div className="g2" style={{marginBottom:13}}>
              {[["Plant",view.customerName],...(view.machineLabel?[["Machine",view.machineLabel]]:[]),["Location",view.location],["Visit Date",view.date],["Technician",view.technicianName],["Operator",view.operatorName],["Next Visit",view.nextVisitDate],["Product Water",view.productWater],["Reject Water",view.rejectWater]].map(([k,v])=>(
                <div key={k} style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:9,padding:10}}><div style={{fontSize:9,color:T.muted,fontWeight:700,letterSpacing:1}}>{k.toUpperCase()}</div><div style={{fontSize:13,fontWeight:600,color:T.heading,marginTop:2}}>{v||"—"}</div></div>
              ))}
            </div>
            <div className="sec-lbl">READINGS</div>
            <div className="g4" style={{marginBottom:13}}>
              {READINGS_META.map(r=><div key={r.key} style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:9,padding:8,textAlign:"center"}}><div style={{fontSize:9,color:T.muted}}>{r.label}</div><div style={{fontSize:17,fontWeight:700,color:T.light,fontFamily:T.mono}}>{view.readings?.[r.key]||"—"}</div></div>)}
            </div>
            {view.remarks&&<div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:9,padding:11,marginBottom:13}}><div style={{fontSize:9,color:T.muted,fontWeight:700,letterSpacing:1,marginBottom:4}}>REMARKS</div><div style={{fontSize:13}}>{view.remarks}</div></div>}
            {(()=>{
              const all=view.photos||[], bad=all.filter(p=>!isValidPhoto(p)).length;
              return(
                <div style={{marginBottom:13}}>
                  <div className="sec-lbl">SITE PHOTOS ({all.length})</div>
                  {all.length>0&&<PhotoGrid photos={all}/>}
                  {all.length===0&&<div style={{fontSize:12,color:T.muted,margin:"4px 0"}}>No photos on this report yet.</div>}
                  {bad>0&&<div style={{fontSize:12,color:T.warn,margin:"8px 0"}}>⚠ {bad} photo{bad>1?"s":""} could not be loaded (saved incorrectly by an older version of the app). Please re-attach {bad>1?"them":"it"}.</div>}
                  <button className="btn-p" style={{fontSize:12,marginTop:8}} disabled={photoBusy} onClick={()=>pickPhotos(view)}><Ic.Camera/> {photoBusy?"Processing…":bad>0?"Re-attach photos":"Add photos"}</button>
                </div>);
            })()}w.signature&&(
              <div style={{marginBottom:13}}>
                <div className="sec-lbl">SIGNATURE</div>
                <div style={{background:"#fff",borderRadius:9,padding:8,display:"inline-block",border:`2px solid ${T.border}`}}>
                  <img src={view.signature} alt="sig" style={{maxWidth:"100%",maxHeight:110,display:"block"}}/>
                </div>
              </div>
            )}
            <div style={{fontSize:10,color:T.muted,textAlign:"right"}}>Submitted {new Date(view.submittedAt).toLocaleString()}</div>
          </div>
        </div>
      )}
    </div>
  );
};

// ─── Settings ───────────────────────────────────────────────────────────────
const Settings = ({user,onLogout,customers,reports,smallRO,smallROVisits,firebaseOk,theme,toggleTheme,setCustomers,setReports,setSmallRO,setSmallROVisits,setFinance,trash,lastBackupAt,onBackup,onRestoreTrash,onPurgeTrash}) => {
  const restoreRef=useRef(null);
  const restoreFile=async file=>{
    if(!file) return;
    if(file.size>40*1024*1024){ alert("That file is too large to be a backup."); return; }
    try{
      const b=parseBackup(await file.text());
      const n=k=>b[k].good.length, bad=b.customers.bad+b.reports.bad+b.smallRO.bad+b.smallROVisits.bad+b.finance.bad;
      const msg=`Restore from backup${b.exportedAt?` made ${new Date(b.exportedAt).toLocaleString()}`:""}?\n\n• ${n("customers")} plants\n• ${n("reports")} visit reports\n• ${n("smallRO")} Small RO contracts\n• ${n("smallROVisits")} Small RO visit reports\n• ${n("finance")} payment plans\n\nThis MERGES the backup into your current data: records with the same ID are replaced by the backup version, everything else is kept. Nothing is deleted.${bad?`\n\n(${bad} unreadable record(s) will be skipped.)`:""}`;
      if(!window.confirm(msg)) return;
      if(n("customers")) setCustomers(prev=>mergeById(prev,b.customers.good));
      if(n("reports")) setReports(prev=>mergeById(prev,b.reports.good));
      if(n("smallRO")) setSmallRO(prev=>mergeById(prev,b.smallRO.good));
      if(n("smallROVisits")) setSmallROVisits(prev=>mergeById(prev,b.smallROVisits.good));
      if(n("finance")) setFinance(prev=>mergeById(prev,b.finance.good));
      alert("Backup restored.");
    }catch(e){ alert(e.message||"Could not restore that file."); }
  };
  const exp=customers.filter(c=>isAMC(c)&&daysUntil(c.amcEnd)!==null&&daysUntil(c.amcEnd)<0);
  const warn60=customers.filter(c=>{if(!isAMC(c))return false;const d=daysUntil(c.amcEnd);return d!==null&&d>=0&&d<=60;});
  const Row=({l,v,c})=>(<div style={{display:"flex",justifyContent:"space-between",padding:"8px 0",borderBottom:`1px solid ${T.border}`}}><span style={{fontSize:13,color:T.muted}}>{l}</span><span style={{fontSize:13,fontWeight:700,color:c||T.light,fontFamily:T.mono}}>{v}</span></div>);
  return(
    <div className="pg fade-up">
      <div style={{fontSize:22,fontWeight:800,color:T.heading,marginBottom:16}}>Settings</div>
      <div style={{background:`linear-gradient(135deg,${T.navy},${T.mid})`,borderRadius:14,padding:20,marginBottom:12,position:"relative",overflow:"hidden"}}>
        <div style={{position:"absolute",top:-18,right:-18,width:90,height:90,borderRadius:"50%",background:"rgba(255,255,255,0.06)"}}/>
        <Logo size={26}/><div style={{fontSize:10,color:"rgba(255,255,255,0.42)",marginTop:10,letterSpacing:1}}>AMC MANAGEMENT SYSTEM</div><div style={{fontSize:11,color:"rgba(255,255,255,0.45)",marginTop:2}}>superquality-est.com</div>
      </div>
      <div className="card" style={{marginBottom:12}}>
        <div className="sec-lbl">Account</div>
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:10}}>
          <div style={{width:42,height:42,borderRadius:"50%",background:`linear-gradient(135deg,${T.mid},${T.bright})`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:17,fontWeight:700,color:"#fff",flexShrink:0}}>{user.name.charAt(0)}</div>
          <div><div style={{fontWeight:700,fontSize:15,color:T.heading}}>{user.name}</div><div style={{fontSize:12,color:T.muted}}>@{user.username}</div></div>
          <span className="tag" style={{marginLeft:"auto",background:user.role==="admin"?T.mid+"44":T.accent2+"22",color:user.role==="admin"?T.light:T.accent2}}>{user.role.toUpperCase()}</span>
        </div>
        {user.role==="technician"&&<div style={{fontSize:12,color:T.muted,padding:"8px 11px",background:T.bg,borderRadius:8}}>View-only access. Contact admin to add or edit plants.</div>}
      </div>
      <div className="card" style={{marginBottom:12}}>
        <div className="sec-lbl">Data Sync</div>
        <div style={{display:"flex",alignItems:"center",gap:10,padding:"6px 0"}}>
          <span style={{width:10,height:10,borderRadius:"50%",background:firebaseOk?T.accent2:T.warn,boxShadow:firebaseOk?`0 0 8px ${T.accent2}`:undefined,display:"inline-block",flexShrink:0}}/>
          <div>
            <div style={{fontSize:13,fontWeight:600,color:T.heading}}>{firebaseOk?"Firebase Connected — Live Sync Active":"Local Storage Only"}</div>
            <div style={{fontSize:11,color:T.muted}}>{firebaseOk?"All devices sync in real time.":"Set up Firebase to share reports between users"}</div>
          </div>
        </div>
      </div>
      <div className="card" style={{marginBottom:12}}>
        <div className="sec-lbl">Appearance</div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div style={{fontSize:12,color:T.muted}}>Switch between dark and light theme. Saved to your account — carries over across devices.</div>
          <button className="btn-soft" style={{fontSize:13,padding:"8px 14px",flexShrink:0,marginLeft:12,display:"flex",alignItems:"center",gap:6}} onClick={toggleTheme}>
            {theme==="light" ? <><Ic.Moon/> Dark</> : <><Ic.Sun/> Light</>}
          </button>
        </div>
      </div>
      <div className="card" style={{marginBottom:12}}>
        <div className="sec-lbl">Data Backup</div>
        <div style={{fontSize:12,fontWeight:700,marginBottom:8,color:(!lastBackupAt||(Date.now()-new Date(lastBackupAt).getTime())>7*86400000)?T.warn:T.accent2}}>
          {lastBackupAt?`Last backup: ${new Date(lastBackupAt).toLocaleString()} (${Math.floor((Date.now()-new Date(lastBackupAt).getTime())/86400000)} day(s) ago)`:"No backup made from this account yet"}
        </div>
        <div style={{fontSize:12,color:T.muted,marginBottom:10}}>
          Download a full backup of all Plants, Reports, Small RO contracts & payment plans as a JSON file to your device. Keep it safe — it's a snapshot of everything, in case anything ever needs to be restored.
        </div>
        <button className="btn-p" style={{fontSize:13,padding:"9px 16px"}} onClick={onBackup}><Ic.Save/> Backup All Data</button>
        {user.role==="admin"&&(<>
          <button className="btn-soft" style={{fontSize:13,padding:"9px 16px",marginLeft:8}} onClick={()=>restoreRef.current&&restoreRef.current.click()}>⬆ Restore from Backup</button>
          <input ref={restoreRef} type="file" accept="application/json,.json" style={{display:"none"}} onChange={e=>{restoreFile(e.target.files[0]);e.target.value="";}}/>
          <div style={{fontSize:11,color:T.muted,marginTop:8}}>Restore merges a backup file into your current data — it never deletes anything.</div>
        </>)}
      </div>
      {user.role==="admin"&&(
        <div className="card" style={{marginBottom:12}}>
          <div className="sec-lbl">Recycle Bin ({(trash||[]).length})</div>
          <div style={{fontSize:12,color:T.muted,marginBottom:10}}>Deleted plants, reports, contracts and payment plans are kept here for {TRASH_DAYS} days, then removed permanently.</div>
          {(!trash||trash.length===0)&&<div style={{fontSize:12,color:T.muted,padding:"6px 0"}}>🗑 Empty</div>}
          <div style={{maxHeight:320,overflowY:"auto"}}>
            {(trash||[]).map(e=>(
              <div key={`${e.kind}__${e.id}`} style={{display:"flex",gap:8,alignItems:"center",padding:"8px 0",borderTop:`1px solid ${T.border}`}}>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:13,fontWeight:700,color:T.heading,wordBreak:"break-word"}}>{trashLabel(e)}</div>
                  <div style={{fontSize:11,color:T.muted}}>Deleted {e.deletedAt?new Date(e.deletedAt).toLocaleDateString():"—"}{e.deletedBy?` by ${e.deletedBy}`:""} · {trashDaysLeft(e)}d left</div>
                </div>
                <button className="btn-g" style={{padding:"5px 10px",fontSize:12,flexShrink:0}} onClick={()=>onRestoreTrash(e)}>Restore</button>
                <button className="btn-d" style={{padding:"5px 8px",fontSize:12,flexShrink:0}} title="Delete forever" onClick={()=>onPurgeTrash(e)}><Ic.Trash/></button>
              </div>
            ))}
          </div>
        </div>
      )}
      <div className="card" style={{marginBottom:12}}>
        <div className="sec-lbl">System Stats</div>
        <Row l="Total Plants" v={customers.length} c={T.light}/>
        <Row l="Total Reports" v={reports.length} c={T.light}/>
        <Row l="Expired Contracts" v={exp.length} c={exp.length>0?T.danger:T.accent2}/>
        <Row l="Expiring ≤60 Days" v={warn60.length} c={warn60.length>0?T.warn:T.accent2}/>
        <Row l="App version" v={APP_VERSION} c={T.muted}/>
      </div>
      <div className="card" style={{marginBottom:12}}>
        <div className="sec-lbl">Contract Alerts</div>
        {exp.length===0&&warn60.length===0?<div style={{color:T.accent2,fontSize:13,display:"flex",alignItems:"center",gap:8}}><Ic.Check/> All contracts up to date</div>
        :[...exp,...warn60].sort((a,b)=>daysUntil(a.amcEnd)-daysUntil(b.amcEnd)).map(c=>{const b=expiryBadge(c.amcEnd);return(
          <div key={c.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 0",borderBottom:`1px solid ${T.border}`}}>
            <div><div style={{fontSize:13,fontWeight:600,color:T.heading}}>{c.name}</div><div style={{fontSize:11,color:T.muted}}>{c.location} · {c.amcEnd||"—"}</div></div>
            <span className="tag" style={{background:b.color+"22",color:b.color}}>{b.label}</span>
          </div>
        );})}
      </div>
      {user.role==="admin"&&(
        <div className="card" style={{marginBottom:12}}>
          <div className="sec-lbl">App Users</div>
          <div style={{fontSize:12,color:T.muted,padding:"8px 0"}}>
            Manage users in Firebase Console → Authentication → Users
          </div>
          <a href="https://console.firebase.google.com" target="_blank" rel="noopener noreferrer"
            style={{display:"inline-flex",alignItems:"center",gap:6,marginTop:6,padding:"8px 14px",background:T.surface,border:`1px solid ${T.border}`,borderRadius:8,fontSize:12,color:T.accent,textDecoration:"none",fontWeight:600}}>
            🔗 Open Firebase Console
          </a>
        </div>
      )}
      <button className="btn-d" style={{width:"100%",justifyContent:"center",padding:"13px",fontSize:15,borderRadius:12,marginTop:4}} onClick={onLogout}><Ic.Out/> Sign Out</button>
      <div style={{textAlign:"center",marginTop:14,fontSize:10,color:T.muted}}>Copyright © 2026 Muhammad Faran. All Rights Reserved</div>
    </div>
  );
};

// ─── App Root ────────────────────────────────────────────────────────────────

// ─── App Root — Secure Firebase Auth State ────────────────────────────────────
export default function App() {
  // ── Theme: apply instantly from local cache, then reconcile with Firebase per-user pref ─
  const [theme, setTheme] = useState(()=> local.get("sq_theme") || "dark");
  useEffect(()=>{ applyTheme(theme); injectCSS(); },[]); // eslint-disable-line react-hooks/exhaustive-deps

  const [firebaseOk, setFirebaseOk] = useState(false);
  const [user,       setUser]       = useState(null);       // {uid, email, name, role}
  const [authReady,  setAuthReady]  = useState(false);      // true once Firebase checked auth state
  const [tab,        setTab]        = useState("home");
  const [customers,  setRawC]       = useState(SEED_CUSTOMERS);
  const [reports,    setRawR]       = useState([]);
  const [smallRO,    setRawSRO]     = useState(SEED_SMALL_RO);
  const [smallROVisits, setRawSROV] = useState([]);
  const [finance,    setRawF]       = useState([]);      // admin only
  const [trash,      setTrash]      = useState([]);      // admin only
  const [lastBackupAt,setLastBackupAt]=useState(null);
  const [bannerHidden,setBannerHidden]=useState(false);
  const [dataLoading,setDataLoading]= useState(true);

  // Latest copy of every collection (so saves never work from a stale snapshot), plus
  // flags that stop any save until the database has actually answered.
  const latest     = useRef({c:SEED_CUSTOMERS, r:[], s:SEED_SMALL_RO, v:[], f:[]});
  const synced     = useRef({c:false, r:false, s:false, v:false, f:false});
  const seedOnly   = useRef(false);   // customers on screen are the built-in sample, not yet saved to the DB
  const hadCustomers = useRef(false);

  // ── 1. Init Firebase & watch auth state ──────────────────────────────────
  useEffect(()=>{
    fbInit().then(ok=>{
      setFirebaseOk(ok);
      if(!ok){ setAuthReady(true); setDataLoading(false); return; }

      // onAuthStateChanged fires immediately with current user or null
      // This handles page refresh — Firebase Auth persists sessions automatically
      // No localStorage session hacks needed
      const unsub = window._fbOnAuth(window._fbAuth, async (fbUser) => {
        if(fbUser){
          // User is signed in — load their profile from DB
          const profile = await fbGetProfile(fbUser.uid);
          if(profile){
            setUser({ uid: fbUser.uid, email: fbUser.email, name: profile.name, role: profile.role });
            // Reconcile theme with this user's saved preference (cross-device)
            const savedTheme = await fbGetOnce(`sq_prefs/${fbUser.uid}/theme`);
            if(savedTheme && (savedTheme==="light"||savedTheme==="dark")){
              setTheme(savedTheme);
              applyTheme(savedTheme);
              injectCSS();
              local.set("sq_theme", savedTheme);
            }
            const lbRemote = await fbGetOnce(`sq_prefs/${fbUser.uid}/lastBackupAt`);
            const lbBest = [lbRemote, local.get("sq_last_backup")].filter(Boolean).sort().pop();
            if(lbBest) setLastBackupAt(lbBest);
          } else {
            // Profile missing in DB — sign them out
            await fbSignOut();
            setUser(null);
          }
        } else {
          setUser(null);
        }
        setAuthReady(true);
      });
      return unsub;
    });
  },[]);

  // ── 2. Load data when user is authenticated ───────────────────────────────
  useEffect(()=>{
    if(!user || !firebaseOk){ setDataLoading(false); return; }
    setDataLoading(true);
    let gotCustomers = false;
    let gotReports   = false;
    let gotSmallRO   = false;
    let gotSROVisits = false;
    synced.current = {c:false, r:false, s:false, v:false, f:false};
    const checkDone  = () => { if(gotCustomers && gotReports && gotSmallRO && gotSROVisits) setDataLoading(false); };

    const unsubC = fbListen("sq_customers", data=>{
      if(data){ const a=Object.values(data); hadCustomers.current=true; seedOnly.current=false; latest.current.c=a; setRawC(a); }
      else if(hadCustomers.current){ latest.current.c=[]; setRawC([]); }   // everything was deleted
      else { seedOnly.current=true; }                                       // empty DB: keep the built-in sample
      synced.current.c = true; gotCustomers = true; checkDone();
    });
    const unsubR = fbListen("sq_reports", data=>{
      const a = data ? Object.values(data).sort((x,y)=>new Date(y.submittedAt||0)-new Date(x.submittedAt||0)) : [];
      latest.current.r=a; setRawR(a);
      synced.current.r = true; gotReports = true; checkDone();
    });
    const unsubSRO = fbListen("sq_small_ro", data=>{
      const a = data ? Object.values(data) : [];
      latest.current.s=a; setRawSRO(a);
      synced.current.s = true; gotSmallRO = true; checkDone();
    });
    const unsubSROV = fbListen("sq_small_ro_visits", data=>{
      const a = data ? Object.values(data) : [];
      latest.current.v=a; setRawSROV(a);
      synced.current.v = true; gotSROVisits = true; checkDone();
    });

    let unsubF=()=>{}, unsubT=()=>{};
    if(user.role==="admin"){
      unsubF = fbListen("sq_finance", data=>{
        const a = data ? Object.values(data) : [];
        latest.current.f=a; setRawF(a); synced.current.f = true;
      });
      unsubT = fbListen("sq_trash", data=>{
        const a = data ? Object.values(data).sort((x,y)=>new Date(y.deletedAt||0)-new Date(x.deletedAt||0)) : [];
        setTrash(a);
        // auto-purge anything older than 30 days
        a.forEach(e=>{ if(trashDaysLeft(e)<=0) fbSet(`sq_trash/${e.kind}__${e.id}`, null); });
      });
    } else { synced.current.f = true; }

    // Safety timeout — if Firebase doesn't respond in 5s, show app with seed data
    const timeout = setTimeout(()=>{ setDataLoading(false); }, 5000);

    return ()=>{ unsubC(); unsubR(); unsubSRO(); unsubSROV(); unsubF(); unsubT(); clearTimeout(timeout); };
  },[user, firebaseOk]);

  // ── 3. Saving data ────────────────────────────────────────────────────────
  // Only the records that actually changed are written (one Firebase node each),
  // never the whole collection — so two people saving at once can't wipe each
  // other's work, and nothing is written until the database has loaded.
  const persist = (path, prev, next, forceAll, kind, who) => {
    const pm={}, nm={};
    prev.forEach(x=>{ pm[x.id]=x; });
    next.forEach(x=>{ nm[x.id]=x; });
    Object.keys(nm).forEach(id=>{
      if(forceAll || pm[id]!==nm[id]){
        let clean; try{ clean = JSON.parse(JSON.stringify(nm[id])); }catch{ return; }   // drops undefined fields
        if(forceAll || JSON.stringify(pm[id])!==JSON.stringify(clean)) fbSet(`${path}/${id}`, clean);
      }
    });
    // Deleted records go to the recycle bin FIRST; the real record is only removed once
    // the bin copy is safely stored. If that fails, the delete is cancelled (record stays in the DB).
    Object.keys(pm).forEach(id=>{
      if(id in nm) return;
      let snap; try{ snap = JSON.parse(JSON.stringify(pm[id])); }catch{ snap=null; }
      if(!snap){ console.warn("Skipped delete of unreadable record",id); return; }
      fbSetP(`sq_trash/${kind}__${id}`, {kind, id, item:snap, deletedAt:new Date().toISOString(), deletedBy:who||""})
        .then(()=>fbSet(`${path}/${id}`, null))
        .catch(e=>{ console.warn("Recycle bin write failed — delete cancelled",e); alert("Could not move that record to the recycle bin, so it was NOT deleted. Reload the app to see it again."); });
    });
  };
  const writeCol = useCallback((key, path, setRaw, upd) => {
    if(firebaseOk && !synced.current[key]){
      alert("Still connecting to the database — please wait a few seconds and try again. Nothing was saved.");
      return false;
    }
    const prev = latest.current[key];
    const next = typeof upd==="function" ? upd(prev) : upd;
    if(next===prev) return true;
    latest.current[key] = next;
    setRaw(next);
    if(firebaseOk){
      persist(path, prev, next, key==="c" && seedOnly.current, key, user&&user.name);
      if(key==="c") seedOnly.current = false;
    }
    return true;
  },[firebaseOk, user]);

  const setCustomers = useCallback(upd=>{
    if(!user){ console.warn("Not authenticated"); return; }
    if(user.role !== "admin"){ console.warn("Unauthorized: admin only"); return; }
    return writeCol("c","sq_customers",setRawC,upd);
  },[user, writeCol]);

  // Reports — any authenticated user can write
  const setReports = useCallback(upd=>{
    if(!user){ console.warn("Not authenticated"); return; }
    return writeCol("r","sq_reports",setRawR,upd);
  },[user, writeCol]);

  // Small RO contracts — admin only
  const setSmallRO = useCallback(upd=>{
    if(!user){ console.warn("Not authenticated"); return; }
    if(user.role !== "admin"){ console.warn("Unauthorized: admin only"); return; }
    return writeCol("s","sq_small_ro",setRawSRO,upd);
  },[user, writeCol]);

  // Small RO visit reports — any authenticated user (technicians submit these)
  const setSmallROVisits = useCallback(upd=>{
    if(!user){ console.warn("Not authenticated"); return; }
    return writeCol("v","sq_small_ro_visits",setRawSROV,upd);
  },[user, writeCol]);

  // Finance (payment plans) — admin only, never visible to technicians
  const setFinance = useCallback(upd=>{
    if(!user || user.role!=="admin"){ console.warn("Unauthorized: admin only"); return; }
    return writeCol("f","sq_finance",setRawF,upd);
  },[user, writeCol]);

  // Add photos to an EXISTING report / visit report later. Writes only the "photos" field,
  // so any signed-in user can do it without being able to change the rest of the record.
  const setRecordPhotos = useCallback((key, id, photos) => {
    if(!user){ console.warn("Not authenticated"); return false; }
    if(firebaseOk && !synced.current[key]){ alert("Still connecting to the database — please wait a few seconds and try again. Nothing was saved."); return false; }
    const path = key==="r" ? "sq_reports" : "sq_small_ro_visits";
    const setRaw = key==="r" ? setRawR : setRawSROV;
    if(!latest.current[key].some(x=>x.id===id)) return false;
    const next = latest.current[key].map(x=>x.id===id?{...x,photos}:x);
    latest.current[key] = next; setRaw(next);
    if(firebaseOk) fbSet(`${path}/${id}/photos`, photos);
    return true;
  },[firebaseOk, user]);

  // A technician logging a visit may update ONE field on a contract (lastVisitDate)
  // even though contract editing is admin-only.
  const touchSmallROVisitDate = useCallback((contractId, date) => {
    if(!user){ console.warn("Not authenticated"); return; }
    if(firebaseOk && !synced.current.s) return;
    if(!latest.current.s.some(c=>c.id===contractId)) return;
    const next = latest.current.s.map(c=>c.id===contractId ? {...c, lastVisitDate: date||""} : c);
    latest.current.s = next;
    setRawSRO(next);
    if(firebaseOk){ fbSet(`sq_small_ro/${contractId}/lastVisitDate`, date||""); }
  },[firebaseOk, user]);

  // ── 4f. Backup (with reminder bookkeeping) ───────────────────────────────
  const markBackup = useCallback(()=>{
    const iso=new Date().toISOString();
    setLastBackupAt(iso); local.set("sq_last_backup", iso);
    if(firebaseOk && user) fbSet(`sq_prefs/${user.uid}/lastBackupAt`, iso);
  },[firebaseOk, user]);
  const doBackup = ()=>{
    backupAllData({customers, reports, smallRO, smallROVisits, finance});
    markBackup();
  };

  // ── 4g. Recycle bin actions (admin) ───────────────────────────────────────
  const restoreFromTrash = e => {
    const setter = {c:setCustomers, r:setReports, s:setSmallRO, v:setSmallROVisits, f:setFinance}[e.kind];
    if(!setter || !e.item) return;
    const ok = setter(prev=> prev.some(x=>x.id===e.item.id) ? prev : [...prev, e.item]);
    if(ok===false) return;                                  // not saved (still connecting) — keep it in the bin
    fbSet(`sq_trash/${e.kind}__${e.id}`, null);
    if(e.kind==="v"){                                       // refresh the contract's last-visit date
      const ds=latest.current.v.filter(v=>v.contractId===e.item.contractId).map(v=>v.date).filter(Boolean).sort();
      touchSmallROVisitDate(e.item.contractId, ds.length?ds[ds.length-1]:"");
    }
    alert("Restored: "+trashLabel(e));
  };
  const purgeTrashEntry = e => {
    if(!window.confirm(`Permanently delete "${trashLabel(e)}"? This cannot be undone.`)) return;
    fbSet(`sq_trash/${e.kind}__${e.id}`, null);
  };

  // ── 4e. toggleTheme — flips light/dark, persists locally (instant) + to
  // Firebase under the signed-in user's own uid (cross-device, per-user)
  const toggleTheme = useCallback(() => {
    setTheme(prev=>{
      const next = prev==="light" ? "dark" : "light";
      applyTheme(next);
      injectCSS();
      local.set("sq_theme", next);
      if(firebaseOk && user){ fbSet(`sq_prefs/${user.uid}/theme`, next); }
      return next;
    });
  },[firebaseOk, user]);

  // ── 5. Logout via Firebase Auth ───────────────────────────────────────────
  const logout = async () => {
    await fbSignOut();
    setUser(null);
    setTab("home");
  };

  const alertCount = customers.filter(c=>{ if(!isAMC(c)) return false; const d=daysUntil(c.amcEnd); return d!==null&&d<=30; }).length;
  const payAlert   = user&&user.role==="admin" ? overduePayments(finance) : {count:0,gross:0};   // overdue installments (admin only)

  const TABS=[
    {id:"home",     label:"Home",    I:Ic.Home},
    {id:"customers",label:"Plants",  I:Ic.Plants},
    {id:"smallro",  label:"Small RO",I:Ic.Droplet},
    {id:"route",    label:"Route",   I:Ic.Route},
    {id:"reports",  label:"Reports", I:Ic.Reports},
    ...(user&&user.role==="admin"?[{id:"finance",label:"Finance",I:Ic.Money}]:[]),
    {id:"settings", label:"Settings",I:Ic.Settings},
  ];

  // ── Screens ───────────────────────────────────────────────────────────────

  // Waiting for Firebase to check existing session (handles refresh)
  if(!authReady){
    return(
      <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:`linear-gradient(135deg,${T.navy},${T.mid})`,flexDirection:"column",gap:20}}>
        <Logo size={32}/>
        <div style={{color:"rgba(255,255,255,0.38)",fontSize:11,letterSpacing:3}}>CHECKING SESSION…</div>
      </div>
    );
  }

  // Not logged in
  if(!user){
    return <Login onLogin={()=>{}} firebaseOk={firebaseOk}/>;
  }

  // Loading data
  if(dataLoading){
    return(
      <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:`linear-gradient(135deg,${T.navy},${T.mid})`,flexDirection:"column",gap:20}}>
        <Logo size={32}/>
        <div style={{color:"rgba(255,255,255,0.38)",fontSize:11,letterSpacing:3}}>LOADING DATA…</div>
      </div>
    );
  }

  const pp = {customers, reports, user, firebaseOk};

  return(
    <div className="shell">
      {/* Top bar */}
      <div className="tbar">
        <Logo size={22}/>
        <div style={{display:"flex",alignItems:"center",gap:11}}>
          <button onClick={toggleTheme} title={theme==="light"?"Switch to dark theme":"Switch to light theme"}
            style={{background:"rgba(255,255,255,0.12)",border:"none",borderRadius:8,width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",cursor:"pointer",padding:0}}>
            {theme==="light" ? <Ic.Moon/> : <Ic.Sun/>}
          </button>
          {(alertCount+payAlert.count)>0&&(
            <div style={{position:"relative",cursor:"pointer",color:T.warn,display:"flex"}} onClick={()=>setTab(alertCount>0?"settings":"finance")}>
              <Ic.Bell/>
              <span style={{position:"absolute",top:-5,right:-5,background:T.danger,color:"#fff",borderRadius:10,fontSize:9,padding:"1px 5px",fontWeight:800,lineHeight:1.5}}>{alertCount+payAlert.count}</span>
            </div>
          )}
          <div style={{display:"flex",alignItems:"center",gap:7}}>
            <span className="dot-live"/>
            <div style={{width:30,height:30,borderRadius:"50%",background:`linear-gradient(135deg,${T.mid},${T.bright})`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:700,color:"#fff"}}>
              {user.name.charAt(0)}
            </div>
          </div>
        </div>
      </div>

      {/* Body: sidebar + main */}
      <div style={{display:"flex",flex:1,overflow:"hidden"}}>
        <aside className="sidebar" id="sidebar" style={{flexDirection:"column"}}>
          <div style={{fontSize:9,color:T.muted,fontWeight:700,letterSpacing:2,padding:"10px 13px 5px",textTransform:"uppercase"}}>Navigation</div>
          {TABS.map(t=>(
            <button key={t.id} className={`sitem ${tab===t.id?"on":""}`} onClick={()=>setTab(t.id)}>
              <t.I/> {t.label}
              {t.id==="finance"&&payAlert.count>0&&(
                <span style={{marginLeft:"auto",width:17,height:17,borderRadius:"50%",background:T.danger,color:"#fff",fontSize:9,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800}}>{payAlert.count}</span>
              )}
              {t.id==="settings"&&alertCount>0&&(
                <span style={{marginLeft:"auto",width:17,height:17,borderRadius:"50%",background:T.danger,color:"#fff",fontSize:9,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800}}>{alertCount}</span>
              )}
            </button>
          ))}
          <div style={{marginTop:"auto",paddingTop:14,borderTop:`1px solid ${T.border}`}}>
            <div style={{fontSize:12,color:"#fff",fontWeight:600,padding:"0 13px 2px"}}>{user.name}</div>
            <div style={{fontSize:10,color:T.muted,padding:"0 13px 4px"}}>{user.email}</div>
            <div style={{fontSize:10,color:T.muted,padding:"0 13px 10px"}}>Role: {user.role}</div>
            <button className="btn-soft" style={{width:"100%",justifyContent:"center",fontSize:12,padding:"8px"}} onClick={logout}>
              <Ic.Out/> Sign Out
            </button>
          </div>
        </aside>

        <main style={{flex:1,overflowY:"auto",minWidth:0}}>
          {user.role==="admin"&&!dataLoading&&!bannerHidden&&(!lastBackupAt||(Date.now()-new Date(lastBackupAt).getTime())>7*86400000)&&(
            <div style={{margin:"12px 20px 0",padding:"10px 12px",borderRadius:10,background:T.warn+"1f",border:`1px solid ${T.warn}55`,display:"flex",gap:10,alignItems:"center",flexWrap:"wrap"}}>
              <div style={{flex:1,minWidth:180,fontSize:13,color:T.heading,fontWeight:600}}>
                💾 {lastBackupAt?`Your last backup was ${Math.floor((Date.now()-new Date(lastBackupAt).getTime())/86400000)} days ago.`:"You haven't made a backup yet."} Back up now to keep your data safe.
              </div>
              <button className="btn-p" style={{padding:"6px 12px",fontSize:12}} onClick={doBackup}><Ic.Save/> Back up now</button>
              <button className="btn-soft" style={{padding:"6px 10px",fontSize:12}} onClick={()=>setBannerHidden(true)}>Later</button>
            </div>
          )}
          {tab==="home"      && <Dashboard  {...pp} onTab={setTab} payAlert={payAlert}/>}
          {tab==="customers" && <Customers  {...pp} setCustomers={setCustomers}/>}
          {tab==="smallro"   && <SmallRO    customers={smallRO} setCustomers={setSmallRO} visits={smallROVisits} setVisits={setSmallROVisits} setVisitPhotos={(id,p)=>setRecordPhotos("v",id,p)} touchVisit={touchSmallROVisitDate} user={user}/>}
          {tab==="finance"   && user.role==="admin" && <Finance plans={finance} setPlans={setFinance} plants={customers} smallRO={smallRO}/>}
          {tab==="route"     && <Route      customers={customers} setCustomers={setCustomers} user={user} reports={reports}/>}
          {tab==="reports"   && <Reports    {...pp} setReports={setReports} setPhotos={(id,p)=>setRecordPhotos("r",id,p)}/>}
          {tab==="settings"  && <Settings   {...pp} smallRO={smallRO} smallROVisits={smallROVisits} theme={theme} toggleTheme={toggleTheme} setCustomers={setCustomers} setReports={setReports} setSmallRO={setSmallRO} setSmallROVisits={setSmallROVisits} setFinance={setFinance} trash={trash} lastBackupAt={lastBackupAt} onBackup={doBackup} onRestoreTrash={restoreFromTrash} onPurgeTrash={purgeTrashEntry} onLogout={logout}/>}
        </main>
      </div>

      {/* Bottom nav — mobile only */}
      <nav className={TABS.length>6?"bnav many":"bnav"}>
        {TABS.map(t=>(
          <button key={t.id} className={`nb ${tab===t.id?"on":""}`} onClick={()=>setTab(t.id)}>
            <t.I/>{t.label}
            {t.id==="settings"&&alertCount>0&&(
              <span style={{position:"absolute",top:8,right:"calc(50% - 15px)",width:6,height:6,borderRadius:"50%",background:T.danger}}/>
            )}
            {t.id==="finance"&&payAlert.count>0&&(
              <span style={{position:"absolute",top:6,right:"calc(50% - 18px)",minWidth:15,height:15,padding:"0 4px",borderRadius:8,background:T.danger,color:"#fff",fontSize:9,fontWeight:800,display:"flex",alignItems:"center",justifyContent:"center"}}>{payAlert.count}</span>
            )}
          </button>
        ))}
      </nav>

      <style>{`@media(min-width:768px){#sidebar{display:flex!important}}`}</style>
    </div>
  );
}
